webpackJsonp([1],{

/***/ "+0T7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Adjust Balance")])],1),_vm._v(" "),_c('v-card-title',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Amount")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Amount","value":"10.00","type":"number","prefix":"$"},model:{value:(_vm.user.amount),callback:function ($$v) {_vm.$set(_vm.user, "amount", $$v)},expression:"user.amount"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Description")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{attrs:{"name":"input-1","label":"Label Text","textarea":""},model:{value:(_vm.user.description),callback:function ($$v) {_vm.$set(_vm.user, "description", $$v)},expression:"user.description"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":_vm.disableButton ? true : _vm.user.amount ? _vm.user.description ? false : true : true,"color":"warning"},on:{"click":function($event){$event.preventDefault();_vm.adjustBallance($event)}}},[_vm._v("Adjust")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":_vm.alert.type === 'error' ? 'error' : 'check_circle',"value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n          "+_vm._s(_vm.alert.message)+"\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+lt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":_vm.color}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),(!_vm.isAgencyDeleted)?_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Agency Details")]):_c('v-toolbar-title',{staticClass:"white--text",attrs:{"color":"red"}},[_vm._v("Agency has been deleted")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isAgencyDeleted)?_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":function($event){_vm.editAgency(_vm.agencyData)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e()],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-media',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":"150px","tile":false}},[_c('img',{attrs:{"src":_vm.agencyData.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-card-title',{staticClass:"black--text"},[_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.agencyData.company)+"  ")])]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("fingerprint")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("ID "+_vm._s(_vm.agencyData.id))])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("work")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyType))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Agency Type")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("account_box")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.first_name)+" "+_vm._s(_vm.agencyData.last_name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Contact person")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Email")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.city))]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.address))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.agencyData.country)+" "+_vm._s(_vm.agencyData.zip_code))])],1)],1),_vm._v(" "),(_vm.agencyData.phone)?_c('span',[_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.phone))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Phone")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("$ "+_vm._s(_vm.agencyData.balance))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Current Balance")]),_vm._v(" "),(!_vm.isAgencyDeleted)?_c('v-btn',{attrs:{"color":_vm.color,"dark":"","small":"","absolute":"","right":"","fab":""},on:{"click":_vm.adjustBalance}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n        "+_vm._s(_vm.alert.message)+"\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+oNi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      pagination: {},
      dateFrom: null,
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      search: '',
      agencies: [{ company: 'All', id: null }],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [{ name: 'All', value: null }, { name: 'Booked', value: 'false' }, { name: 'Cancelled', value: 'true' }],
      accountTypeSelected: null,
      accountType: [{ account: 'All', accountValue: null }, { account: 'Agency', accountValue: 'agency' }, { account: 'Provider', accountValue: 'provider' }],
      searchQuery: '',
      headers: [{
        text: "No.",
        align: "center",
        sortable: false,
        value: "id"
      }, {
        text: "Account Type",
        value: "accountType",
        sortable: false,
        align: "cetner"
      }, {
        text: "Agency",
        value: "agency",
        sortable: false,
        align: "center"
      }, {
        text: "Insurance Policies Sold",
        value: "soldPolicies",
        sortable: false,
        align: "center"
      }, {
        text: "Total",
        value: "total",
        sortable: false,
        align: "center"
      }],
      items: []
    };
  },

  filters: {
    isProvider: function isProvider(value) {
      if (value == 0) {
        value = "Agency";
      } else {
        value = "Provider";
      }
      return value;
    },
    minusRemover: function minusRemover(string) {
      return string.replace('-', '');
    }
  },
  methods: {
    getSummary: function getSummary() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/reports/summary").then(function (response) {
        _this.items = response.data.reports;
        _this.loading = false;
      });
    },
    getAgencies: function getAgencies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (res) {
        for (var user in res.data.users) {
          if (res.data.users[user].is_disabled !== '1') {
            _this2.agencies.push(res.data.users[user]);
          }
        }
      });
    },
    goToPolicy: function goToPolicy(id) {
      this.$router.push({ path: "/admin/policies/show/" + id });
    },
    buildQuery: function buildQuery() {
      this.searchQuery = '';
      if (this.accountTypeSelected) {
        this.searchQuery += 'account_type=' + this.accountTypeSelected + '&';
      }
      if (this.selectedAgency) {
        this.searchQuery += 'agency=' + this.selectedAgency + "&";
      }
      if (this.typeSelected) {
        this.searchQuery += 'cancelled=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery += 'date_from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery += 'date_to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter: function searchFilter() {
      var _this3 = this;

      this.loading = true;
      this.items = {};
      this.buildQuery();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/reports/summary?" + this.searchQuery).then(function (response) {
        _this3.items = response.data.reports;
        _this3.loading = false;
      });
    }
  },
  created: function created() {
    this.getAgencies();
    this.getSummary();
  }
});

/***/ }),

/***/ "+ra9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sales_vue__ = __webpack_require__("/K0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5bd0cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sales_vue__ = __webpack_require__("g+nL");
function injectStyle (ssrContext) {
  __webpack_require__("8FOj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c5bd0cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c5bd0cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/7cw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__("097D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_countryCodes_js__ = __webpack_require__("mbGk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha___default.a },
  data: function data() {
    var _this = this;

    return {
      e1: 1,
      alert: {
        status: false,
        message: null,
        type: null
      },
      validAcc: true,
      validDetails: true,
      validLocation: true,
      rules: {
        fieldRules: [function (v) {
          return !!v || "Field is required";
        }],
        phoneValidation: [function (v) {
          return !!v || "Phone is required";
        }, function (v) {
          return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
          );
        }],
        passwordRules: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v.length >= 8 || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v == _this.user.password || "Password not confirmed";
        }],
        emailRules: [function (v) {
          return !!v || "E-mail is required";
        }, function (v) {
          return (/\S+@\S+\.\S+/.test(v) || "E-mail must be valid"
          );
        }]
      },
      visibility: true,
      visibilityConfirm: true,
      recaptchaValid: false,
      sitekey: "6LcO6ToUAAAAAOF_CfUjFI62e4z4K3UnTWcWCzW9",
      captchaError: false,
      user: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        confirm_password: "",
        countr: "",
        city: "",
        address: "",
        zip_code: "",
        company: "",
        logo_url: "",
        phone: "",
        website: ""
      },
      states: __WEBPACK_IMPORTED_MODULE_2__helpers_countryCodes_js__["a" /* countryCodesSingle */]
    };
  },

  methods: {
    alerting: function alerting() {
      var _this2 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this2.alert.status = !_this2.alert.status;
      }, 2500);
    },
    submit: function submit() {
      if (this.$refs.form.validate()) {
        this.e1++;
      }
    },
    passwordChecker: function passwordChecker() {
      if (user.password !== user.passwordChecker) {}
    },
    register: function register() {
      var _this3 = this;

      if (this.recaptchaValid) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/register", { user: this.user }).then(function (response) {
          _this3.alert.message = 'You have registered successfully.';
          _this3.alert.type = 'success';
          _this3.alerting();
          setTimeout(function () {
            _this3.$router.push('/auth/login');
          }, 2000);
        }).catch(function (err) {
          _this3.alert.message = 'There was an issue with your registration.';
          _this3.alert.type = 'error';
          _this3.alerting();
        });
      } else {
        this.alert.type = 'error';
        this.alert.message = 'Please, validate your registration.';
        this.alerting();
      }
    },

    onVerify: function onVerify(response) {
      this.recaptchaValid = true;
    },
    onExpired: function onExpired() {
      this.recaptchaValid = false;
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ "/K0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      search: "",
      pagination: {},
      counter: 0,
      dateFrom: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      sum: null,
      agencies: [{ company: 'All', id: null }],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [{ name: 'All', value: null }, { name: 'Booked', value: 'false' }, { name: 'Cancelled', value: 'true' }],
      countrySelected: null,
      country: [{ country: 'All', countryValue: null }, { country: 'Turkey', countryValue: 'turkey' }, { country: 'Other', countryValue: 'other' }],
      accountTypeSelected: null,
      accountType: [{ account: 'All', accountValue: null }, { account: 'Agency', accountValue: 'agency' }, { account: 'Provider', accountValue: 'provider' }],
      searchQuery: '',
      headers: [{
        text: "No.",
        align: "center",
        sortable: false,
        value: "id"
      }, { text: "Account Type", value: "accountType", sortable: false, align: "cetner" }, {
        text: "Agency",
        value: "agency",
        sortable: false,
        align: "center"
      }, { text: "Date", value: "date", sortable: false, align: "center" }, {
        text: "Type of Insurance",
        value: "insuranceType",
        sortable: false,
        align: "center"
      }, {
        text: "Policy UUID",
        value: "policy_uuid",
        sortable: false,
        align: "center"
      }, {
        text: "No. people",
        value: "people_count",
        sortable: false,
        align: "center"
      }, {
        text: "Status",
        value: "status",
        sortable: false,
        align: "center"
      }, {
        text: "Total",
        value: "total",
        sortable: false,
        align: "center"
      }, {
        text: "Beneficiary",
        value: "user",
        sortable: false,
        align: "center"
      }],
      items: []
    };
  },

  filters: {
    isProvider: function isProvider(value) {
      if (value == '0') {
        value = "Agency";
      } else {
        value = "Provider";
      }
      return value;
    },
    status: function status(value) {
      if (value == '0') {
        value = "Booked";
      } else {
        value = "Cancelled";
      }
      return value;
    },
    minusRemover: function minusRemover(value) {
      return value.replace('-', '');
    },
    removeTime: function removeTime(value) {
      return value.substring(0, value.length - 9);
    }
  },
  methods: {
    calculated: function calculated() {
      var summary = 0;
      for (var key in this.items) {
        var a = Math.abs(this.items[key].amount);
        summary += a;
      }
      this.sum = summary;
    },
    getAgencies: function getAgencies() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (res) {
        for (var user in res.data.users) {
          _this.agencies.push(res.data.users[user]);
        }
      });
    },
    goToPolicy: function goToPolicy(id) {
      this.$router.push({ path: "/admin/policies/show/" + id });
    },
    buildQuery: function buildQuery() {
      this.searchQuery = '';
      if (this.selectedAgency) {
        this.searchQuery += 'agency=' + this.selectedAgency + "&";
      }
      if (this.countrySelected) {
        this.searchQuery += 'country=' + this.countrySelected + "&";
      }
      if (this.accountTypeSelected) {
        this.searchQuery += 'account_type=' + this.accountTypeSelected + "&";
      }
      if (this.typeSelected) {
        this.searchQuery += 'cancelled=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery += 'date_from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery += 'date_to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter: function searchFilter() {
      var _this2 = this;

      this.loading = true;
      this.items = [];
      this.buildQuery();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/reports/sales?" + this.searchQuery).then(function (response) {
        response.data.reports.forEach(function (element) {
          if (element.tx_type === "SALE" && element.cancelled == "1") {
            return false;
          } else {
            _this2.items.push(element);
          }
        });
        _this2.loading = false;
        _this2.calculated();
      });
    }
  },
  created: function created() {
    this.searchFilter();
    this.getAgencies();
  }
});

/***/ }),

/***/ "/vzY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("GDDW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b85d80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("1Bnv");
function injectStyle (ssrContext) {
  __webpack_require__("YE/9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51b85d80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0nzY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__ = __webpack_require__("ggn8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7450c420_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__("bMfB");
function injectStyle (ssrContext) {
  __webpack_require__("z0xp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7450c420"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Auth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7450c420_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "14Ez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":""}},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("New Policy - Turkey")])],1),_vm._v(" "),_c('div',[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("New Policy")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v(" Insurance Plan")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.e1 > 3}},[_vm._v("Travel Details")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4","complete":_vm.e1 > 4}},[_vm._v("Quotation")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"5","complete":_vm.e1 > 5}},[_vm._v("Beneficiary Details")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"6"}},[_vm._v("Confirmation")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-form',{ref:"newpolicy",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Beneficiary Type:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"rules":_vm.inputRules},model:{value:(_vm.policy.insurance_type),callback:function ($$v) {_vm.$set(_vm.policy, "insurance_type", $$v)},expression:"policy.insurance_type"}},[_c('v-radio',{attrs:{"label":"Single","value":"Single","name":"beneficiary"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Family","value":"Family","name":"beneficaryType"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Group","value":"Group","name":"beneficaryType"}})],1)],1)],1),_vm._v(" "),(_vm.policy.insurance_type === 'Family')?_c('div',{attrs:{"row":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Parents:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.policy.insurance_type === 'Family' } }),expression:"{ rules: { required: policy.insurance_type === 'Family' } }"}],attrs:{"prepend-icon":_vm.policy.total_parents === 1 ? 'person' : 'people',"items":_vm.inputParents,"label":"Select","single-line":"","item-value":"number","data-vv-name":"parents","rules":[function (v) { return !!v || 'Please, select a proper value.'; }],"mandatory":true,"bottom":"","required":""},model:{value:(_vm.policy.total_parents),callback:function ($$v) {_vm.$set(_vm.policy, "total_parents", $$v)},expression:"policy.total_parents"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Kids:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.policy.insurance_type === 'Family' } }),expression:"{ rules: { required: policy.insurance_type === 'Family' } }"}],attrs:{"prepend-icon":"face","label":"Number of kids","data-vv-name":"number of kids","rules":[function (v) { return !!_vm.policy.total_parents || 'Please, enter a number of kids.'; }],"required":""},model:{value:(_vm.policy.total_children),callback:function ($$v) {_vm.$set(_vm.policy, "total_children", _vm._n($$v))},expression:"policy.total_children"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.policy.insurance_type === 'Group')?_c('div',{attrs:{"row":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Number of people:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.policy.insurance_type === 'Group' } }),expression:"{ rules: { required: policy.insurance_type === 'Group' } }"}],attrs:{"prepend-icon":"group_add","label":"People","data-vv-name":"Input people","rules":[function (v) { return (!!v && v>1) || 'Please, enter a number of people. Must be greater than 1.'; }],"required":""},model:{value:(_vm.policy.total_persons),callback:function ($$v) {_vm.$set(_vm.policy, "total_persons", _vm._n($$v))},expression:"policy.total_persons"}})],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.addToPersons(); _vm.validateNewPolicy(); _vm.checkToken();}}},[_vm._v("Continue")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-form',{ref:"insuranceplan",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('span',[_vm._v("Insurance Plan")]),_vm._v(" "),_c('span',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-select',{attrs:{"prepend-icon":"assignment","items":_vm.insurancePlans,"item-text":"name","item-value":"id","label":"Select insurance plan","max-height":"","multi-line":"","disabled":"","rules":[function (v) { return !!v || 'Please, select a plan.'; }],"bottom":"","required":""},model:{value:(_vm.policy.insurance_plan_id),callback:function ($$v) {_vm.$set(_vm.policy, "insurance_plan_id", $$v)},expression:"policy.insurance_plan_id"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.policy.persons),function(person,key){return _c('span',{key:person,staticClass:"mt-3"},[(key === 0)?_c('span',[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.policy.total_parents > 1 && key == 1)?_c('span',[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 1 && key !== 0))?_c('span',[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 2 && key !== 0 && key !== 1))?_c('span',[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.policy.total_children && !_vm.policy.total_parents && key != 0)?_c('span',[_vm._v(" User "+_vm._s(key))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.policy.persons[key].menu),callback:function ($$v) {_vm.$set(_vm.policy.persons[key], "menu", $$v)},expression:"policy.persons[key].menu"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-icon":"date_range","label":"Date of birth","rules":[function (v) { return !!v || 'Please, select a date of birth.'; }],"readonly":"","required":""},slot:"activator",model:{value:(person['date_of_birth']),callback:function ($$v) {_vm.$set(person, 'date_of_birth', $$v)},expression:"person['date_of_birth']"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","disabled":"","allowed-dates":_vm.years},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(person['date_of_birth']),callback:function ($$v) {_vm.$set(person, 'date_of_birth', $$v)},expression:"person['date_of_birth']"}})],1)],1)],1)],1)})],2)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.validateInsurancePlan(); _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-form',{ref:"traveldetails",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',[_vm._v("Residence:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"prepend-icon":"flag","items":_vm.states,"label":"Country","rules":[function (v) { return !!v || 'Please, select a country of residence.'; }],"autocomplete":"","bottom":"","required":""},model:{value:(_vm.policy.country_residence),callback:function ($$v) {_vm.$set(_vm.policy, "country_residence", $$v)},expression:"policy.country_residence"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',[_vm._v("Destination:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{staticClass:"input-group",attrs:{"prepend-icon":"map","items":_vm.policy.country_destination,"label":"Country","rules":[function (v) { return !!v || 'Please, select a country of destination.'; }],"disabled":"","autocomplete":"","required":""},model:{value:(_vm.policy.country_destination),callback:function ($$v) {_vm.$set(_vm.policy, "country_destination", $$v)},expression:"policy.country_destination"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Duration:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.policy.duration_fromMenu),callback:function ($$v) {_vm.$set(_vm.policy, "duration_fromMenu", $$v)},expression:"policy.duration_fromMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From","prepend-icon":"event","rules":[function (v) { return !!v || 'Please, select a date.'; }],"readonly":""},slot:"activator",model:{value:(_vm.policy.duration_from),callback:function ($$v) {_vm.$set(_vm.policy, "duration_from", $$v)},expression:"policy.duration_from"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","disabled":"","allowed-dates":_vm.durationFrom},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.policy.duration_from),callback:function ($$v) {_vm.$set(_vm.policy, "duration_from", $$v)},expression:"policy.duration_from"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.policy.duration_toMenu),callback:function ($$v) {_vm.$set(_vm.policy, "duration_toMenu", $$v)},expression:"policy.duration_toMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To","prepend-icon":"event","rules":[function (v) { return !!v || 'Please, select a date.'; }],"readonly":""},slot:"activator",model:{value:(_vm.policy.duration_to),callback:function ($$v) {_vm.$set(_vm.policy, "duration_to", $$v)},expression:"policy.duration_to"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","disabled":"","allowed-dates":_vm.durationFrom},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.policy.duration_to),callback:function ($$v) {_vm.$set(_vm.policy, "duration_to", $$v)},expression:"policy.duration_to"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.quoteCalculator(); _vm.validateTraveDetails(); _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Quotation")])],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Plan")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.getPlanName))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Insurance Type")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.insurance_type))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of residence")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_residence))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of destination")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_destination))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date from")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_from))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date to")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_to))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Duration")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.duration)+" days")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Price")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("$ "+_vm._s(_vm.policy.amount))])],1)],1)],1),_vm._v(" "),_c('v-divider')],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.e1++; _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_vm._l((_vm.policy.persons),function(person,key){return _c('span',{key:key},[_c('v-layout',{attrs:{"mt-3":""}},[_c('v-flex',[(key === 0)?_c('span',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.policy.total_parents > 1 && key == 1)?_c('span',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 1 && key !== 0))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 2 && key !== 0 && key !== 1))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.policy.total_children && !_vm.policy.total_parents && key != 0)?_c('span',{staticClass:"headline"},[_vm._v(" User "+_vm._s(key))]):_vm._e()])],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"First Name","rules":_vm.inputRules,"required":""},model:{value:(person.first_name),callback:function ($$v) {_vm.$set(person, "first_name", $$v)},expression:"person.first_name"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Middle Name","rules":_vm.inputRules,"required":""},model:{value:(person.middle_name),callback:function ($$v) {_vm.$set(person, "middle_name", $$v)},expression:"person.middle_name"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Last Name","rules":_vm.inputRules,"required":""},model:{value:(person.last_name),callback:function ($$v) {_vm.$set(person, "last_name", $$v)},expression:"person.last_name"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"prepend-icon":"picture_in_picture","label":"Passport Number","rules":_vm.inputRules,"required":""},model:{value:(person.passport_number),callback:function ($$v) {_vm.$set(person, "passport_number", $$v)},expression:"person.passport_number"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',[_c('span',{attrs:{"prepend-icon":"email"}},[_vm._v("Gender:")])]),_vm._v(" "),_c('v-flex',[_c('span',[_c('v-radio-group',{attrs:{"rules":[function (v) { return !!v || 'Please, select a gender.'; }],"mandatory":true,"row":""},model:{value:(person.gender),callback:function ($$v) {_vm.$set(person, "gender", $$v)},expression:"person.gender"}},[_c('v-radio',{attrs:{"label":"Male","value":"M"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":"F"}})],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',[_c('v-flex',[_c('span',[_vm._v("Do you have any pre-existing medical condition?")])]),_vm._v(" "),_c('v-flex',{attrs:{"mt-2":""}},[_c('v-switch',{attrs:{"label":person.has_existing_medical_condition ? 'Yes' : 'No',"value":""},model:{value:(person.has_existing_medical_condition),callback:function ($$v) {_vm.$set(person, "has_existing_medical_condition", $$v)},expression:"person.has_existing_medical_condition"}})],1),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-flex',[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Please explain your condition","textarea":"","rules":[function (v) { return !!v || 'This field is required.'; }]},model:{value:(person.existing_medical_condition),callback:function ($$v) {_vm.$set(person, "existing_medical_condition", $$v)},expression:"person.existing_medical_condition"}})],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',[_c('v-flex',[_c('span',[_vm._v("Medical coverage with an insurance company in "+_vm._s(_vm.policy.country_residence)+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"mt-2":""}},[_c('v-switch',{attrs:{"label":person.has_medical_insurance_in_country_of_residence ? 'Yes' : 'No',"value":""},model:{value:(person.has_medical_insurance_in_country_of_residence),callback:function ($$v) {_vm.$set(person, "has_medical_insurance_in_country_of_residence", $$v)},expression:"person.has_medical_insurance_in_country_of_residence"}})],1),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-flex',[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Please state name and expire date","textarea":"","rules":[function (v) { return !!v || 'This field is required.'; }]},model:{value:(person.medical_insurance_in_country_of_residence),callback:function ($$v) {_vm.$set(person, "medical_insurance_in_country_of_residence", $$v)},expression:"person.medical_insurance_in_country_of_residence"}})],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":""}},[_c('v-flex',[_c('span',{staticClass:"headline"},[_vm._v("Contact info")])])],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"prepend-icon":"email","label":"Contact email","rules":_vm.emailRules,"required":""},model:{value:(_vm.policy.email),callback:function ($$v) {_vm.$set(_vm.policy, "email", $$v)},expression:"policy.email"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"prepend-icon":"phone","label":"Contact phone","rules":_vm.phoneValidation,"required":""},model:{value:(_vm.policy.phone),callback:function ($$v) {_vm.$set(_vm.policy, "phone", $$v)},expression:"policy.phone"}})],1)],2)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.validateLastForm(); _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"6"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Quotation")])],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Plan")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.getPlanName))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Insurance Type")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.insurance_type))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of residence")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_residence))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of destination")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_destination))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date from")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_from))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date to")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_to))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Duration")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.duration)+" days")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Price")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("$ "+_vm._s(_vm.policy.amount))])],1)],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_vm._l((_vm.policy.persons),function(person,key){return _c('v-card',{key:key},[_c('v-divider'),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[(key === 0)?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.policy.total_parents > 1 && key == 1)?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 1 && key !== 0))?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 2 && key !== 0 && key !== 1))?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.policy.total_children && !_vm.policy.total_parents && key != 0)?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" User "+_vm._s(key))]):_vm._e()],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("First Name")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.first_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Middle Name")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.middle_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Last Name")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.last_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Passport Number")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.passport_number))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date of birth")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.date_of_birth))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Gender")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.gender))])],1)],1),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-divider'):_vm._e(),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Pre Existing Medical Condition")])],1)],1):_vm._e(),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Explanation","textarea":"","readonly":""},model:{value:(person.existing_medical_condition),callback:function ($$v) {_vm.$set(person, "existing_medical_condition", $$v)},expression:"person.existing_medical_condition"}})],1)]):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-divider'):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Medical coverage with an insurance company in "+_vm._s(_vm.policy.country_residence))])],1)],1):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Explanation","textarea":"","readonly":""},model:{value:(person.medical_insurance_in_country_of_residence),callback:function ($$v) {_vm.$set(person, "medical_insurance_in_country_of_residence", $$v)},expression:"person.medical_insurance_in_country_of_residence"}})],1)]):_vm._e()],1)],1)})],2)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","disabled":_vm.disabledFinal},nativeOn:{"click":function($event){_vm.savePolicy($event)}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack($event)}}},[_vm._v("Back")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n        "+_vm._s(_vm.alert.message)+"\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Bnv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Account Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"warning"},nativeOn:{"click":function($event){_vm.editAgency(_vm.agencyData)}}},[_vm._v("Edit Password")])],1),_vm._v(" "),_c('v-card-media',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":"150px","tile":false}},[_c('img',{attrs:{"src":_vm.agencyData.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"text-xs-right"},[_vm._v("ID "+_vm._s(_vm.agencyData.id))])],1)],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"black--text"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.agencyData.company)+"  ")])]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("work")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyType))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Agency Type")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("account_box")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.first_name)+" "+_vm._s(_vm.agencyData.last_name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Contact person")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Email")])],1)],1),_vm._v(" "),(_vm.agencyData.city || _vm.agencyData.country || _vm.agencyData.zip_code)?_c('span',[_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.city))]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.address))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.agencyData.country)+" "+_vm._s(_vm.agencyData.zip_code))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.agencyData.phone)?_c('span',[_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.phone))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Phone")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("$ "+_vm._s(_vm.agencyData.balance))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Current Balance")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1HCu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1INv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__("mIhx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f54487_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__("JlHn");
function injectStyle (ssrContext) {
  __webpack_require__("Gxsl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-39f54487"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f54487_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1O+T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      drawer: true,
      dataLoading: true,
      defaultLogo: __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default.a,
      menuItems: [{ icon: 'supervisor_account', title: 'Admins', route: '/admin/admins' }, { icon: 'work', title: 'Agencies', route: '/admin/agencies' }, { icon: 'assignment', title: 'Insurance Policies', route: '/admin/policies' }, { icon: ' format_list_bulleted', title: 'Insurance Plans', route: '/admin/plans' }, { icon: 'content_copy', title: 'Transaction Reports', route: '/admin/transaction' }, { icon: 'assessment', title: 'Sales Reports', route: '/admin/sales' }, { icon: 'description', title: 'Summary Reports', route: '/admin/summary' }],
      meProps: {}
    };
  },
  props: {
    source: String
  },
  computed: {
    avatarSize: function avatarSize() {
      return '150px';
    }
  },
  methods: {
    toHomepage: function toHomepage() {
      location.href = '';
    },
    logout: function logout() {
      this.$auth.destroyToken();
      this.$router.push('/auth/login');
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/me').then(function (res) {
      _this.meProps = res.data;
      _this.dataLoading = false;
    });
  }
});

/***/ }),

/***/ "1iI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Adjust Balance")])],1),_vm._v(" "),_c('v-card-title',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Amount")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Amount","value":"10.00","type":"number","prefix":"$"},model:{value:(_vm.user.amount),callback:function ($$v) {_vm.$set(_vm.user, "amount", $$v)},expression:"user.amount"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Description")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{attrs:{"name":"input-1","label":"Label Text","textarea":""},model:{value:(_vm.user.description),callback:function ($$v) {_vm.$set(_vm.user, "description", $$v)},expression:"user.description"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":_vm.disableButton ? true : _vm.user.amount ? _vm.user.description ? false : true : true,"color":"warning"},on:{"click":function($event){$event.preventDefault();_vm.adjustBallance($event)}}},[_vm._v("Adjust")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":_vm.alert.type === 'error' ? 'error' : 'check_circle',"value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n          "+_vm._s(_vm.alert.message)+"\n        ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1iK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      search: '',
      dateFrom: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      pagination: {
        sortBy: 'created_at'
      },
      headers: [{ text: 'ID', value: 'uuid', sortable: false, align: 'center' }, { text: 'Created At', value: 'created_at', sortable: true, align: 'center' }, { text: 'Type', value: 'type', sortable: false, align: 'center' }, { text: 'Agency', value: 'agency', sortable: false, align: 'center' }, { text: 'Holder', value: 'holder', sortable: false, align: 'center' }, { text: 'Passport', value: 'passport', sortable: false, align: 'center' }, { text: 'People', value: 'total', sortable: false, align: 'center' }, { text: 'From', value: 'from', sortable: true, align: 'center' }, { text: 'To', value: 'to', sortable: false, align: 'center' }, { text: 'Canceled', value: 'canceled', sortable: false, align: 'center' }, { text: 'Total', value: 'total', sortable: false, align: 'center' }],
      agencies: [],
      searchQuery: '',
      items: []
    };
  },

  filters: {
    booleanify: function booleanify(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    },
    removeTime: function removeTime(value) {
      return value.substring(0, value.length - 9);
    }
  },
  methods: {
    buildQuery: function buildQuery() {
      var str = '?';
      if (this.dateFrom) {
        str += 'date_from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        str += 'date_to=' + this.dateTo + "&";
      }
      str = str.slice(0, -1);
      this.searchQuery = str;
    },
    searchFilter: function searchFilter() {
      var _this = this;

      this.loading = true;
      this.buildQuery();

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/policies" + this.searchQuery).then(function (response) {
        _this.items = response.data.policies;
        _this.loading = false;
        _this.pagination.descending = true;
        _this.items.forEach(function (element, index) {
          element.people.forEach(function (person, ind) {
            _this.items[index]['fullName' + ind] = person.first_name + ' ' + person.middle_name + ' ' + person.last_name;
            _this.items[index]['passport' + ind] = person.passport_number;
          });
        });
      }).catch(function (error) {
        // handle error
        this.loading = false;
      });
    },
    showPolicy: function showPolicy(item) {
      this.$router.push({ path: "/admin/policies/show/" + item.uuid });
    },
    agencyName: function agencyName(agency_id) {
      var companyName = '';
      this.agencies.forEach(function (element) {
        if (element.id == agency_id) {
          companyName = element.company;
        }
      });
      return companyName;
    }
  },
  created: function created() {
    var _this2 = this;

    this.searchFilter();
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (response) {
      _this2.agencies = response.data.users;
    });
  },

  computed: {}
});

/***/ }),

/***/ "1lqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlansEdit_vue__ = __webpack_require__("4u8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e50a800_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlansEdit_vue__ = __webpack_require__("9Fk0");
function injectStyle (ssrContext) {
  __webpack_require__("JjR9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e50a800"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlansEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e50a800_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlansEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2G1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":"","grid-list-xl":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-flex',{attrs:{"xs12":"","sm12":"","md10":"","lg5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Agency Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":function($event){_vm.editAgency(_vm.agencyData)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","flat":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirm your action")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete this agency?"),_c('br'),_vm._v("This action can not be reverted")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Disagree")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","dark":""},nativeOn:{"click":function($event){_vm.closeDialog(); _vm.deleteItem(_vm.agencyData.id)}}},[_vm._v("Delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-media',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":"150px","tile":false}},[_c('img',{attrs:{"src":_vm.agencyData.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-card-title',{staticClass:"black--text"},[_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.agencyData.company)+"  ")])]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fingerprint")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.id))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("ID")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("work")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyType))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Agency Type")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("account_box")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.first_name)+" "+_vm._s(_vm.agencyData.last_name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Contact person")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Email")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.city))]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.address))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.agencyData.country)+" "+_vm._s(_vm.agencyData.zip_code))])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.phone))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Phone")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("$ "+_vm._s(_vm.agencyData.balance))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Current Balance")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","small":"","absolute":"","right":"","fab":""},on:{"click":_vm.adjustBalance}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n      "+_vm._s(_vm.alert.message)+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2lq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_countryCodes_js__ = __webpack_require__("mbGk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      agency: {
        user: {
          approved: true
        }
      },
      e1: 0,
      e2: true,
      validAcc: true,
      validDetails: true,
      validLocation: true,
      alert: {
        status: false,
        message: null,
        type: null
      },
      rules: {
        fieldRules: [function (v) {
          return !!v || "Field is required";
        }],
        phoneValidation: [function (v) {
          return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
          );
        }],
        passwordRules: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v.length >= 8 || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v == _this.user.password || "Password not confirmed";
        }],
        emailRules: [function (v) {
          return !!v || "E-mail is required";
        }, function (v) {
          return (/\S+@\S+\.\S+/.test(v) || "E-mail must be valid"
          );
        }]
      },
      states: __WEBPACK_IMPORTED_MODULE_1__helpers_countryCodes_js__["a" /* countryCodesSingle */]
    };
  },

  methods: {
    alerting: function alerting() {
      var _this2 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this2.alert.status = !_this2.alert.status;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.push("/admin/agencies");
    },
    post: function post() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/users", this.agency).then(function (res) {
        _this3.alert.message = "You have registered successfully.";
        _this3.alert.type = "success";
        _this3.alerting();
        setTimeout(function () {
          _this3.$router.push("/admin/agencies");
        }, 2000);
      }).catch(function (err) {
        _this3.alert.message = "There was an issue with your registration.";
        _this3.alert.type = "error";
        _this3.alerting();
      });
    }
  }
});

/***/ }),

/***/ "3bWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      dataLoading: true,
      alert: {
        status: false,
        message: '',
        type: ''
      },
      defaultLogo: __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default.a,
      pagination: {},
      forApproval: [],
      hide_headers: true,
      headers: [{
        text: "Logo",
        align: "left",
        sortable: false,
        value: "name"
      }, {
        text: "Company",
        align: "left",
        sortable: false,
        value: "name"
      }, {
        text: "Email",
        align: "left",
        sortable: false,
        value: "email"
      }, {
        text: "Approved",
        align: "center",
        sortable: false,
        value: "approved"
      }],
      items: []
    };
  },

  filters: {
    booleanify: function booleanify(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    }
  },
  computed: {
    avatarSize: function avatarSize() {
      return "40px";
    }
  },
  methods: {
    alerting: function alerting() {
      var _this = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this.alert.status = !_this.alert.status;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.push("/admin/agencies");
    },
    approvingCounter: function approvingCounter() {
      var helperObj = this.items;
      this.forApproval = [];
      for (var k in helperObj) {
        if (helperObj[k].approved === '0') {
          this.forApproval.push(helperObj[k]);
        }
      }
    },
    approveUser: function approveUser(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/users/" + id, {
        user: {
          approved: "1"
        }
      }).then(function (res) {
        _this2.getAgencies();
        _this2.alert.message = 'Agency has been approved.';
        _this2.alert.type = 'success';
        _this2.alerting();
      });
    },
    getAgencies: function getAgencies() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (response) {
        _this3.items = response.data.users;
        _this3.approvingCounter();
        _this3.dataLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getAgencies();
  }
});

/***/ }),

/***/ "4u8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      dataLoading: true,
      alert: {
        status: false,
        message: '',
        type: ''
      },
      plan: {}
    };
  },

  mounted: function mounted() {
    this.getPlan();
  },
  methods: {
    alerting: function alerting() {
      var _this = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this.alert.status = !_this.alert.status;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.push("/admin/plans");
    },
    getPlan: function getPlan() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/insuranceplans/" + this.$route.params.id).then(function (res) {
        _this2.plan = res.data;
        _this2.dataLoading = false;
      });
    },
    post: function post() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/insuranceplans/" + this.$route.params.id, this.plan).then(function (res) {
        _this3.alert.message = 'Insurance plan has been updated.';
        _this3.alert.type = 'success';
        _this3.alerting();
      }).catch(function (err) {
        _this3.alert.message = 'Update has failed.';
        _this3.alert.type = 'error';
        _this3.alerting();
      });
    }
  }
});

/***/ }),

/***/ "5LHe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issued_vue__ = __webpack_require__("hulT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0f4826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Issued_vue__ = __webpack_require__("Np5C");
function injectStyle (ssrContext) {
  __webpack_require__("muFA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Issued_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f0f4826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Issued_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5fSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesEdit_vue__ = __webpack_require__("OXyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b764ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesEdit_vue__ = __webpack_require__("eL8q");
function injectStyle (ssrContext) {
  __webpack_require__("YMJ9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74b764ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74b764ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5jUa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesApprove_vue__ = __webpack_require__("3bWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2da4706_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesApprove_vue__ = __webpack_require__("KJ/n");
function injectStyle (ssrContext) {
  __webpack_require__("IYKe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d2da4706"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesApprove_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2da4706_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesApprove_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6BWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md7":"","lg5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Create Agency")])],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("Account Info")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v("Company Details")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v("Location")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-form',{ref:"form",model:{value:(_vm.validAcc),callback:function ($$v) {_vm.validAcc=$$v},expression:"validAcc"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"First Name","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.first_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "first_name", $$v)},expression:"agency.user.first_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Last Name","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.last_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "last_name", $$v)},expression:"agency.user.last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.rules.emailRules,"required":""},model:{value:(_vm.agency.user.email),callback:function ($$v) {_vm.$set(_vm.agency.user, "email", $$v)},expression:"agency.user.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Password","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text',"rules":_vm.rules.passwordRules,"counter":""},model:{value:(_vm.agency.user.password),callback:function ($$v) {_vm.$set(_vm.agency.user, "password", $$v)},expression:"agency.user.password"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validAcc},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Continue")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-form',{ref:"form",model:{value:(_vm.validDetails),callback:function ($$v) {_vm.validDetails=$$v},expression:"validDetails"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Company","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.company),callback:function ($$v) {_vm.$set(_vm.agency.user, "company", $$v)},expression:"agency.user.company"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Logo URL","required":""},model:{value:(_vm.agency.user.logo_url),callback:function ($$v) {_vm.$set(_vm.agency.user, "logo_url", $$v)},expression:"agency.user.logo_url"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Phone","rules":_vm.rules.phoneValidation,"required":""},model:{value:(_vm.agency.user.phone),callback:function ($$v) {_vm.$set(_vm.agency.user, "phone", $$v)},expression:"agency.user.phone"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Website","required":""},model:{value:(_vm.agency.user.website),callback:function ($$v) {_vm.$set(_vm.agency.user, "website", $$v)},expression:"agency.user.website"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validDetails},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Back")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-form',{ref:"form",model:{value:(_vm.validLocation),callback:function ($$v) {_vm.validLocation=$$v},expression:"validLocation"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-select',{attrs:{"items":_vm.states,"label":"Country","item-value":"text","rules":_vm.rules.fieldRules,"autocomplete":"","required":""},model:{value:(_vm.agency.user.country),callback:function ($$v) {_vm.$set(_vm.agency.user, "country", $$v)},expression:"agency.user.country"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"City","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.city),callback:function ($$v) {_vm.$set(_vm.agency.user, "city", $$v)},expression:"agency.user.city"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Address","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.address),callback:function ($$v) {_vm.$set(_vm.agency.user, "address", $$v)},expression:"agency.user.address"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Zip Code","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.zip_code),callback:function ($$v) {_vm.$set(_vm.agency.user, "zip_code", $$v)},expression:"agency.user.zip_code"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validLocation},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Create")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")])],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-alert',{staticClass:"auth",attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.alert.message)+"\n            ")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Cvj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6FBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md7":"","lg5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Update Password")])],1),_vm._v(" "),_c('v-form',{ref:"form",model:{value:(_vm.validPass),callback:function ($$v) {_vm.validPass=$$v},expression:"validPass"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"New Password","min":"8","rules":_vm.rules.passwordRules,"append-icon":_vm.visibility ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibility = !_vm.visibility); },"type":_vm.visibility ? 'password' : 'text',"counter":""},model:{value:(_vm.user.new_password),callback:function ($$v) {_vm.$set(_vm.user, "new_password", $$v)},expression:"user.new_password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Confirm New Password","min":"8","rules":_vm.rules.passwordRulesConfirm,"append-icon":_vm.visibilityConfirm ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibilityConfirm = !_vm.visibilityConfirm); },"type":_vm.visibilityConfirm ? 'password' : 'text',"counter":""},model:{value:(_vm.confirmNewPass),callback:function ($$v) {_vm.confirmNewPass=$$v},expression:"confirmNewPass"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Old password","min":"8","rules":_vm.rules.fieldRules,"append-icon":_vm.oldConfrim ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.oldConfrim = !_vm.oldConfrim); },"type":_vm.oldConfrim ? 'password' : 'text',"counter":""},model:{value:(_vm.user.old_password),callback:function ($$v) {_vm.$set(_vm.user, "old_password", $$v)},expression:"user.old_password"}}),_vm._v("\n                (we need your current password to confirm your changes)\n              ")],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"color":"warning","disabled":!_vm.validPass},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Update")])],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.alert.message)+"\n            ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6bET":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.dataLoading === true)?_c('spinner',{staticClass:"spinner-centered",attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-app',[_c('v-navigation-drawer',{attrs:{"persistent":"","enable-resize-watcher":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-card',{staticClass:"elevation-3"},[_c('v-card-media',[_c('v-container',{attrs:{"fluid":"","fill-height":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":_vm.avatarSize}},[_c('img',{attrs:{"src":_vm.meProps.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("account_box")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.meProps.first_name)+" "+_vm._s(_vm.meProps.last_name))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("work")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.meProps.company))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.meProps.email))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("$ "+_vm._s(_vm.meProps.balance))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fingerprint")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("ID "+_vm._s(_vm.meProps.id))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-list',[_vm._l((_vm.items),function(item){return _c('v-list-group',{key:item.title,attrs:{"value":item.active}},[_c('v-list-tile',{attrs:{"slot":"item"},slot:"item"},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.action))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_down")])],1)],1),_vm._v(" "),_vm._l((item.items),function(subItem){return _c('v-list-tile',{key:subItem.title,attrs:{"to":subItem.route}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                    "+_vm._s(subItem.title)+"\n                  ")])],1)],1)})],2)}),_vm._v(" "),_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"to":item.route,"exact":""}},[_c('v-list-tile-action',{attrs:{"primary":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)})],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"indigo","dark":"","fixed":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Songa Insurance")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("lock")]),_vm._v("\n          Logout\n        ")],1)],1),_vm._v(" "),_c('main',[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"color":"indigo","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© Songa Insurance")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6rNO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__("XfZp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f41f04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__("ZcHi");
function injectStyle (ssrContext) {
  __webpack_require__("V4PG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79f41f04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f41f04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7LYs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agencies_vue__ = __webpack_require__("pCD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94a9740_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agencies_vue__ = __webpack_require__("lig9");
function injectStyle (ssrContext) {
  __webpack_require__("otUq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e94a9740"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agencies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e94a9740_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agencies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7MiB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agencies_vue__ = __webpack_require__("xdGE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72aa58c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agencies_vue__ = __webpack_require__("k+H9");
function injectStyle (ssrContext) {
  __webpack_require__("8xpJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agencies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72aa58c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agencies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8FOj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8iil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesBalanceProvider_vue__ = __webpack_require__("UAHm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109e3539_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesBalanceProvider_vue__ = __webpack_require__("+0T7");
function injectStyle (ssrContext) {
  __webpack_require__("r0+j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-109e3539"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesBalanceProvider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109e3539_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesBalanceProvider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8xpJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9/bu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policies_vue__ = __webpack_require__("1iK7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31693f00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policies_vue__ = __webpack_require__("VMBe");
function injectStyle (ssrContext) {
  __webpack_require__("Y9oe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31693f00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Policies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31693f00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Policies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "959D":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "9Fk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.plan.insurancePlan.name))])],1),_vm._v(" "),_c('v-card-title',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-subheader',[_vm._v("Short name:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Short name"},model:{value:(_vm.plan.insurancePlan.short_name),callback:function ($$v) {_vm.$set(_vm.plan.insurancePlan, "short_name", $$v)},expression:"plan.insurancePlan.short_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-subheader',[_vm._v("Name:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-text-field',{attrs:{"label":"Name"},model:{value:(_vm.plan.insurancePlan.name),callback:function ($$v) {_vm.$set(_vm.plan.insurancePlan, "name", $$v)},expression:"plan.insurancePlan.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-subheader',[_vm._v("Prices:")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v("Period up to ")]),_vm._v(" "),_vm._l((_vm.plan.insurancePlan.pricing),function(ages){return [_c('th',{key:ages},[_vm._v(_vm._s(ages.begin)+" to "+_vm._s(ages.end)+" years")])]})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.plan.insurancePlan.pricing[0].pricing),function(duration,index){return [_c('tr',{key:index},[_c('th',[_vm._v(_vm._s(duration.duration)+" days")]),_vm._v(" "),_vm._l((_vm.plan.insurancePlan.pricing),function(cena,secondIndex){return [_c('td',{key:secondIndex,staticClass:"text-xs-center",attrs:{"type":"text"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.plan.insurancePlan.pricing[secondIndex].pricing[index].price),expression:"plan.insurancePlan.pricing[secondIndex].pricing[index].price"}],staticClass:"text-xs-center",attrs:{"type":"text"},domProps:{"value":(_vm.plan.insurancePlan.pricing[secondIndex].pricing[index].price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.plan.insurancePlan.pricing[secondIndex].pricing[index], "price", $event.target.value)}}})])]})],2)]})],2)])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"warning"},on:{"click":_vm.post}},[_vm._v("Update")])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n          "+_vm._s(_vm.alert.message)+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9kNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__("+oNi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4c8731c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__("oHAl");
function injectStyle (ssrContext) {
  __webpack_require__("SRuY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a4c8731c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4c8731c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AIGb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminsEdit_vue__ = __webpack_require__("i/LN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689ec42c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminsEdit_vue__ = __webpack_require__("E9GD");
function injectStyle (ssrContext) {
  __webpack_require__("e3aa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminsEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_689ec42c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminsEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AZsf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bgat":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Diup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Transaction report")])],1),_vm._v(" "),_c('v-flex',[_c('v-card-title',[_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg3":""}},[_c('v-select',{attrs:{"items":_vm.agencies,"label":"Agencies","item-text":"company","item-value":"id","bottom":"","autocomplete":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.company)+" "+_vm._s(data.item.id))])],1)]]}}]),model:{value:(_vm.selectedAgency),callback:function ($$v) {_vm.selectedAgency=$$v},expression:"selectedAgency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.typeItems,"item-text":"name","item-value":"value","label":"Type","bottom":""},model:{value:(_vm.typeSelected),callback:function ($$v) {_vm.typeSelected=$$v},expression:"typeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.searchFilter}},[_vm._v(" Search\n            ")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":_vm.rows,"pagination":_vm.pagination,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.created_at))]),_vm._v(" "),(props.item.type === 'ADJUSTMENT' && Math.sign(props.item.amount) === 1)?_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),(props.item.type === 'CANCEL' )?_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),(props.item.type === 'ADJUSTMENT' && Math.sign(props.item.amount) === -1)?_c('td',{staticClass:"text-xs-center red--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),(props.item.type === 'SALE')?_c('td',{staticClass:"text-xs-center red--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("furs")(props.item.type)))]),_vm._v(" "),(props.item.type === 'SALE' || props.item.type === 'CANCEL')?_c('td',{staticClass:"text-xs-center"},[_c('router-link',{attrs:{"to":'/admin/policies/show/' + props.item.policy.uuid}},[_vm._v(_vm._s(props.item.policy.uuid))])],1):_vm._e(),_vm._v(" "),(props.item.type === 'ADJUSTMENT')?_c('td',{staticClass:"text-xs-center"},[_vm._v("-")]):_vm._e(),_vm._v(" "),(props.item.type === 'SALE' || props.item.type === 'CANCEL')?_c('td',{staticClass:"text-xs-center"},[_vm._v("-")]):_vm._e(),_vm._v(" "),(props.item.type === 'ADJUSTMENT')?_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.actor.company || props.item.actor.email))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('router-link',{attrs:{"to":'/admin/agencies/show/' + props.item.account.id}},[_vm._v(_vm._s(props.item.account.company))])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))])]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n            Showing "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+" Total: "+_vm._s(_vm.items.length)+"\n          ")]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E9GD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs7":"","md5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Update Admin")])],1),_vm._v(" "),_c('v-card-title',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-1","label":"First Name"},model:{value:(_vm.admin.user.first_name),callback:function ($$v) {_vm.$set(_vm.admin.user, "first_name", $$v)},expression:"admin.user.first_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-1","label":"Last Name"},model:{value:(_vm.admin.user.last_name),callback:function ($$v) {_vm.$set(_vm.admin.user, "last_name", $$v)},expression:"admin.user.last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-1","label":"Email"},model:{value:(_vm.admin.user.email),callback:function ($$v) {_vm.$set(_vm.admin.user, "email", $$v)},expression:"admin.user.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Enter your password","min":"8","rules":_vm.rules.passwordRules,"append-icon":_vm.visibility ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibility = !_vm.visibility); },"type":_vm.visibility ? 'password' : 'text',"counter":""},model:{value:(_vm.admin.user.password),callback:function ($$v) {_vm.$set(_vm.admin.user, "password", $$v)},expression:"admin.user.password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Confirm your password","min":"8","rules":_vm.rules.passwordRulesConfirm,"append-icon":_vm.visibilityConfirm ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibilityConfirm = !_vm.visibilityConfirm); },"type":_vm.visibilityConfirm ? 'password' : 'text',"counter":""},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"warning","disabled":!_vm.valid},on:{"click":function($event){$event.preventDefault();_vm.post($event)}}},[_vm._v("Update")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-alert',{attrs:{"color":"success","icon":"check_circle","value":_vm.alert,"transition":"scale-transition"}},[_vm._v("\n      You have successfully updated admin's data.\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EBEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesEdit_vue__ = __webpack_require__("ieRD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a031fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesEdit_vue__ = __webpack_require__("XmNj");
function injectStyle (ssrContext) {
  __webpack_require__("uQzO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a031fee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZ9g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GDDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      search: "",
      dataLoading: true,
      agencyType: '',
      defaultLogo: __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default.a,
      e1: 0,
      items: [],
      agencyData: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/me").then(function (response) {
      _this.items = response.data;
      _this.getData();
    });
  },

  methods: {
    editAgency: function editAgency(item) {
      this.$router.push({ path: "/agency/agencies/edit/password/" + item.id });
    },
    getData: function getData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/users/" + this.items.id).then(function (response) {
        _this2.agencyData = response.data.user;
        _this2.agencyType = _this2.agencyData.is_provider === '1' ? "Provider" : "Agency";
        _this2.dataLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "Gxsl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I2d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md7":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Register")])],1),_vm._v(" "),_c('div',[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("Account Info")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v("Company Details")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v("Location")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-form',{ref:"form",model:{value:(_vm.validAcc),callback:function ($$v) {_vm.validAcc=$$v},expression:"validAcc"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"First Name","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Last Name","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.rules.emailRules,"required":""},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Enter your password","min":"8","rules":_vm.rules.passwordRules,"append-icon":_vm.visibility ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibility = !_vm.visibility); },"type":_vm.visibility ? 'password' : 'text',"counter":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)}},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Confirm your password","min":"8","rules":_vm.rules.passwordRulesConfirm,"append-icon":_vm.visibilityConfirm ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibilityConfirm = !_vm.visibilityConfirm); },"type":_vm.visibilityConfirm ? 'password' : 'text',"counter":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)}},model:{value:(_vm.user.confirm_password),callback:function ($$v) {_vm.$set(_vm.user, "confirm_password", $$v)},expression:"user.confirm_password"}})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.validAcc,"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("\n                Continue\n              ")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-form',{ref:"form",model:{value:(_vm.validDetails),callback:function ($$v) {_vm.validDetails=$$v},expression:"validDetails"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Company","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.user.company),callback:function ($$v) {_vm.$set(_vm.user, "company", $$v)},expression:"user.company"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Logo URL"},model:{value:(_vm.user.logo),callback:function ($$v) {_vm.$set(_vm.user, "logo", $$v)},expression:"user.logo"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Phone","rules":_vm.rules.phoneValidation,"required":""},model:{value:(_vm.user.phone),callback:function ($$v) {_vm.$set(_vm.user, "phone", $$v)},expression:"user.phone"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Website"},model:{value:(_vm.user.website),callback:function ($$v) {_vm.$set(_vm.user, "website", $$v)},expression:"user.website"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validDetails},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-form',{ref:"form",model:{value:(_vm.validLocation),callback:function ($$v) {_vm.validLocation=$$v},expression:"validLocation"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-flex',[_c('v-select',{staticClass:"input-group",attrs:{"items":_vm.states,"rules":_vm.rules.fieldRules,"autocomplete":"","required":"","label":"Country","item-value":"text"},model:{value:(_vm.user.country),callback:function ($$v) {_vm.$set(_vm.user, "country", $$v)},expression:"user.country"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"City","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.user.city),callback:function ($$v) {_vm.$set(_vm.user, "city", $$v)},expression:"user.city"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Address","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.user.address),callback:function ($$v) {_vm.$set(_vm.user, "address", $$v)},expression:"user.address"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Zip Code","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.user.zip_code),callback:function ($$v) {_vm.$set(_vm.user, "zip_code", $$v)},expression:"user.zip_code"}})],1),_vm._v(" "),_c('v-flex',[[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.sitekey},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})]],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validLocation},nativeOn:{"click":function($event){_vm.register($event)}}},[_vm._v("Register")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-alert',{staticClass:"auth",attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.alert.message)+"\n            ")])],1)],1)],1),_vm._v(" "),_c('v-footer')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IIR/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Sales report")])],1),_vm._v(" "),_c('v-flex',[_c('v-card-title',[(_vm.meProps.is_provider)?_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg1":""}},[_c('v-select',{attrs:{"items":_vm.accountType,"label":"Type","item-text":"account","item-value":"accountValue","bottom":""},model:{value:(_vm.accountTypeSelected),callback:function ($$v) {_vm.accountTypeSelected=$$v},expression:"accountTypeSelected"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg1":""}},[_c('v-select',{attrs:{"items":_vm.country,"label":"Country","item-text":"country","item-value":"countryValue","bottom":""},model:{value:(_vm.countrySelected),callback:function ($$v) {_vm.countrySelected=$$v},expression:"countrySelected"}})],1),_vm._v(" "),(_vm.meProps.is_provider)?_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.agencies,"label":"Agencies","item-text":"company","item-value":"id","bottom":"","autocomplete":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.company)+" "+_vm._s(data.item.id))])],1)]]}}]),model:{value:(_vm.selectedAgency),callback:function ($$v) {_vm.selectedAgency=$$v},expression:"selectedAgency"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg1":""}},[_c('v-select',{attrs:{"items":_vm.typeItems,"item-text":"name","item-value":"value","label":"Status","bottom":""},model:{value:(_vm.typeSelected),callback:function ($$v) {_vm.typeSelected=$$v},expression:"typeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.searchFilter}},[_vm._v(" Search\n            ")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":_vm.rows,"loading":_vm.loading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.index+1))]),_vm._v(" "),(_vm.meProps.is_provider)?_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("isProvider")(props.item.is_provider)))]):_vm._e(),_vm._v(" "),(_vm.meProps.is_provider)?_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.company))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("removeTime")(props.item.created_at)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.insurance_type))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.policy_uuid))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.people_count))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("status")(props.item.cancelled)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(_vm._f("minusRemover")(props.item.amount)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.first_name)+" "+_vm._s(props.item.last_name))])]}}])},[_c('template',{attrs:{"slot":"footer"},slot:"footer"},[_c('td',{staticClass:"text-xs-center"},[_c('strong',[_vm._v("\n                Total:\n              ")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.meProps.is_provider)?_c('td'):_vm._e(),_vm._v(" "),(_vm.meProps.is_provider)?_c('td'):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center green--text"},[_c('strong',[_vm._v("\n                $ "+_vm._s(_vm.sum)+"\n              ")])]),_vm._v(" "),_c('td')])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IYKe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J+Xa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      alert: {
        status: false,
        message: '',
        type: ''
      },
      insurancePlans: [],
      search: "",
      dataLoading: true,
      e1: 0,
      policyValid: false,
      items: [],
      duration: null,
      dialog: false,
      insurancePolicy: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/insuranceplans").then(function (response) {
      _this.insurancePlans = response.data.insurancePlans;
    });
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/me").then(function (response) {
      _this2.items = response.data;
      _this2.getData();
    });
  },

  methods: {
    insurancePlanName: function insurancePlanName(plan_id) {
      var plan_name = '';
      this.insurancePlans.map(function (element) {
        if (element.id == plan_id) {
          plan_name = element.name;
        }
      });
      return plan_name;
    },
    closeDialog: function closeDialog() {
      this.dialog = !this.dialog;
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    alerting: function alerting() {
      var _this3 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this3.alert.status = !_this3.alert.status;
      }, 2500);
    },
    getData: function getData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/policies/' + this.$route.params.uuid).then(function (response) {
        _this4.insurancePolicy = response.data.policies;
        _this4.dataLoading = false;
        _this4.duration = _this4.policyDuration(_this4.insurancePolicy.duration_from, _this4.insurancePolicy.duration_to);
        _this4.policyValid = _this4.policyValidation(_this4.insurancePolicy.duration_from);
      });
    },
    cancelPolicy: function cancelPolicy(uuid) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/policies/' + uuid + '/cancel').then(function (res) {
        _this5.alert.message = 'Policy has been cancelled.';
        _this5.alert.type = 'success';
        _this5.alerting();
        _this5.getData();
      }).catch(function (error) {});
    },
    downloadPdf: function downloadPdf(uuid) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/policies/' + uuid + '/pdf', { responseType: 'blob' }).then(function (response) {
        var newBlob = new Blob([response.data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob, uuid + ".pdf");
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = uuid + ".pdf";
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100);
      }).catch(function (error) {});
    },
    policyDuration: function policyDuration(start, finish) {
      var beg = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(finish);
      var result = end.diff(beg, "days");
      return result;
    },
    policyValidation: function policyValidation(start) {
      var exp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start);
      var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      var diffDuration = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(exp.diff(now));

      if (diffDuration.minutes() > 0) {
        return true;
      }
    }
  }
});

/***/ }),

/***/ "JPPC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      alert: {
        status: false,
        message: "",
        type: ""
      },
      defaultLogo: __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default.a,
      dataLoading: true,
      agencyData: [],
      isAgencyDeleted: false,
      color: 'primary',
      resize: "sm4",
      menu: false,
      agencyType: "Agency",
      loading: true
    };
  },

  mounted: function mounted() {
    this.getData();
  },
  methods: {
    adjustBalance: function adjustBalance() {
      this.$router.push("/agency/agencies/balance/" + this.$route.params.id);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    editAgency: function editAgency(item) {
      this.$router.push({ path: "/agency/agencies/edit/" + item.id });
    },
    getData: function getData() {
      var _this = this;

      this.dataLoading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/users/" + this.$route.params.id).then(function (res) {
        _this.agencyData = res.data.user;
        _this.dataLoading = false;
        _this.isAgencyDeleted = _this.agencyData.is_deleted == 1 ? true : false;
        _this.color = _this.isAgencyDeleted ? 'red' : 'primary';
      });
    }
  }
});

/***/ }),

/***/ "JjR9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JlHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md8":"","lg4":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Reset password")])],1),_vm._v(" "),_c('v-card-title',[_c('v-flex',[_c('p',[_vm._v("Please enter your email and follow instructions on how to reset your password.")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.rules.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid},on:{"click":function($event){$event.preventDefault();_vm.reset($event)}}},[_vm._v("\r\n              reset\r\n            ")])],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{staticClass:"auth",attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\r\n              "+_vm._s(_vm.alert.message)+"\r\n            ")])],1)],1)],1),_vm._v(" "),_c('v-footer')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KJ/n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-flex',{attrs:{"xs12":"","sm12":"","md8":"","lg6":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Approve Agency")])],1),_vm._v(" "),_c('v-flex',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.forApproval,"hide-actions":"","no-data-text":"There are no agencies to approve."},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',[_c('v-avatar',{attrs:{"size":_vm.avatarSize,"tile":false}},[_c('img',{attrs:{"src":props.item.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company || "something"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.approved)))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"green"},on:{"click":function($event){_vm.approveUser(props.item.id)}}},[_vm._v("Approve\n                          ")])],1)],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n          "+_vm._s(_vm.alert.message)+"\n        ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Keya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__("/7cw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74812f9b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__("I2d3");
function injectStyle (ssrContext) {
  __webpack_require__("iNl1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74812f9b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74812f9b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L/VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PoliciesShow_vue__ = __webpack_require__("J+Xa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b0578c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PoliciesShow_vue__ = __webpack_require__("pfVq");
function injectStyle (ssrContext) {
  __webpack_require__("rgr7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b0578c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PoliciesShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b0578c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PoliciesShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LCHv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md7":"","lg4":"","xl4":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Reset password")])],1),_vm._v(" "),_c('div',[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-form',{ref:"form",model:{value:(_vm.validAcc),callback:function ($$v) {_vm.validAcc=$$v},expression:"validAcc"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Enter your password","min":"8","rules":_vm.rules.passwordRules,"append-icon":_vm.visibility ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibility = !_vm.visibility); },"type":_vm.visibility ? 'password' : 'text',"counter":""},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Confirm your password","min":"8","rules":_vm.rules.passwordRulesConfirm,"append-icon":_vm.visibilityConfirm ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibilityConfirm = !_vm.visibilityConfirm); },"type":_vm.visibilityConfirm ? 'password' : 'text',"counter":""},model:{value:(_vm.user.confirm_password),callback:function ($$v) {_vm.$set(_vm.user, "confirm_password", $$v)},expression:"user.confirm_password"}})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.validAcc,"color":"primary"},nativeOn:{"click":function($event){_vm.saveNewPass($event)}}},[_vm._v("\n                Save\n              ")])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-alert',{staticClass:"auth",attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.alert.message)+"\n            ")])],1)],1)],1),_vm._v(" "),_c('v-footer')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Vq/C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MGmC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MQgg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__("aapp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e065c2c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__("Diup");
function injectStyle (ssrContext) {
  __webpack_require__("1HCu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e065c2c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e065c2c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mcgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesSubShow_vue__ = __webpack_require__("TFyE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b25782e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesSubShow_vue__ = __webpack_require__("2G1o");
function injectStyle (ssrContext) {
  __webpack_require__("v2Y2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b25782e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesSubShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b25782e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesSubShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__("eqvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_auth_js__ = __webpack_require__("VrlL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_style_css__ = __webpack_require__("Q0/0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_style_css__);










// index.js or main.js


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__plugins_auth_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.request.use(function (config) {

  if (config.url[0] === "/") {
    config.url = "http://songa.iq/app/api" + config.url;

    var token = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.getToken();
    if (token) {
      config.headers['Content-Type'] = 'application/json';
      config.headers['Authorization'] = 'Bearer ' + token;
    }
  }
  return config;
}, function (error) {
  // Do something with request error
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_3__routes_js__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAdmin;
  })) {
    var admin = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.getAdmin();
    if (admin === "true") {
      next();
    } else if (admin === "false") {
      next({
        path: '/agency',
        query: { redirect: to.fullPath }
      });
    } else if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    }) && !__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.loggedIn()) {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath }
      });
    }
  } else if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && !__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.loggedIn()) {
    next({
      path: '/auth/login',
      query: { redirect: to.fullPath }
    });
  } else if (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.loggedIn() && __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].auth.getAdmin() === "true") {
    next({
      path: '/admin'
    });
  } else {
    next(); // make sure to always call next()!
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__routes_js__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  },
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_8_vue_simple_spinner___default.a
  }
});

/***/ }),

/***/ "NSul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      password: '',
      email: '',
      e1: true,
      alert: false,
      errorMessage: ''
    };
  },
  methods: {
    alerting: function alerting() {
      var _this = this;

      this.alert = !this.alert;
      setTimeout(function () {
        _this.alert = !_this.alert;
      }, 3500);
    },
    login: function login() {
      var _this2 = this;

      var vm = this;
      this.valid = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login', {
        email: this.email,
        password: this.password
      }).then(function (res) {
        _this2.$auth.setToken(res.data.access_token, Date.now() + 28800000);
        _this2.$auth.setAdmin(res.data.is_admin);
        if (res.data.is_admin == true) {
          _this2.$router.push('/admin');
        } else {
          _this2.$router.push('/agency');
        }
      }).catch(function (error) {
        vm.errorMessage = error.response.data.message || 'Username or password is not valid.';
        vm.alerting();
        vm.valid = true;
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ "Np5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Issued Policies")])],1),_vm._v(" "),_c('v-card-title',[_c('v-flex',{attrs:{"xs12":"","lg2":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-4 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},on:{"input":function($event){_vm.dateFormatted = _vm.formatDate($event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-4 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-2 pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.getPolicies}},[_vm._v(" Search\n          ")])],1)],1),_vm._v(" "),_c('v-flex',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"search":_vm.search,"loading":_vm.loading,"rows-per-page-items":_vm.rows,"item-key":"uuid"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:({ cursor: props.item.people.length > 1 ? 'pointer' : 'auto' }),on:{"click":function($event){ props.item.insurance_type !== 'Single' ? props.expanded = !props.expanded : null}}},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.uuid))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("removeTime")(props.item.created_at)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.insurance_type))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.beneficiary.first_name + ' ' + props.item.beneficiary.middle_name + ' ' + props.item.beneficiary.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.beneficiary.passport_number))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.country_residence))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.country_destination))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.duration_from))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.duration_to))]),_vm._v(" "),(props.item.cancelled === '1')?_c('td',{staticClass:"text-xs-center red--text"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.cancelled)))]):_c('td',{staticClass:"text-xs-center green--text"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.cancelled)))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"primary"},on:{"click":function($event){_vm.showPolicy(props.item)}}},[_vm._v("\n                    show\n                    ")])],1)],1)],1)])]}},{key:"expand",fn:function(props){return _vm._l((props.item.people),function(person,index){return _c('v-list',{key:index,staticClass:"grey lighten-4",attrs:{"three-line":""}},[(index === 0)?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(props.item.total_parents > 1 && index == 1)?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(props.item.total_children && (props.item.total_parents == 1 && index !== 0))?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(index))]):_vm._e(),_vm._v(" "),(props.item.total_children && (props.item.total_parents == 2 && index !== 0 && index !== 1))?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(index - 1))]):_vm._e(),_vm._v(" "),(!props.item.total_children && !props.item.total_parents && index != 0)?_c('v-subheader',{staticClass:"headline"},[_vm._v(" User "+_vm._s(index))]):_vm._e(),_vm._v(" "),_c('v-list-tile',{attrs:{"two-line":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(person.first_name + ' ' + person.middle_name + ' ' + person.last_name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Name")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(person.passport_number))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Passport number")])],1)],1)],1)})}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n          Showing "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+" Total: "+_vm._s(_vm.items.length)+"\n        ")]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ny8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_countryCodes_js__ = __webpack_require__("mbGk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      agency: {
        user: {
          approved: true
        }
      },
      e1: 0,
      e2: true,
      validAcc: true,
      validDetails: true,
      validLocation: true,
      alert: {
        status: false,
        message: null,
        type: null
      },
      rules: {
        fieldRules: [function (v) {
          return !!v || "Field is required";
        }],
        phoneValidation: [function (v) {
          return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
          );
        }],
        passwordRules: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v.length >= 8 || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v == _this.user.password || "Password not confirmed";
        }],
        emailRules: [function (v) {
          return !!v || "E-mail is required";
        }, function (v) {
          return (/\S+@\S+\.\S+/.test(v) || "E-mail must be valid"
          );
        }]
      },
      states: __WEBPACK_IMPORTED_MODULE_1__helpers_countryCodes_js__["a" /* countryCodesSingle */]
    };
  },

  methods: {
    alerting: function alerting() {
      var _this2 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this2.alert.status = !_this2.alert.status;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.push("/agency/agencies");
    },
    post: function post() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/users", this.agency).then(function (res) {
        _this3.alert.message = 'You have registered successfully.';
        _this3.alert.type = 'success';
        _this3.alerting();
        setTimeout(function () {
          _this3.$router.push("/agency/agencies");
        }, 2000);
      }).catch(function (err) {
        _this3.alert.message = 'There was an issue with your registration.';
        _this3.alert.type = 'error';
        _this3.alerting();
      });
    }
  }
});

/***/ }),

/***/ "OS5g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OTuL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OXyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_countryCodes_js__ = __webpack_require__("mbGk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a
  },
  data: function data() {
    var _this = this;

    return {
      imageName: "",
      imageUrl: "",
      selectedFile: "",
      confirmPassword: "",
      visibility: true,
      visibilityConfirm: true,
      valid: true,
      agency: {
        user: {
          password: "",
          confirmPassword: ""
        }
      },
      rules: {
        fieldRules: [function (v) {
          return !!v || "Field is required";
        }],
        phoneValidation: [function (v) {
          return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
          );
        }],
        passwordRules: [function (v) {
          return v.length >= 8 || !v || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return v == _this.agency.user.password || !v || "Password not confirmed";
        }, function (v) {
          return v.length >= 8 || !v || "Password must be at least 8 characters";
        }],
        emailRules: [function (v) {
          return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
          );
        }]
      },
      e1: 0,
      dataLoading: true,
      alert: {
        status: false,
        message: "",
        type: ""
      },
      states: __WEBPACK_IMPORTED_MODULE_3__helpers_countryCodes_js__["a" /* countryCodesSingle */]
    };
  },

  mounted: function mounted() {
    this.getAgency();
  },
  watch: {
    "agency.user.password": function agencyUserPassword(val) {
      this.confirmPassword = '';
      if (val && val !== this.confirmPassword) {
        this.valid = false;
      } else if (!val && !this.confirmPassword) {
        this.valid = true;
      } else if (val && this.agency.user.password === val) {
        this.valid = true;
      } else {
        return false;
      }
    },
    confirmPassword: function confirmPassword(val) {
      if (val !== "" && val === this.agency.user.password) {
        this.valid = true;
      } else if (!val && !this.agency.user.password) {
        this.valid = true;
      } else {
        this.valid = false;
      }
    }
  },
  methods: {
    resetImage: function resetImage() {
      var fr = new FileReader();
      this.imageName = "";
      this.selectedFile = "";
      this.imageUrl = "";
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onFileSelected: function onFileSelected(event) {
      var _this2 = this;

      var files = event.target.files[0];
      this.selectedFile = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(files);

      var fr = new FileReader();
      fr.readAsDataURL(files);
      fr.addEventListener('load', function () {
        _this2.imageUrl = fr.result;
      });
    },
    sendLogo: function sendLogo() {
      var _this3 = this;

      var fd = new FormData();
      fd.append('image', this.selectedFile);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/upload", fd).then(function (res) {
        _this3.agency.user.logo_url = res.data.url;
        _this3.post(true);
        _this3.resetImage();
      }).catch(function (error) {
        if (error.response.data.errors[0].detail === "validation.dimensions") {
          _this3.alert.message = "Logo dimension should not be bigger than 500x500 px";
        } else {
          _this3.alert.message = "Logo size should not exceed 2mb";
        }
        _this3.alert.type = "error";
        _this3.alerting();
      });
    },
    alerting: function alerting() {
      var _this4 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this4.alert.status = !_this4.alert.status;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getAgency: function getAgency() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/users/" + this.$route.params.id).then(function (res) {
        _this5.agency.user = res.data.user;
        _this5.dataLoading = "false";
      });
    },
    post: function post() {
      var _this6 = this;

      var isImage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/users/" + this.$route.params.id, this.agency).then(function (res) {
        _this6.alert.message = isImage === true ? "Logo has been changed." : "Agency has been updated.";
        _this6.alert.type = "success";
        _this6.alerting();
      });
    }
  }
});

/***/ }),

/***/ "PryS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      drawer: true,
      dataLoading: true,
      binging: true,
      defaultLogo: __WEBPACK_IMPORTED_MODULE_2__assets_placeholder_profile_photo_200x200_png___default.a,
      items: [{
        action: 'assignment',
        title: 'Insurance Policy',
        active: true,
        items: [{ action: 'add', title: 'New Insurance Policy', route: '/agency/new_insurance' }, { action: 'add', title: 'New Insurance Policy - Turkey', route: '/agency/new_insurance_turkey' }, { action: 'add', title: 'Issued Policies', route: '/agency/issued_policies' }]
      }],
      menuItems: [{ icon: 'supervisor_account', title: 'Account', route: '/agency/account' }, { icon: 'assessment', title: 'Sales Reports', route: '/agency/sales' }],
      meProps: {}
    };
  },
  props: {
    source: String
  },
  computed: {
    avatarSize: function avatarSize() {
      return '150px';
    },
    binding: function binding() {
      if (this.$vuetify.breakpoint.xs) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    logout: function logout() {
      this.$auth.destroyToken();
      this.$router.push('/auth/login');
    },
    getMe: function getMe() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/me').then(function (res) {
        _this.meProps = res.data;
        _this.isProvider();
        _this.dataLoading = !_this.dataLoading;
      });
    },
    updateBalance: function updateBalance() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/me').then(function (res) {
        _this2.meProps.balance = res.data.balance;
      });
    },
    isProvider: function isProvider() {
      if (this.meProps.is_provider === true) {
        this.menuItems.splice(1, 0, { icon: 'work', title: 'Agencies', route: '/agency/agencies' });
        this.menuItems.splice(2, 0, { icon: 'content_copy', title: 'Transaction Reports', route: '/agency/transaction' });
        this.menuItems.push({ icon: 'description', title: 'Summary Reports', route: '/agency/summary' });
      }
    }
  },
  created: function created() {
    this.getMe();
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.$on('updateBalance', function () {
      _this3.updateBalance();
    });
  }
});

/***/ }),

/***/ "Q0/0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qlto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.plan.insurancePlan.name))])],1),_vm._v(" "),_c('v-card-title',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs2":""}},[_c('v-subheader',[_vm._v("Short name:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-subheader',[_vm._v("\n                      "+_vm._s(_vm.plan.insurancePlan.short_name)+"\n                      ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-subheader',[_vm._v("Name:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-subheader',[_vm._v("\n                      "+_vm._s(_vm.plan.insurancePlan.name)+"\n                      ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v("Period up to ")]),_vm._v(" "),_vm._l((_vm.plan.insurancePlan.pricing),function(ages){return [_c('th',{key:ages},[_vm._v(_vm._s(ages.begin)+" to "+_vm._s(ages.end)+" years")])]})],2)]),_vm._v(" "),_c('tbody',[_vm._l((_vm.plan.insurancePlan.pricing[0].pricing),function(duration,index){return [_c('tr',{key:index},[_c('th',[_vm._v(_vm._s(duration.duration)+" days")]),_vm._v(" "),_vm._l((_vm.plan.insurancePlan.pricing),function(cena,secondIndex){return [_c('td',{key:secondIndex+index,staticClass:"text-xs-center",attrs:{"type":"text"}},[_vm._v(_vm._s(_vm.plan.insurancePlan.pricing[secondIndex].pricing[index].price))])]})],2)]})],2)])])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SRuY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TEkg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__("097D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_countryCodes_js__ = __webpack_require__("mbGk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      e1: 1,
      alert: {
        status: false,
        message: null,
        type: null
      },
      validAcc: true,
      rules: {
        passwordRules: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v.length >= 8 || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v == _this.user.password || "Password not confirmed";
        }]
      },
      visibility: true,
      visibilityConfirm: true,
      user: {
        password: "",
        confirm_password: ""
      }
    };
  },

  methods: {
    alerting: function alerting() {
      var _this2 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this2.alert.status = !_this2.alert.status;
      }, 2500);
    },
    saveNewPass: function saveNewPass() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/token/reset", { token: this.$route.params.token, new_password: this.user.password }).then(function (response) {
        _this3.alert.message = 'You have changed your password successfully.';
        _this3.alert.type = 'success';
        _this3.alerting();
        setTimeout(function () {
          _this3.$router.push('/auth/login');
        }, 2000);
      }).catch(function (err) {
        _this3.alert.message = 'There was an issue with changing your password.';
        _this3.alert.type = 'error';
        _this3.alerting();
      });
    }
  }
});

/***/ }),

/***/ "TFyE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a
  },
  data: function data() {
    var _ref;

    return _ref = {
      alert: {
        status: false,
        message: "",
        type: ""
      },
      defaultLogo: __WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png___default.a,
      dataLoading: true,
      dialog: false,
      agencyData: [],
      agencyType: "Agency",
      agencies: [{ id: '' }],
      selectedAgency: null
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialog", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "loading", true), _ref;
  },

  mounted: function mounted() {
    this.getData();
  },
  methods: {
    alerting: function alerting() {
      var _this = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this.alert.status = !_this.alert.status;
      }, 2500);
    },
    closeDialog: function closeDialog() {
      this.dialog = !this.dialog;
    },
    adjustBalance: function adjustBalance() {
      this.$router.push("/admin/agencies/balance/" + this.$route.params.id);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    editAgency: function editAgency(item) {
      this.$router.push({ path: "/admin/agencies/edit/" + item.id });
    },
    getData: function getData() {
      var _this2 = this;

      this.dataLoading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/users/" + this.$route.params.id).then(function (res) {
        _this2.agencyData = res.data.user;
        _this2.dataLoading = false;
      });
    },
    deleteItem: function deleteItem(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/users/" + id).then(function (response) {
        _this3.$router.push("/admin/agencies");
      });
    }
  }
});

/***/ }),

/***/ "To2K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesEditPass_vue__ = __webpack_require__("c1PA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162646c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesEditPass_vue__ = __webpack_require__("6FBZ");
function injectStyle (ssrContext) {
  __webpack_require__("6Cvj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesEditPass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_162646c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesEditPass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UAHm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      alert: {
        status: false,
        message: '',
        type: ''
      },
      disableButton: false,
      user: {
        amount: "",
        description: ""
      }
    };
  },

  methods: {
    alerting: function alerting() {
      var _this = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this.alert.status = !_this.alert.status;
        _this.disableButton = false;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    adjustBallance: function adjustBallance() {
      var _this2 = this;

      this.disableButton = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/users/" + this.$route.params.id + "/adjustment", this.user).then(function (res) {
        _this2.alert.message = 'Amount adjusted.';
        _this2.alert.type = 'success';
        _this2.alerting();
        _this2.$root.$emit('updateBalance');
        setTimeout(function () {
          _this2.goBack();
        }, 2600);
      }).catch(function (err) {
        _this2.alert.message = err.response.data.message || 'Adjustment failed.';
        _this2.alert.type = 'error';
        _this2.alerting();
      });
    }
  }
});

/***/ }),

/***/ "ULPA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      search: "",
      pagination: {},
      counter: 0,
      dateFrom: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      sum: null,
      agencies: [{ company: 'All', id: null }],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [{ name: 'All', value: null }, { name: 'Booked', value: 'false' }, { name: 'Cancelled', value: 'true' }],
      countrySelected: null,
      country: [{ country: 'All', countryValue: null }, { country: 'Turkey', countryValue: 'turkey' }, { country: 'Other', countryValue: 'other' }],
      accountTypeSelected: null,
      accountType: [{ account: 'All', accountValue: null }, { account: 'Agency', accountValue: 'agency' }, { account: 'Provider', accountValue: 'provider' }],
      searchQuery: '',
      headers: [{
        text: "No.",
        align: "center",
        sortable: false,
        value: "id"
      }, { text: "Account Type", value: "accountType", sortable: false, align: "cetner" }, {
        text: "Agency",
        value: "agency",
        sortable: false,
        align: "center"
      }, { text: "Date", value: "date", sortable: false, align: "center" }, {
        text: "Type of Insurance",
        value: "insuranceType",
        sortable: false,
        align: "center"
      }, {
        text: "Insurance ID",
        value: "policy_uuid",
        sortable: false,
        align: "center"
      }, {
        text: "Num. of people",
        value: "number_of_people",
        sortable: false,
        align: "center"
      }, {
        text: "Status",
        value: "status",
        sortable: false,
        align: "center"
      }, {
        text: "Total",
        value: "total",
        sortable: false,
        align: "center"
      }, {
        text: "Beneficiary",
        value: "user",
        sortable: false,
        align: "center"
      }],
      items: [],
      meProps: {}
    };
  },

  filters: {
    isProvider: function isProvider(value) {
      if (value == '0') {
        value = "Agency";
      } else {
        value = "Provider";
      }
      return value;
    },
    status: function status(value) {
      if (value == '0') {
        value = "Booked";
      } else {
        value = "Cancelled";
      }
      return value;
    },
    minusRemover: function minusRemover(value) {
      return value.replace('-', '');
    },
    removeTime: function removeTime(value) {
      return value.substring(0, value.length - 9);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.searchFilter();
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/me').then(function (res) {
      _this.meProps = res.data;
      if (!_this.meProps.is_provider) {
        _this.headers = [{
          text: "No.",
          align: "center",
          sortable: false,
          value: "id"
        }, { text: "Date", value: "date", sortable: false, align: "center" }, {
          text: "Type of Insurance",
          value: "insuranceType",
          sortable: false,
          align: "center"
        }, {
          text: "Insurance ID",
          value: "policy_uuid",
          sortable: false,
          align: "center"
        }, {
          text: "Num. of people",
          value: "number_of_people",
          sortable: false,
          align: "center"
        }, {
          text: "Status",
          value: "status",
          sortable: false,
          align: "center"
        }, {
          text: "Total",
          value: "total",
          sortable: false,
          align: "center"
        }, {
          text: "Beneficiary",
          value: "user",
          sortable: false,
          align: "center"
        }];
      }
      _this.dataLoading = !_this.dataLoading;
    });
    if (this.meProps.is_provider) this.getAgencies();
  },

  methods: {
    calculated: function calculated() {
      var summary = 0;
      for (var key in this.items) {
        var a = Math.abs(this.items[key].amount);
        summary += a;
      }
      this.sum = summary;
    },
    getAgencies: function getAgencies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (res) {
        for (var user in res.data.users) {
          _this2.agencies.push(res.data.users[user]);
        }
      });
    },
    goToPolicy: function goToPolicy(id) {
      this.$router.push({ path: "/admin/policies/show/" + id });
    },
    buildQuery: function buildQuery() {
      this.searchQuery = '';
      if (this.selectedAgency) {
        this.searchQuery += 'agency=' + this.selectedAgency + "&";
      }
      if (this.countrySelected) {
        this.searchQuery += 'country=' + this.countrySelected + "&";
      }
      if (this.accountTypeSelected) {
        this.searchQuery += 'account_type=' + this.accountTypeSelected + "&";
      }
      if (this.typeSelected) {
        this.searchQuery += 'cancelled=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery += 'date_from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery += 'date_to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter: function searchFilter() {
      var _this3 = this;

      this.buildQuery();
      this.loading = true;
      this.items = [];
      this.sum = 0;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/reports/sales?" + this.searchQuery).then(function (response) {
        response.data.reports.forEach(function (element) {
          if (element.tx_type === "SALE" && element.cancelled == "1") {
            return false;
          } else {
            _this3.items.push(element);
          }
        });
        _this3.loading = false;
        _this3.calculated();
      }).catch(function (error) {
        this.loading = false;
      });
    }
  }
});

/***/ }),

/***/ "V4PG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VMBe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Insurance Policies")])],1),_vm._v(" "),_c('v-card-title',[_c('v-flex',{attrs:{"xs12":"","lg2":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-4 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},on:{"input":function($event){_vm.dateFormatted = _vm.formatDate($event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-4 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-2 pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.searchFilter}},[_vm._v(" Search\n          ")])],1)],1),_vm._v(" "),_c('v-flex',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"pagination":_vm.pagination,"loading":_vm.loading,"search":_vm.search,"rows-per-page-items":_vm.rows,"item-key":"uuid"},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:({ cursor: props.item.people.length > 1 ? 'pointer' : 'auto' }),on:{"click":function($event){ props.item.insurance_type !== 'Single' ? props.expanded = !props.expanded : null}}},[_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.uuid))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("removeTime")(props.item.created_at)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.insurance_type))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('router-link',{attrs:{"to":'/admin/agencies/show/' + props.item.agency_id}},[_vm._v(_vm._s(_vm.agencyName(props.item.agency_id)))])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.beneficiary.first_name + ' ' + props.item.beneficiary.middle_name + ' ' + props.item.beneficiary.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.beneficiary.passport_number))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.people.length))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.duration_from))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.duration_to))]),_vm._v(" "),(props.item.cancelled === '1')?_c('td',{staticClass:"text-xs-center red--text"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.cancelled)))]):_c('td',{staticClass:"text-xs-center green--text"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.cancelled)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("$"+_vm._s(props.item.amount))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"primary"},on:{"click":function($event){_vm.showPolicy(props.item)}}},[_vm._v("\n                    show\n                    ")])],1)],1)],1)])]}},{key:"expand",fn:function(props){return _vm._l((props.item.people),function(person,index){return _c('v-list',{key:index,staticClass:"grey lighten-4",attrs:{"three-line":""}},[(index === 0)?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(props.item.total_parents > 1 && index == 1)?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(props.item.total_children && (props.item.total_parents == 1 && index !== 0))?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(index))]):_vm._e(),_vm._v(" "),(props.item.total_children && (props.item.total_parents == 2 && index !== 0 && index !== 1))?_c('v-subheader',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(index - 1))]):_vm._e(),_vm._v(" "),(!props.item.total_children && !props.item.total_parents && index != 0)?_c('v-subheader',{staticClass:"headline"},[_vm._v(" User "+_vm._s(index))]):_vm._e(),_vm._v(" "),_c('v-list-tile',{attrs:{"two-line":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(person.first_name + ' ' + person.middle_name + ' ' + person.last_name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Name")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(person.passport_number))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Passport number")])],1)],1)],1)})}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n            Showing "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+" Total: "+_vm._s(_vm.items.length)+"\n          ")]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vq/C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VrlL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);

var AuthPlugin = {
    setToken: function setToken(token, expiration) {
        localStorage.setItem('authToken', token);
        localStorage.setItem('authTokenExpiration', expiration);
    },

    destroyToken: function destroyToken() {
        localStorage.removeItem('authToken');
        localStorage.removeItem('authTokenExpiration');
        localStorage.removeItem("admin");
    },

    getToken: function getToken() {
        var token = localStorage.getItem('authToken');
        var expiration = localStorage.getItem('authTokenExpiration');

        if (!token || !expiration) return null;

        if (Date.now() > parseInt(expiration)) {
            this.destroyToken();
            return null;
        } else {
            return token;
        }
    },

    loggedIn: function loggedIn() {
        if (this.getToken()) return true;else return false;
    },
    setAdmin: function setAdmin(value) {
        localStorage.setItem("admin", value);
    },
    getAdmin: function getAdmin() {
        var admin = localStorage.getItem('admin');
        return admin;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (function (Vue) {
    Vue.auth = AuthPlugin;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(Vue.prototype, {
        $auth: {
            get: function get() {
                return Vue.auth;
            }
        }
    });
});

/***/ }),

/***/ "XfZp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      search: "",
      pagination: {},
      counter: 0,
      dateFrom: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      calculated: null,
      agencies: [{ company: 'All', id: null }],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [{ name: 'All', value: null }, { name: 'Adjustment', value: 'ADJUSTMENT' }, { name: 'Sale', value: 'SALE' }, { name: 'Cancel', value: 'CANCEL' }],
      searchQuery: ''
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "pagination", {
      sortBy: 'id'
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "headers", [{
      text: "Transaction ID",
      value: "id",
      sortable: true,
      align: "center"
    }, {
      text: "Date",
      value: "date",
      sortable: false,
      align: "cetner" }, {
      text: "Credit/Debit",
      value: "type",
      sortable: false,
      align: "center"
    }, {
      text: "Type",
      value: "type",
      sortable: false,
      align: "center"
    }, {
      text: "Insurance policy",
      value: "total",
      sortable: false,
      align: "center"
    }, {
      text: "Creator",
      value: "canceled",
      sortable: false,
      align: "center"
    }, { text: "Agency",
      value: "total",
      sortable: false,
      align: "center"
    }, {
      text: "Description",
      value: "holder",
      sortable: false,
      align: "center"
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "items", []), _ref;
  },

  filters: {
    booleanify: function booleanify(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    },
    formatId: function formatId(value) {
      return value.substring(2);
    },
    furs: function furs(string) {
      var smalling = string.toLowerCase();
      var uppin = smalling.charAt(0).toUpperCase() + smalling.slice(1);
      return uppin;
    }
  },
  methods: {
    getTransactions: function getTransactions() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/transactions").then(function (response) {
        _this.items = response.data.transactions;
        _this.loading = false;
      });
    },
    agencyInfo: function agencyInfo(agencyId) {
      var extraVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var agencyData = '';
      this.agencies.forEach(function (agency) {
        if (agency.id == agencyId) {
          if (extraVal) {
            agencyData = agency[extraVal];
          } else {
            agencyData = agency.id;
          }
        }
      });
      return agencyData;
    },
    getAgencies: function getAgencies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/agencies").then(function (res) {
        for (var user in res.data.users) {
          _this2.agencies.push(res.data.users[user]);
        }
      });
    },
    buildQuery: function buildQuery() {
      this.searchQuery = '';
      if (this.selectedAgency) {
        this.searchQuery += 'agency_id=' + this.selectedAgency + "&";
      }
      if (this.typeSelected) {
        this.searchQuery += 'type=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery += 'from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery += 'to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter: function searchFilter() {
      var _this3 = this;

      this.loading = true;
      this.items = {};
      this.buildQuery();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/transactions?" + this.searchQuery).then(function (response) {
        _this3.items = response.data.transactions;
        _this3.loading = false;
      });
    }
  },
  created: function created() {
    this.getTransactions();
    this.getAgencies();
    this.pagination.descending = !this.pagination.descending;
  }
});

/***/ }),

/***/ "XmNj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md7":"","lg5":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Update Agency")])],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("Account Info")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v("Location")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v("Company Details")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"First Name","required":""},model:{value:(_vm.agency.user.first_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "first_name", $$v)},expression:"agency.user.first_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Last Name","required":""},model:{value:(_vm.agency.user.last_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "last_name", $$v)},expression:"agency.user.last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"E-mail","required":""},model:{value:(_vm.agency.user.email),callback:function ($$v) {_vm.$set(_vm.agency.user, "email", $$v)},expression:"agency.user.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Enter new password","min":"8","rules":_vm.rules.passwordRules,"append-icon":_vm.visibility ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibility = !_vm.visibility); },"type":_vm.visibility ? 'password' : 'text',"counter":""},model:{value:(_vm.agency.user.password),callback:function ($$v) {_vm.$set(_vm.agency.user, "password", $$v)},expression:"agency.user.password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Confirm new password","min":"8","rules":_vm.rules.passwordRulesConfirm,"append-icon":_vm.visibilityConfirm ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibilityConfirm = !_vm.visibilityConfirm); },"type":_vm.visibilityConfirm ? 'password' : 'text',"counter":""},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Update")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-select',{staticClass:"input-group",attrs:{"items":_vm.states,"label":"Country","item-value":"text","autocomplete":"","required":""},model:{value:(_vm.agency.user.country),callback:function ($$v) {_vm.$set(_vm.agency.user, "country", $$v)},expression:"agency.user.country"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"City","required":""},model:{value:(_vm.agency.user.city),callback:function ($$v) {_vm.$set(_vm.agency.user, "city", $$v)},expression:"agency.user.city"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Address","required":""},model:{value:(_vm.agency.user.address),callback:function ($$v) {_vm.$set(_vm.agency.user, "address", $$v)},expression:"agency.user.address"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Zip Code","required":""},model:{value:(_vm.agency.user.zip_code),callback:function ($$v) {_vm.$set(_vm.agency.user, "zip_code", $$v)},expression:"agency.user.zip_code"}})],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning"},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Update")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Back")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Company","required":""},model:{value:(_vm.agency.user.company),callback:function ($$v) {_vm.$set(_vm.agency.user, "company", $$v)},expression:"agency.user.company"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[(_vm.imageUrl || _vm.agency.user.logo_url)?_c('img',{attrs:{"src":_vm.imageUrl || _vm.agency.user.logo_url,"height":"150"}}):_vm._e(),_vm._v(" "),(!_vm.selectedFile)?_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"info"},nativeOn:{"click":function($event){_vm.pickFile($event)}}},[_vm._v("\n                Select Logo\n                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("attach_file")])],1):_vm._e(),_vm._v(" "),(!_vm.selectedFile)?_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFileSelected}}):_vm._e(),_vm._v(" "),(_vm.imageUrl)?_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){_vm.sendLogo($event)}}},[_vm._v("\n                Update logo\n                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1):_vm._e(),_vm._v(" "),(_vm.imageUrl)?_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"error"},nativeOn:{"click":function($event){_vm.resetImage($event)}}},[_vm._v("\n                Cancel\n              ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Phone","rules":_vm.rules.phoneValidation,"required":""},model:{value:(_vm.agency.user.phone),callback:function ($$v) {_vm.$set(_vm.agency.user, "phone", $$v)},expression:"agency.user.phone"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Website","required":""},model:{value:(_vm.agency.user.website),callback:function ($$v) {_vm.$set(_vm.agency.user, "website", $$v)},expression:"agency.user.website"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning"},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Update")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.alert.message)+"\n            ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y9oe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YE/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YMJ9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YWt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlansShow_vue__ = __webpack_require__("xRPz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d286773_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlansShow_vue__ = __webpack_require__("Qlto");
function injectStyle (ssrContext) {
  __webpack_require__("p95A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d286773"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlansShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d286773_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlansShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YwHY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":"","grid-list-xl":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-flex',{class:_vm.resize,attrs:{"xs12":"","sm12":"","md10":"","lg5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":_vm.color}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),(!_vm.isAgencyDeleted)?_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Agency Details")]):_c('v-toolbar-title',{staticClass:"white--text",attrs:{"color":"red"}},[_vm._v("Agency has been deleted")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isAgencyDeleted)?_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":function($event){_vm.editAgency(_vm.agencyData)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.agencyData.is_provider !== '1' && !_vm.isAgencyDeleted)?_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","flat":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirm your action")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete this agency?"),_c('br'),_vm._v("This action can not be reverted.")]),_vm._v(" "),_c('v-card-text',[_vm._v("Please enter and confirm your password.")]),_vm._v(" "),_c('v-form',{ref:"form",model:{value:(_vm.validAcc),callback:function ($$v) {_vm.validAcc=$$v},expression:"validAcc"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Enter your password","min":"8","rules":_vm.rules.passwordRules,"append-icon":_vm.visibility ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibility = !_vm.visibility); },"type":_vm.visibility ? 'password' : 'text',"counter":""},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Confirm your password","min":"8","rules":_vm.rules.passwordRulesConfirm,"append-icon":_vm.visibilityConfirm ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibilityConfirm = !_vm.visibilityConfirm); },"type":_vm.visibilityConfirm ? 'password' : 'text',"counter":""},model:{value:(_vm.user.confirm_password),callback:function ($$v) {_vm.$set(_vm.user, "confirm_password", $$v)},expression:"user.confirm_password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.color},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"disabled":!_vm.validAcc,"color":"red"},nativeOn:{"click":function($event){_vm.checkPassword(); _vm.closeDialog(); }}},[_vm._v("\n                    Confirm\n                  ")])],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-media',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":"150px","tile":false}},[_c('img',{attrs:{"src":_vm.agencyData.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-card-title',{staticClass:"black--text"},[_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.agencyData.company)+"  ")])]),_vm._v(" "),(_vm.providerAgency)?_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("account_balance")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.providerAgency))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Provider")])],1)],1):_vm._e(),_vm._v(" "),(_vm.providerAgency)?_c('v-divider',{attrs:{"inset":""}}):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("fingerprint")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.id))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("ID")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("work")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyType))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Agency Type")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("account_box")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.first_name)+" "+_vm._s(_vm.agencyData.last_name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Contact person")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.email))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Email")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.city))]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.address))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.agencyData.country)+" "+_vm._s(_vm.agencyData.zip_code))])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agencyData.phone))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Phone")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("$ "+_vm._s(_vm.agencyData.balance))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Current Balance")]),_vm._v(" "),(!_vm.isAgencyDeleted)?_c('v-btn',{attrs:{"color":_vm.color,"dark":"","small":"","absolute":"","right":"","fab":""},on:{"click":_vm.adjustBalance}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),(this.agencyData.is_provider === '1')?_c('v-toolbar',{attrs:{"color":_vm.color}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Provided Agencies")])],1):_vm._e(),_vm._v(" "),(this.agencyData.is_provider === '1')?_c('v-card',{staticClass:"elevation-1"},[_c('v-card-title',[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-flex',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.providedAgencies,"search":_vm.search,"loading":_vm.loading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"justify-center":"","align-left":""}},[_c('v-flex',[_c('v-avatar',{attrs:{"tile":false}},[_c('img',{attrs:{"src":props.item.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company || "something"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.approved)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.is_disabled)))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":_vm.color},on:{"click":function($event){_vm.showAgency(props.item)}}},[_vm._v("\n                        show\n                      ")])],1)],1)],1),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"black"},on:{"click":function($event){_vm.editAgency(props.item)}}},[_vm._v("\n                        edit\n                      ")])],1)],1)],1),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"error"},on:{"click":function($event){_vm.removeProvidedAgency(props.item.id)}}},[_vm._v("\n                        remove\n                      ")])],1)],1)],1)]}}])})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-flex',[_c('v-card-title',[_c('v-flex',{attrs:{"xs12":"","lg4":""}},[_c('v-select',{attrs:{"items":_vm.agencies,"label":"Select Agency","item-text":"company","item-value":"id","bottom":"","autocomplete":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.company)+" "+_vm._s(data.item.id))])],1)]]}}]),model:{value:(_vm.selectedAgency),callback:function ($$v) {_vm.selectedAgency=$$v},expression:"selectedAgency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"block":"","small":"","dark":"","color":_vm.color},on:{"click":function($event){_vm.addAgency(_vm.selectedAgency)}}},[_vm._v("\n                  Add Agency\n                ")])],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n      "+_vm._s(_vm.alert.message)+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZU8h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZcHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Transaction report")])],1),_vm._v(" "),_c('v-flex',[_c('v-card-title',[_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg3":""}},[_c('v-select',{attrs:{"items":_vm.agencies,"label":"Agencies","item-text":"company","item-value":"id","bottom":"","autocomplete":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.company)+" "+_vm._s(data.item.id))])],1)]]}}]),model:{value:(_vm.selectedAgency),callback:function ($$v) {_vm.selectedAgency=$$v},expression:"selectedAgency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.typeItems,"item-text":"name","item-value":"value","label":"Type","bottom":""},model:{value:(_vm.typeSelected),callback:function ($$v) {_vm.typeSelected=$$v},expression:"typeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.searchFilter}},[_vm._v(" Search\n            ")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":_vm.rows,"pagination":_vm.pagination,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.created_at))]),_vm._v(" "),(props.item.type === 'ADJUSTMENT' && Math.sign(props.item.amount) === 1)?_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),(props.item.type === 'CANCEL' )?_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),(props.item.type === 'ADJUSTMENT' && Math.sign(props.item.amount) === -1)?_c('td',{staticClass:"text-xs-center red--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),(props.item.type === 'SALE')?_c('td',{staticClass:"text-xs-center red--text"},[_vm._v("$ "+_vm._s(props.item.amount))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("furs")(props.item.type)))]),_vm._v(" "),(props.item.type === 'SALE' || props.item.type === 'CANCEL')?_c('td',{staticClass:"text-xs-center"},[_c('router-link',{attrs:{"to":'/agency/issued_policies/show/' + props.item.policy.uuid}},[_vm._v(_vm._s(props.item.policy.uuid))])],1):_vm._e(),_vm._v(" "),(props.item.type === 'ADJUSTMENT')?_c('td',{staticClass:"text-xs-center"},[_vm._v("-")]):_vm._e(),_vm._v(" "),(props.item.type === 'SALE' || props.item.type === 'CANCEL')?_c('td',{staticClass:"text-xs-center"},[_vm._v("-")]):_vm._e(),_vm._v(" "),(props.item.type === 'ADJUSTMENT')?_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.actor.company || props.item.actor.email))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('router-link',{attrs:{"to":'/agency/agencies/show/' + props.item.account.id}},[_vm._v(_vm._s(props.item.account.company))])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))])]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n            Showing "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+" Total: "+_vm._s(_vm.items.length)+"\n          ")]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aapp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      search: "",
      pagination: {},
      counter: 0,
      dateFrom: __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      calculated: null,
      agencies: [{ company: 'All', id: null }],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [{ name: 'All', value: null }, { name: 'Adjustment', value: 'ADJUSTMENT' }, { name: 'Sale', value: 'SALE' }, { name: 'Cancel', value: 'CANCEL' }],
      searchQuery: ''
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "pagination", {
      sortBy: 'id'
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "headers", [{
      text: "Transaction ID",
      value: "id",
      sortable: true,
      align: "center"
    }, {
      text: "Date",
      value: "date",
      sortable: false,
      align: "cetner" }, {
      text: "Credit/Debit",
      value: "type",
      sortable: false,
      align: "center"
    }, {
      text: "Type",
      value: "type",
      sortable: false,
      align: "center"
    }, {
      text: "Insurance policy",
      value: "total",
      sortable: false,
      align: "center"
    }, {
      text: "Creator",
      value: "canceled",
      sortable: false,
      align: "center"
    }, { text: "Agency",
      value: "total",
      sortable: false,
      align: "center"
    }, {
      text: "Description",
      value: "holder",
      sortable: false,
      align: "center"
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "items", []), _ref;
  },

  filters: {
    booleanify: function booleanify(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    },
    formatId: function formatId(value) {
      return value.substring(2);
    },
    furs: function furs(string) {
      var smalling = string.toLowerCase();
      var uppin = smalling.charAt(0).toUpperCase() + smalling.slice(1);
      return uppin;
    }
  },
  methods: {
    getTransactions: function getTransactions() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/transactions").then(function (response) {
        _this.items = response.data.transactions;
        _this.loading = false;
      });
    },
    getAgencies: function getAgencies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/agencies").then(function (res) {
        for (var user in res.data.users) {
          _this2.agencies.push(res.data.users[user]);
        }
      });
    },
    buildQuery: function buildQuery() {
      this.searchQuery = '';
      if (this.selectedAgency) {
        this.searchQuery += 'agency_id=' + this.selectedAgency + "&";
      }
      if (this.typeSelected) {
        this.searchQuery += 'type=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery += 'from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery += 'to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter: function searchFilter() {
      var _this3 = this;

      this.loading = true;
      this.items = {};
      this.buildQuery();
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/transactions?" + this.searchQuery).then(function (response) {
        _this3.items = response.data.transactions;
        _this3.loading = false;
      });
    }
  },
  created: function created() {
    this.getTransactions();
    this.getAgencies();
    this.pagination.descending = !this.pagination.descending;
  }
});

/***/ }),

/***/ "ad3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminsNew_vue__ = __webpack_require__("sFIB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_692690f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminsNew_vue__ = __webpack_require__("e0Zp");
function injectStyle (ssrContext) {
  __webpack_require__("ptf8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-692690f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminsNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_692690f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminsNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bMfB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-toolbar',{attrs:{"color":"primary","dark":"","fixed":""}},[_c('v-toolbar-title',[_vm._v("Songa Insurance")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center",staticStyle:{"margin-left":"auto"}},[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.routeHandler('login')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("lock_open")]),_vm._v("\n            Login\n            ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.routeHandler('register')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("person_add")]),_vm._v("\n                Register\n            ")],1)],1)],1),_vm._v(" "),_c('main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c0mh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("NSul");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ada79a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("s+GN");
function injectStyle (ssrContext) {
  __webpack_require__("kHV7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ada79a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ada79a1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c1PA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    var _this = this;

    return {
      validPass: true,
      rules: {
        fieldRules: [function (v) {
          return !!v || "Field is required";
        }],
        phoneValidation: [function (v) {
          return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
          );
        }],
        passwordRules: [function (v) {
          return v.length >= 8 || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return v == _this.user.new_password || "Password not confirmed";
        }]
      },
      visibility: true,
      visibilityConfirm: true,
      oldConfrim: true,
      confirmNewPass: "",
      user: {
        email: "",
        old_password: "",
        new_password: ""
      },
      alert: {
        status: false,
        message: "",
        type: ""
      }
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    alerting: function alerting() {
      var _this2 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this2.alert.status = !_this2.alert.status;
      }, 2500);
    },
    getMe: function getMe() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/me').then(function (res) {
        _this3.user.email = res.data.email;
      });
    },
    post: function post() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/change-own-password", this.user).then(function (res) {
        _this4.alert.message = "Password has been updated.";
        _this4.alert.type = "success";
        _this4.alerting();
        setTimeout(function () {
          _this4.$auth.destroyToken();
          _this4.$router.push('/auth/login');
        }, 4000);
      }).catch(function (err) {
        _this4.alert.message = err.response.data.message;
        _this4.alert.type = "error";
        _this4.alerting();
      });
    }
  },
  created: function created() {
    this.getMe();
  }
});

/***/ }),

/***/ "cCh5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesBalance_vue__ = __webpack_require__("wi0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed1e88c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesBalance_vue__ = __webpack_require__("1iI0");
function injectStyle (ssrContext) {
  __webpack_require__("eUg1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ed1e88c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesBalance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ed1e88c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesBalance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cfn2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: "",
      loading: true,
      headers: [{ text: "ID", value: "id", sortable: false, align: "center" }, { text: "Name", value: "name", sortable: false, align: "center" }, { text: "Email", value: "email", sortable: false, align: "center" }],
      items: [],
      alert: false,
      dialog: false,
      id: ''
    };
  },

  methods: {
    getAdmins: function getAdmins() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/admins").then(function (response) {
        _this.items = response.data.users;
        _this.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.dialog = !this.dialog;
    },
    alerting: function alerting() {
      var _this2 = this;

      this.alert = !this.alert;
      setTimeout(function () {
        _this2.alert = !_this2.alert;
      }, 2500);
    },
    newAdmin: function newAdmin() {
      this.$router.push("/admin/admins/new");
    },
    userId: function userId(id) {
      this.id = id;
    },
    editItem: function editItem(item) {
      this.$router.push({ path: "/admin/admins/edit/" + item.id });
    },
    deleteItem: function deleteItem(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete("/users/" + id).then(function (response) {
        _this3.alerting();
        _this3.getAdmins();
      });
    }
  },
  created: function created() {
    this.getAdmins();
  }
});

/***/ }),

/***/ "d1y/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesShow_vue__ = __webpack_require__("x84x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f508fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesShow_vue__ = __webpack_require__("YwHY");
function injectStyle (ssrContext) {
  __webpack_require__("fnWH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51f508fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51f508fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dO4R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e/C9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__("hmVv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b34de4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__("n/jG");
function injectStyle (ssrContext) {
  __webpack_require__("gXZe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42b34de4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42b34de4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e0Zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs7":"","md5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Create Admin")])],1),_vm._v(" "),_c('v-card-title',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("First Name:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"name":"input-1","label":"First Name"},model:{value:(_vm.admin.user.first_name),callback:function ($$v) {_vm.$set(_vm.admin.user, "first_name", $$v)},expression:"admin.user.first_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Last Name:")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"name":"input-1","label":"Last Name"},model:{value:(_vm.admin.user.last_name),callback:function ($$v) {_vm.$set(_vm.admin.user, "last_name", $$v)},expression:"admin.user.last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Email")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"name":"input-1","label":"Email"},model:{value:(_vm.admin.user.email),callback:function ($$v) {_vm.$set(_vm.admin.user, "email", $$v)},expression:"admin.user.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Password")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{attrs:{"name":"input-10-1","label":"Password","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"counter":""},model:{value:(_vm.admin.user.password),callback:function ($$v) {_vm.$set(_vm.admin.user, "password", $$v)},expression:"admin.user.password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){$event.preventDefault();_vm.post($event)}}},[_vm._v("Create")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('v-alert',{attrs:{"color":"error","icon":"warning","value":_vm.alert,"transition":"scale-transition"}},[_vm._v("\n        User with the same email adress already exist.\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e3aa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eEZG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssuedShow_vue__ = __webpack_require__("sn0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cabbbec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IssuedShow_vue__ = __webpack_require__("uFDE");
function injectStyle (ssrContext) {
  __webpack_require__("o3vl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cabbbec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IssuedShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cabbbec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IssuedShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eL8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md7":"","lg5":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Update Agency")])],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("Account Info")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v("Location")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v("Company Details")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"First Name","required":""},model:{value:(_vm.agency.user.first_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "first_name", $$v)},expression:"agency.user.first_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Last Name","required":""},model:{value:(_vm.agency.user.last_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "last_name", $$v)},expression:"agency.user.last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"E-mail","required":""},model:{value:(_vm.agency.user.email),callback:function ($$v) {_vm.$set(_vm.agency.user, "email", $$v)},expression:"agency.user.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Enter new password","min":"8","rules":_vm.rules.passwordRules,"append-icon":_vm.visibility ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibility = !_vm.visibility); },"type":_vm.visibility ? 'password' : 'text',"counter":""},model:{value:(_vm.agency.user.password),callback:function ($$v) {_vm.$set(_vm.agency.user, "password", $$v)},expression:"agency.user.password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"name":"input-8-1","label":"Confirm new password","min":"8","rules":_vm.rules.passwordRulesConfirm,"append-icon":_vm.visibilityConfirm ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.visibilityConfirm = !_vm.visibilityConfirm); },"type":_vm.visibilityConfirm ? 'password' : 'text',"counter":""},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"true-value":'1',"false-value":'0',"label":"Approved"},model:{value:(_vm.agency.user.approved),callback:function ($$v) {_vm.$set(_vm.agency.user, "approved", $$v)},expression:"agency.user.approved"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"true-value":'1',"false-value":'0',"label":"Provider"},model:{value:(_vm.agency.user.is_provider),callback:function ($$v) {_vm.$set(_vm.agency.user, "is_provider", $$v)},expression:"agency.user.is_provider"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Update")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-select',{staticClass:"input-group",attrs:{"items":_vm.states,"label":"Country","item-value":"text","autocomplete":"","required":""},model:{value:(_vm.agency.user.country),callback:function ($$v) {_vm.$set(_vm.agency.user, "country", $$v)},expression:"agency.user.country"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"City","required":""},model:{value:(_vm.agency.user.city),callback:function ($$v) {_vm.$set(_vm.agency.user, "city", $$v)},expression:"agency.user.city"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Address","required":""},model:{value:(_vm.agency.user.address),callback:function ($$v) {_vm.$set(_vm.agency.user, "address", $$v)},expression:"agency.user.address"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Zip Code","required":""},model:{value:(_vm.agency.user.zip_code),callback:function ($$v) {_vm.$set(_vm.agency.user, "zip_code", $$v)},expression:"agency.user.zip_code"}})],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning"},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Update")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Back")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Company","required":""},model:{value:(_vm.agency.user.company),callback:function ($$v) {_vm.$set(_vm.agency.user, "company", $$v)},expression:"agency.user.company"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[(_vm.imageUrl || _vm.agency.user.logo_url)?_c('img',{attrs:{"src":_vm.imageUrl || _vm.agency.user.logo_url,"height":"150"}}):_vm._e(),_vm._v(" "),(!_vm.selectedFile)?_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"info"},nativeOn:{"click":function($event){_vm.pickFile($event)}}},[_vm._v("\n                          Select Logo\n                          "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("attach_file")])],1):_vm._e(),_vm._v(" "),(!_vm.selectedFile)?_c('input',{ref:"image",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFileSelected}}):_vm._e(),_vm._v(" "),(_vm.imageUrl)?_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){_vm.sendLogo($event)}}},[_vm._v("\n                          Update logo\n                          "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1):_vm._e(),_vm._v(" "),(_vm.imageUrl)?_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"error"},nativeOn:{"click":function($event){_vm.resetImage($event)}}},[_vm._v("\n                          Cancel\n                        ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Phone","rules":_vm.rules.phoneValidation,"required":""},model:{value:(_vm.agency.user.phone),callback:function ($$v) {_vm.$set(_vm.agency.user, "phone", $$v)},expression:"agency.user.phone"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Website","required":""},model:{value:(_vm.agency.user.website),callback:function ($$v) {_vm.$set(_vm.agency.user, "website", $$v)},expression:"agency.user.website"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning"},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Update")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n        "+_vm._s(_vm.alert.message)+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eUg1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eqvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_Auth_vue__ = __webpack_require__("0nzY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login_vue__ = __webpack_require__("c0mh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Register_vue__ = __webpack_require__("Keya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_Reset_vue__ = __webpack_require__("1INv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_ResetPass_vue__ = __webpack_require__("mIVK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_admin_Views_AdminFront_vue__ = __webpack_require__("zADa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_admin_Admins_Admins_vue__ = __webpack_require__("tOzQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_admin_Admins_AdminsEdit_vue__ = __webpack_require__("AIGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_admin_Admins_AdminsNew_vue__ = __webpack_require__("ad3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_admin_Agencies_Agencies_vue__ = __webpack_require__("7LYs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_admin_Agencies_AgenciesEdit_vue__ = __webpack_require__("5fSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_admin_Agencies_AgenciesNew_vue__ = __webpack_require__("leK4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_admin_Agencies_AgenciesBalance_vue__ = __webpack_require__("cCh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_admin_Agencies_AgenciesShow_vue__ = __webpack_require__("d1y/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_admin_Agencies_AgenciesSubShow_vue__ = __webpack_require__("Mcgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_Agencies_AgenciesApprove_vue__ = __webpack_require__("5jUa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_admin_Plans_Plans_vue__ = __webpack_require__("tdIa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_admin_Plans_PlansShow_vue__ = __webpack_require__("YWt/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_admin_Plans_PlansEdit_vue__ = __webpack_require__("1lqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_admin_Policies_Policies_vue__ = __webpack_require__("9/bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_admin_Policies_PoliciesShow_vue__ = __webpack_require__("L/VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_admin_Transactions_Transactions_vue__ = __webpack_require__("MQgg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_admin_Summary_Summary_vue__ = __webpack_require__("e/C9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_admin_Sales_Sales_vue__ = __webpack_require__("+ra9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_agency_Agencies_Agencies_vue__ = __webpack_require__("7MiB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_agency_Agencies_AgenciesEdit_vue__ = __webpack_require__("EBEb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_agency_Agencies_AgenciesEditPass_vue__ = __webpack_require__("To2K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_agency_Agencies_AgenciesNew_vue__ = __webpack_require__("ioVp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_agency_Agencies_AgenciesShow_vue__ = __webpack_require__("qLfF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_agency_Views_AgencyFront_vue__ = __webpack_require__("ukpj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_agency_Account_Account_vue__ = __webpack_require__("/vzY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_agency_Agencies_AgenciesBalanceProvider_vue__ = __webpack_require__("8iil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_agency_Policy_NewPolicy_NewPolicy_vue__ = __webpack_require__("jdwT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_agency_Policy_NewPolicy_NewPolicyTurkey_vue__ = __webpack_require__("jumo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_agency_Policy_Issued_Issued_vue__ = __webpack_require__("5LHe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_agency_Policy_Issued_IssuedShow_vue__ = __webpack_require__("eEZG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_agency_Transactions_Transactions_vue__ = __webpack_require__("6rNO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_agency_Sales_Sales_vue__ = __webpack_require__("sD6E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_agency_Summary_Summary_vue__ = __webpack_require__("9kNH");


//import Auth





//Admin section
//import Admin views

//Import Admins features



//import Agencies page











//import Policies page


//import Transactions page

//import Summary page

//import Sales page

//End of Admin section

// Agency/Provider section
//import Provider pages






//import Universal feature










//End of Agency/Provider section

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/admin",
    component: __WEBPACK_IMPORTED_MODULE_7__components_admin_Views_AdminFront_vue__["a" /* default */],
    redirect: "/admin/agencies",
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    },
    children: [{
      path: "admins",
      component: __WEBPACK_IMPORTED_MODULE_8__components_admin_Admins_Admins_vue__["a" /* default */],
      children: [],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "admins/new",
      component: __WEBPACK_IMPORTED_MODULE_10__components_admin_Admins_AdminsNew_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "admins/edit/:id",
      component: __WEBPACK_IMPORTED_MODULE_9__components_admin_Admins_AdminsEdit_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "agencies",
      component: __WEBPACK_IMPORTED_MODULE_11__components_admin_Agencies_Agencies_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "agencies/new",
      component: __WEBPACK_IMPORTED_MODULE_13__components_admin_Agencies_AgenciesNew_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "agencies/edit/:id",
      component: __WEBPACK_IMPORTED_MODULE_12__components_admin_Agencies_AgenciesEdit_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "agencies/balance/:id",
      component: __WEBPACK_IMPORTED_MODULE_14__components_admin_Agencies_AgenciesBalance_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "agencies/show/:id",
      component: __WEBPACK_IMPORTED_MODULE_15__components_admin_Agencies_AgenciesShow_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "agencies/subagency/show/:id",
      component: __WEBPACK_IMPORTED_MODULE_16__components_admin_Agencies_AgenciesSubShow_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "agencies/approve",
      component: __WEBPACK_IMPORTED_MODULE_17__components_admin_Agencies_AgenciesApprove_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "policies",
      component: __WEBPACK_IMPORTED_MODULE_21__components_admin_Policies_Policies_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "policies/show/:uuid",
      component: __WEBPACK_IMPORTED_MODULE_22__components_admin_Policies_PoliciesShow_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "plans",
      component: __WEBPACK_IMPORTED_MODULE_18__components_admin_Plans_Plans_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "plans/show/:id",
      component: __WEBPACK_IMPORTED_MODULE_19__components_admin_Plans_PlansShow_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "plans/edit/:id",
      component: __WEBPACK_IMPORTED_MODULE_20__components_admin_Plans_PlansEdit_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "transaction",
      component: __WEBPACK_IMPORTED_MODULE_23__components_admin_Transactions_Transactions_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "sales",
      component: __WEBPACK_IMPORTED_MODULE_25__components_admin_Sales_Sales_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }, {
      path: "summary",
      component: __WEBPACK_IMPORTED_MODULE_24__components_admin_Summary_Summary_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: true
      }
    }]
  }, {
    path: "/",
    redirect: "/agency"
  }, {
    path: "/agency",
    component: __WEBPACK_IMPORTED_MODULE_31__components_agency_Views_AgencyFront_vue__["a" /* default */],
    meta: {
      requiresAuth: true
    },
    redirect: '/agency/issued_policies',
    children: [{
      path: "new_insurance",
      component: __WEBPACK_IMPORTED_MODULE_34__components_agency_Policy_NewPolicy_NewPolicy_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "new_insurance_turkey",
      component: __WEBPACK_IMPORTED_MODULE_35__components_agency_Policy_NewPolicy_NewPolicyTurkey_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "issued_policies",
      component: __WEBPACK_IMPORTED_MODULE_36__components_agency_Policy_Issued_Issued_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "issued_policies/show/:id",
      component: __WEBPACK_IMPORTED_MODULE_37__components_agency_Policy_Issued_IssuedShow_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "account",
      component: __WEBPACK_IMPORTED_MODULE_32__components_agency_Account_Account_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "agencies",
      component: __WEBPACK_IMPORTED_MODULE_26__components_agency_Agencies_Agencies_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "agencies/new",
      component: __WEBPACK_IMPORTED_MODULE_29__components_agency_Agencies_AgenciesNew_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "agencies/edit/:id",
      component: __WEBPACK_IMPORTED_MODULE_27__components_agency_Agencies_AgenciesEdit_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "agencies/edit/password/:id",
      component: __WEBPACK_IMPORTED_MODULE_28__components_agency_Agencies_AgenciesEditPass_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "agencies/balance/:id",
      component: __WEBPACK_IMPORTED_MODULE_33__components_agency_Agencies_AgenciesBalanceProvider_vue__["a" /* default */],
      meta: {
        requiresAuth: true,
        requiresAdmin: false
      }
    }, {
      path: "agencies/show/:id",
      component: __WEBPACK_IMPORTED_MODULE_30__components_agency_Agencies_AgenciesShow_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "transaction",
      component: __WEBPACK_IMPORTED_MODULE_38__components_agency_Transactions_Transactions_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "sales",
      component: __WEBPACK_IMPORTED_MODULE_39__components_agency_Sales_Sales_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }, {
      path: "summary",
      component: __WEBPACK_IMPORTED_MODULE_40__components_agency_Summary_Summary_vue__["a" /* default */],
      meta: {
        requiresAuth: true
      }
    }]
  }, {
    path: "/auth",
    component: __WEBPACK_IMPORTED_MODULE_2__components_auth_Auth_vue__["a" /* default */],
    redirect: "/auth/login",
    children: [{
      path: "login",
      component: __WEBPACK_IMPORTED_MODULE_3__components_auth_Login_vue__["a" /* default */],
      meta: {
        requiresGuest: true
      }
    }, {
      path: "register",
      component: __WEBPACK_IMPORTED_MODULE_4__components_auth_Register_vue__["a" /* default */],
      meta: {
        requiresGuest: true
      }
    }, {
      path: "reset",
      component: __WEBPACK_IMPORTED_MODULE_5__components_auth_Reset_vue__["a" /* default */],
      meta: {
        requiresGuest: true
      }
    }, {
      path: "reset-password/token/:token",
      component: __WEBPACK_IMPORTED_MODULE_6__components_auth_ResetPass_vue__["a" /* default */],
      meta: {
        requiresGuest: true
      }
    }]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "fnWH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g+nL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Sales report")])],1),_vm._v(" "),_c('v-flex',[_c('v-card-title',[_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg1":""}},[_c('v-select',{attrs:{"items":_vm.accountType,"label":"Type","item-text":"account","item-value":"accountValue","bottom":""},model:{value:(_vm.accountTypeSelected),callback:function ($$v) {_vm.accountTypeSelected=$$v},expression:"accountTypeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg1":""}},[_c('v-select',{attrs:{"items":_vm.country,"label":"Country","item-text":"country","item-value":"countryValue","bottom":""},model:{value:(_vm.countrySelected),callback:function ($$v) {_vm.countrySelected=$$v},expression:"countrySelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.agencies,"label":"Agencies","item-text":"company","item-value":"id","bottom":"","autocomplete":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.company)+" "+_vm._s(data.item.id))])],1)]]}}]),model:{value:(_vm.selectedAgency),callback:function ($$v) {_vm.selectedAgency=$$v},expression:"selectedAgency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg1":""}},[_c('v-select',{attrs:{"items":_vm.typeItems,"item-text":"name","item-value":"value","label":"Status","bottom":""},model:{value:(_vm.typeSelected),callback:function ($$v) {_vm.typeSelected=$$v},expression:"typeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},on:{"input":function($event){_vm.dateFormatted = _vm.formatDate($event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.searchFilter}},[_vm._v(" Search\n            ")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":_vm.rows,"loading":_vm.loading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.index+1))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("isProvider")(props.item.is_provider)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.company))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("removeTime")(props.item.created_at)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.insurance_type))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.policy_uuid))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.people_count))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("status")(props.item.cancelled)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(_vm._f("minusRemover")(props.item.amount)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.first_name)+" "+_vm._s(props.item.last_name))])]}}])},[_c('template',{attrs:{"slot":"footer"},slot:"footer"},[_c('td',{staticClass:"text-xs-center"},[_c('strong',[_vm._v("\n                Total:\n              ")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-xs-center green--text"},[_c('strong',[_vm._v("\n                $ "+_vm._s(_vm.sum)+"\n              ")])]),_vm._v(" "),_c('td')])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g98S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md7":"","lg4":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Create Agency")])],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("Account Info")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v("Company Details")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v("Location")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-form',{ref:"form",model:{value:(_vm.validAcc),callback:function ($$v) {_vm.validAcc=$$v},expression:"validAcc"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"First Name","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.first_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "first_name", $$v)},expression:"agency.user.first_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Last Name","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.last_name),callback:function ($$v) {_vm.$set(_vm.agency.user, "last_name", $$v)},expression:"agency.user.last_name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.rules.emailRules,"required":""},model:{value:(_vm.agency.user.email),callback:function ($$v) {_vm.$set(_vm.agency.user, "email", $$v)},expression:"agency.user.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Password","append-icon":_vm.e2 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e2 = !_vm.e2); },"type":_vm.e2 ? 'password' : 'text',"rules":_vm.rules.passwordRules,"counter":""},model:{value:(_vm.agency.user.password),callback:function ($$v) {_vm.$set(_vm.agency.user, "password", $$v)},expression:"agency.user.password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-checkbox',{attrs:{"true-value":'1',"false-value":'0',"label":"Provider"},model:{value:(_vm.agency.user.is_provider),callback:function ($$v) {_vm.$set(_vm.agency.user, "is_provider", $$v)},expression:"agency.user.is_provider"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validAcc},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Continue")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-form',{ref:"form",model:{value:(_vm.validDetails),callback:function ($$v) {_vm.validDetails=$$v},expression:"validDetails"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Company","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.company),callback:function ($$v) {_vm.$set(_vm.agency.user, "company", $$v)},expression:"agency.user.company"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Logo URL","required":""},model:{value:(_vm.agency.user.logo_url),callback:function ($$v) {_vm.$set(_vm.agency.user, "logo_url", $$v)},expression:"agency.user.logo_url"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Phone","rules":_vm.rules.phoneValidation,"required":""},model:{value:(_vm.agency.user.phone),callback:function ($$v) {_vm.$set(_vm.agency.user, "phone", $$v)},expression:"agency.user.phone"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Website","required":""},model:{value:(_vm.agency.user.website),callback:function ($$v) {_vm.$set(_vm.agency.user, "website", $$v)},expression:"agency.user.website"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validDetails},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Back")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-form',{ref:"form",model:{value:(_vm.validLocation),callback:function ($$v) {_vm.validLocation=$$v},expression:"validLocation"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-select',{attrs:{"items":_vm.states,"label":"Country","item-value":"text","rules":_vm.rules.fieldRules,"autocomplete":"","required":""},model:{value:(_vm.agency.user.country),callback:function ($$v) {_vm.$set(_vm.agency.user, "country", $$v)},expression:"agency.user.country"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"City","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.city),callback:function ($$v) {_vm.$set(_vm.agency.user, "city", $$v)},expression:"agency.user.city"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Address","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.address),callback:function ($$v) {_vm.$set(_vm.agency.user, "address", $$v)},expression:"agency.user.address"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-text-field',{attrs:{"label":"Zip Code","rules":_vm.rules.fieldRules,"required":""},model:{value:(_vm.agency.user.zip_code),callback:function ($$v) {_vm.$set(_vm.agency.user, "zip_code", $$v)},expression:"agency.user.zip_code"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.validLocation},nativeOn:{"click":function($event){_vm.post($event)}}},[_vm._v("Create")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")])],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-alert',{staticClass:"auth",attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.alert.message)+"\n            ")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gXZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ggn8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'auth',
    data: function data() {
        return {};
    },

    methods: {
        routeHandler: function routeHandler(route) {
            this.$router.push('/auth/' + route);
        }
    }
});

/***/ }),

/***/ "hmVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      pagination: {},
      dateFrom: null,
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      search: '',
      agencies: [{ company: 'All', id: null }],
      selectedAgency: null,
      typeSelected: null,
      typeItems: [{ name: 'All', value: null }, { name: 'Booked', value: 'false' }, { name: 'Cancelled', value: 'true' }],
      accountTypeSelected: null,
      accountType: [{ account: 'All', accountValue: null }, { account: 'Agency', accountValue: 'agency' }, { account: 'Provider', accountValue: 'provider' }],
      searchQuery: '',
      headers: [{
        text: "No.",
        align: "center",
        sortable: false,
        value: "id"
      }, {
        text: "Account Type",
        value: "accountType",
        sortable: false,
        align: "cetner"
      }, {
        text: "Agency",
        value: "agency",
        sortable: false,
        align: "center"
      }, {
        text: "Insurance Policies Sold",
        value: "soldPolicies",
        sortable: false,
        align: "center"
      }, {
        text: "Total",
        value: "total",
        sortable: false,
        align: "center"
      }],
      items: []
    };
  },

  filters: {
    isProvider: function isProvider(value) {
      if (value == 0) {
        value = "Agency";
      } else {
        value = "Provider";
      }
      return value;
    },
    minusRemover: function minusRemover(string) {
      return string.replace('-', '');
    }
  },
  methods: {
    getSummary: function getSummary() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/reports/summary").then(function (response) {
        _this.items = response.data.reports;
        _this.loading = false;
      });
    },
    getAgencies: function getAgencies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (res) {
        for (var user in res.data.users) {
          if (res.data.users[user].is_disabled !== 1) {
            _this2.agencies.push(res.data.users[user]);
          }
        }
      });
    },
    goToPolicy: function goToPolicy(id) {
      this.$router.push({ path: "/admin/policies/show/" + id });
    },
    buildQuery: function buildQuery() {
      this.searchQuery = '';
      if (this.accountTypeSelected) {
        this.searchQuery += 'account_type=' + this.accountTypeSelected + '&';
      }
      if (this.selectedAgency) {
        this.searchQuery += 'agency=' + this.selectedAgency + "&";
      }
      if (this.typeSelected) {
        this.searchQuery += 'cancelled=' + this.typeSelected + "&";
      }
      if (this.dateFrom) {
        this.searchQuery += 'date_from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        this.searchQuery += 'date_to=' + this.dateTo + "&";
      }
      this.searchQuery = this.searchQuery.slice(0, -1);
    },
    searchFilter: function searchFilter() {
      var _this3 = this;

      this.loading = true;
      this.items = {};
      this.buildQuery();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/reports/summary?" + this.searchQuery).then(function (response) {
        _this3.items = response.data.reports;
        _this3.loading = false;
      });
    }
  },
  created: function created() {
    this.getAgencies();
    this.getSummary();
  }
});

/***/ }),

/***/ "hulT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true,
      search: "",
      dateFrom: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'month').format("YYYY-MM-DD"),
      menuFrom: null,
      dateTo: null,
      menuTo: null,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      searchQuery: '',
      pagination: {},
      headers: [{
        text: "ID",
        align: "center",
        sortable: false,
        value: "uuid"
      }, { text: 'Created At', value: 'created_at', sortable: true, align: 'center' }, {
        text: "Insurance Type",
        align: "left",
        sortable: false,
        value: "insurance_type"
      }, {
        text: "Beneficiary",
        align: "center",
        sortable: false,
        value: "fullName"
      }, {
        text: "Passport No",
        align: "center",
        sortable: false,
        value: "passport"
      }, {
        text: "Country Residence",
        align: "center",
        sortable: false,
        value: "country_residence"
      }, {
        text: "Country Destination",
        align: "center",
        sortable: false,
        value: "country_destination"
      }, {
        text: "From",
        align: "center",
        sortable: false,
        value: "duration_from"
      }, {
        text: "To",
        align: "center",
        sortable: false,
        value: "duration_to"
      }, {
        text: 'Cancelled',
        sortable: false,
        align: 'cancelled',
        value: 'canceled'
      }],
      items: []
    };
  },

  filters: {
    booleanify: function booleanify(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    },
    removeTime: function removeTime(value) {
      return value.substring(0, value.length - 9);
    }
  },
  methods: {
    showPolicy: function showPolicy(item) {
      this.$router.push({ path: "/agency/issued_policies/show/" + item.uuid });
    },
    buildQuery: function buildQuery() {
      var str = '?';
      if (this.dateFrom) {
        str += 'date_from=' + this.dateFrom + "&";
      }
      if (this.dateTo) {
        str += 'date_to=' + this.dateTo + "&";
      }
      str = str.slice(0, -1);
      this.searchQuery = str;
    },
    getPolicies: function getPolicies() {
      var _this = this;

      this.loading = true;
      this.buildQuery();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/policies" + this.searchQuery).then(function (response) {
        _this.loading = false;
        _this.items = response.data.policies;
        _this.items.forEach(function (element, index) {
          element.people.forEach(function (person, ind) {
            _this.items[index]['fullName' + ind] = person.first_name + ' ' + person.middle_name + ' ' + person.last_name;
            _this.items[index]['passport' + ind] = person.passport_number;
          });
        });
        _this.pagination.descending = true;
      });
    }
  },
  created: function created() {
    this.getPolicies();
  }
});

/***/ }),

/***/ "i/LN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      admin: {
        "user": {
          "email": "",
          "first_name": "",
          "last_name": "",
          "password": ""
        }
      },
      valid: true,
      confirmPassword: "",
      visibility: true,
      visibilityConfirm: true,
      rules: {
        fieldRules: [function (v) {
          return !!v || "Field is required";
        }],
        phoneValidation: [function (v) {
          return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
          );
        }],
        passwordRules: [function (v) {
          return v.length >= 8 || !v || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return v == _this.admin.user.password || !v || "Password not confirmed";
        }, function (v) {
          return v.length >= 8 || !v || "Password must be at least 8 characters";
        }],
        emailRules: [function (v) {
          return (/\S+@\S+\.\S+/.test(v) || "E-mail must be valid"
          );
        }]
      },
      e1: true,
      alert: false
    };
  },

  mounted: function mounted() {
    this.getAdmin();
  },
  watch: {
    "admin.user.password": function adminUserPassword(val) {
      this.confirmPassword = '';
      if (val && val !== this.confirmPassword) {
        this.valid = false;
      } else if (!val && !this.confirmPassword) {
        this.valid = true;
      } else if (val && this.admin.user.password === val) {
        this.valid = true;
      } else {
        return false;
      }
    },
    confirmPassword: function confirmPassword(val) {
      if (val !== "" && val === this.admin.user.password) {
        this.valid = true;
      } else if (!val && !this.admin.user.password) {
        this.valid = true;
      } else {
        this.valid = false;
      }
    }
  },
  methods: {
    alerting: function alerting() {
      var _this2 = this;

      this.alert = !this.alert;
      setTimeout(function () {
        _this2.alert = !_this2.alert;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.push("/admin/admins");
    },
    getAdmin: function getAdmin() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/users/" + this.$route.params.id).then(function (res) {
        _this3.admin.user = res.data.user;
      });
    },
    post: function post() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/users/' + this.$route.params.id, this.admin).then(function (res) {
        _this4.alerting();
      });
    }
  }
});

/***/ }),

/***/ "iNl1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ieRD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_countryCodes_js__ = __webpack_require__("mbGk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a
  },
  data: function data() {
    var _this = this;

    return {
      imageName: "",
      imageUrl: "",
      selectedFile: "",
      confirmPassword: "",
      visibility: true,
      visibilityConfirm: true,
      valid: true,
      agency: {
        user: {
          password: null
        }
      },
      rules: {
        fieldRules: [function (v) {
          return !!v || "Field is required";
        }],
        phoneValidation: [function (v) {
          return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
          );
        }],
        passwordRules: [function (v) {
          return v.length >= 8 || !v || "Password must be at least 8 characters";
        }],
        passwordRulesConfirm: [function (v) {
          return v == _this.agency.user.password || !v || "Password not confirmed";
        }, function (v) {
          return v.length >= 8 || !v || "Password must be at least 8 characters";
        }],
        emailRules: [function (v) {
          return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
          );
        }]
      },
      e1: 0,
      dataLoading: true,
      alert: {
        status: false,
        message: "",
        type: ""
      },
      states: __WEBPACK_IMPORTED_MODULE_3__helpers_countryCodes_js__["a" /* countryCodesSingle */]
    };
  },

  mounted: function mounted() {
    this.getAgency();
  },
  watch: {
    "agency.user.password": function agencyUserPassword(val) {
      this.confirmPassword = '';
      if (val && val !== this.confirmPassword) {
        this.valid = false;
      } else if (!val && !this.agency.user.confirmPassword) {
        this.valid = true;
      } else if (val && this.agency.user.password === val) {
        this.valid = true;
      } else {
        return false;
      }
    },
    confirmPassword: function confirmPassword(val) {
      if (val !== "" && val === this.agency.user.password) {
        this.valid = true;
      } else if (!val && !this.agency.user.password) {
        this.valid = true;
      } else {
        this.valid = false;
      }
    }
  },
  methods: {
    resetImage: function resetImage() {
      var fr = new FileReader();
      this.imageName = "";
      this.selectedFile = "";
      this.imageUrl = "";
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onFileSelected: function onFileSelected(event) {
      var _this2 = this;

      var files = event.target.files[0];
      this.selectedFile = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(files);

      var fr = new FileReader();
      fr.readAsDataURL(files);
      fr.addEventListener("load", function () {
        _this2.imageUrl = fr.result;
      });
    },
    sendLogo: function sendLogo() {
      var _this3 = this;

      var fd = new FormData();
      fd.append("image", this.selectedFile);
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/upload", fd).then(function (res) {
        _this3.agency.user.logo_url = res.data.url;
        _this3.post(true);
        _this3.resetImage();
      }).catch(function (error) {
        if (error.response.data.errors[0].detail === "validation.dimensions") {
          _this3.alert.message = "Logo dimension should not be bigger than 500x500 px";
        } else {
          _this3.alert.message = "Logo size should not exceed 2mb";
        }
        _this3.alert.type = "error";
        _this3.alerting();
      });
    },
    goBack: function goBack() {
      this.$router.push("/agency/agencies");
    },
    getAgency: function getAgency() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/users/" + this.$route.params.id).then(function (res) {
        _this4.agency.user = res.data.user;
        _this4.dataLoading = "false";
      });
    },
    alerting: function alerting() {
      var _this5 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this5.alert.status = !_this5.alert.status;
      }, 2500);
    },
    post: function post() {
      var _this6 = this;

      var isImage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/users/" + this.$route.params.id, this.agency).then(function (res) {
        _this6.alert.message = isImage === true ? "Logo has been changed." : "Agency has been updated.";
        _this6.alert.type = "success";
        _this6.alerting();
      });
    }
  }
});

/***/ }),

/***/ "ioVp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesNew_vue__ = __webpack_require__("Ny8f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d39be6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesNew_vue__ = __webpack_require__("6BWr");
function injectStyle (ssrContext) {
  __webpack_require__("EZ9g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d39be6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jdwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPolicy_vue__ = __webpack_require__("p/wV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3531c9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPolicy_vue__ = __webpack_require__("mF/O");
function injectStyle (ssrContext) {
  __webpack_require__("Bgat")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3531c9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3531c9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jumo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPolicyTurkey_vue__ = __webpack_require__("wo1C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12769d41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPolicyTurkey_vue__ = __webpack_require__("14Ez");
function injectStyle (ssrContext) {
  __webpack_require__("MGmC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12769d41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPolicyTurkey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12769d41_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPolicyTurkey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k+H9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Agencies")])],1),_vm._v(" "),_c('v-card-title',[_c('v-flex',{staticClass:"pt-3 pl-4",attrs:{"xs12":"","lg2":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search by ID","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":_vm.newAgency}},[_vm._v("New Agency\r\n          "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-badge',{attrs:{"overlap":"","color":"red"}},[(_vm.approvedCounter > 0)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.approvedCounter))]):_vm._e()])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"loading":_vm.loading,"custom-filter":_vm.customFilter,"hide-actions":"","no-results-text":"We could not find agency based on your search."},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',[_c('v-avatar',{attrs:{"size":_vm.avatarSize,"tile":false}},[_c('img',{attrs:{"src":props.item.logo_url || _vm.defaultLogo,"alt":"logo"}})])],1)],1)],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company || "something"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.approved)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.is_disabled)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.is_provider)))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"primary"},on:{"click":function($event){_vm.showAgency(props.item)}}},[_vm._v("\r\n                      show\r\n                      ")])],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":""},on:{"click":function($event){_vm.editAgency(props.item)}}},[_vm._v("edit\r\n                      ")])],1),_vm._v(" "),(props.item.is_disabled === '1')?_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"warning"}},[_vm._v("Disabled\r\n                      ")])],1):_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"red"},on:{"click":function($event){_vm.disableUser(props.item.id)}}},[_vm._v("Disable\r\n                      ")])],1)],1)],1)]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\r\n            Showing "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+" Total: "+_vm._s(_vm.items.length)+"\r\n          ")]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k/0z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kHV7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "leK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesNew_vue__ = __webpack_require__("2lq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502e6d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesNew_vue__ = __webpack_require__("g98S");
function injectStyle (ssrContext) {
  __webpack_require__("reKX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_502e6d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lig9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Agencies")])],1),_vm._v(" "),_c('v-flex',[_c('v-card-title',[_c('v-flex',{attrs:{"xs12":"","lg3":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search by ID","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex align-center hidden-md-and-down",staticStyle:{"margin-left":"auto"}},[_c('v-btn',{attrs:{"block":"","color":"primary","dark":""},on:{"click":_vm.newAgency}},[_vm._v("New Agency\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-badge',{attrs:{"overlap":"","color":"red"}},[(_vm.approvedCounter > '0')?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.approvedCounter))]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"pl3",on:{"click":_vm.approveAgency}},[_vm._v("Approval")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-lg-and-up",attrs:{"xs12":"","lg2":""}},[_c('v-btn',{attrs:{"block":"","color":"primary","dark":""},on:{"click":_vm.newAgency}},[_vm._v("New Agency\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-lg-and-up",attrs:{"xs12":"","lg2":""}},[_c('v-btn',{staticClass:"pl3",attrs:{"block":""},on:{"click":_vm.approveAgency}},[_vm._v("Approval\n             "),(_vm.approvedCounter > 0)?_c('v-badge',{staticClass:"ml-2",attrs:{"color":"red"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.approvedCounter))])]):_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("check")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"loading":_vm.loading,"custom-filter":_vm.customFilter,"rows-per-page-items":_vm.rows,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',[_c('v-avatar',{attrs:{"size":_vm.avatarSize,"tile":false}},[_c('img',{attrs:{"src":props.item.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company || "something"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{class:[props.item.approved === '0' ? _vm.classObject.texterror : false, _vm.classObject.text]},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.approved)))]),_vm._v(" "),_c('td',{class:[props.item.is_disabled === '1' ? _vm.classObject.texterror : false, _vm.classObject.text]},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.is_disabled)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("booleanify")(props.item.is_provider)))]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"primary"},on:{"click":function($event){_vm.showAgency(props.item)}}},[_vm._v("\n                  show\n                  ")])],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":""},on:{"click":function($event){_vm.editAgency(props.item)}}},[_vm._v("edit\n                  ")])],1),_vm._v(" "),(props.item.is_disabled === '1')?_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"green"},on:{"click":function($event){_vm.enableUser(props.item.id)}}},[_vm._v("Enable\n                  ")])],1):_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"red"},on:{"click":function($event){_vm.disableUser(props.item.id)}}},[_vm._v("Disable\n                  ")])],1)],1)],1)]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n        Showing "+_vm._s(pageStart)+" to "+_vm._s(pageStop)+" Total: "+_vm._s(_vm.items.length)+"\n      ")]}}])})],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.alert.message)+"\n            ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mF/O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":""}},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("New Policy")])],1),_vm._v(" "),_c('div',[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1}},[_vm._v("New Policy")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2}},[_vm._v(" Insurance Plan")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.e1 > 3}},[_vm._v("Travel Details")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4","complete":_vm.e1 > 4}},[_vm._v("Quotation")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"5","complete":_vm.e1 > 5}},[_vm._v("Beneficiary Details")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"6"}},[_vm._v("Confirmation")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-form',{ref:"newpolicy",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Beneficiary Type:")]),_vm._v(" "),_c('v-radio-group',{attrs:{"rules":_vm.inputRules},model:{value:(_vm.policy.insurance_type),callback:function ($$v) {_vm.$set(_vm.policy, "insurance_type", $$v)},expression:"policy.insurance_type"}},[_c('v-radio',{attrs:{"label":"Single","value":"Single","name":"beneficiary"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Family","value":"Family","name":"beneficaryType"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Group","value":"Group","name":"beneficaryType"}})],1)],1)],1),_vm._v(" "),(_vm.policy.insurance_type === 'Family')?_c('div',{attrs:{"row":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Parents:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.policy.insurance_type === 'Family' } }),expression:"{ rules: { required: policy.insurance_type === 'Family' } }"}],attrs:{"prepend-icon":_vm.policy.total_parents === 1 ? 'person' : 'people',"items":_vm.inputParents,"label":"Select","single-line":"","item-value":"number","data-vv-name":"parents","rules":[function (v) { return !!v || 'Please, select a proper value.'; }],"mandatory":true,"bottom":"","required":""},model:{value:(_vm.policy.total_parents),callback:function ($$v) {_vm.$set(_vm.policy, "total_parents", $$v)},expression:"policy.total_parents"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Kids:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.policy.insurance_type === 'Family' } }),expression:"{ rules: { required: policy.insurance_type === 'Family' } }"}],attrs:{"prepend-icon":"face","label":"Number of kids","data-vv-name":"number of kids","rules":[function (v) { return !!_vm.policy.total_parents || 'Please, enter a number of kids.'; }],"required":""},model:{value:(_vm.policy.total_children),callback:function ($$v) {_vm.$set(_vm.policy, "total_children", _vm._n($$v))},expression:"policy.total_children"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.policy.insurance_type === 'Group')?_c('div',{attrs:{"row":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Number of people:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:({ rules: { required: _vm.policy.insurance_type === 'Group' } }),expression:"{ rules: { required: policy.insurance_type === 'Group' } }"}],attrs:{"prepend-icon":"group_add","label":"People","data-vv-name":"Input people","rules":[function (v) { return (!!v && v>1) || 'Please, enter a number of people. Must be greater than 1.'; }],"required":""},model:{value:(_vm.policy.total_persons),callback:function ($$v) {_vm.$set(_vm.policy, "total_persons", _vm._n($$v))},expression:"policy.total_persons"}})],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.addToPersons(); _vm.validateNewPolicy(); _vm.checkToken();}}},[_vm._v("Continue")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-form',{ref:"insuranceplan",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('span',[_vm._v("Insurance Plan")]),_vm._v(" "),_c('span',[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-select',{attrs:{"prepend-icon":"assignment","items":_vm.insurancePlans,"item-text":"name","item-value":"id","label":"Select insurance plan","max-height":"","multi-line":"","rules":[function (v) { return !!v || 'Please, select a plan.'; }],"bottom":"","required":""},model:{value:(_vm.policy.insurance_plan_id),callback:function ($$v) {_vm.$set(_vm.policy, "insurance_plan_id", $$v)},expression:"policy.insurance_plan_id"}})],1)],1)],1),_vm._v(" "),_vm._l((_vm.policy.persons),function(person,key){return _c('span',{key:person,staticClass:"mt-3"},[(key === 0)?_c('span',[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.policy.total_parents > 1 && key == 1)?_c('span',[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 1 && key !== 0))?_c('span',[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 2 && key !== 0 && key !== 1))?_c('span',[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.policy.total_children && !_vm.policy.total_parents && key != 0)?_c('span',[_vm._v(" User "+_vm._s(key))]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.policy.persons[key].menu),callback:function ($$v) {_vm.$set(_vm.policy.persons[key], "menu", $$v)},expression:"policy.persons[key].menu"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-icon":"date_range","label":"Date of birth","rules":_vm.dateOfBirthRule,"readonly":"","required":""},slot:"activator",model:{value:(person['date_of_birth']),callback:function ($$v) {_vm.$set(person, 'date_of_birth', $$v)},expression:"person['date_of_birth']"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","allowed-dates":_vm.years},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(person['date_of_birth']),callback:function ($$v) {_vm.$set(person, 'date_of_birth', $$v)},expression:"person['date_of_birth']"}})],1)],1)],1)],1)})],2)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.validateInsurancePlan(); _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-form',{ref:"traveldetails",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',[_vm._v("Residence:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"prepend-icon":"flag","items":_vm.states,"label":"Country","rules":[function (v) { return !!v || 'Please, select a country of residence.'; }],"autocomplete":"","bottom":"","required":""},model:{value:(_vm.policy.country_residence),callback:function ($$v) {_vm.$set(_vm.policy, "country_residence", $$v)},expression:"policy.country_residence"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',[_vm._v("Destination:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{staticClass:"input-group",attrs:{"prepend-icon":"map","items":_vm.statesTo,"label":"Country","rules":[function (v) { return !!v || 'Please, select a country of destination.'; }],"autocomplete":"","required":""},model:{value:(_vm.policy.country_destination),callback:function ($$v) {_vm.$set(_vm.policy, "country_destination", $$v)},expression:"policy.country_destination"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',[_c('span',[_vm._v("Duration:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.policy.duration_fromMenu),callback:function ($$v) {_vm.$set(_vm.policy, "duration_fromMenu", $$v)},expression:"policy.duration_fromMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From","prepend-icon":"event","rules":[function (v) { return !!v || 'Please, select a date.'; }],"readonly":""},slot:"activator",model:{value:(_vm.policy.duration_from),callback:function ($$v) {_vm.$set(_vm.policy, "duration_from", $$v)},expression:"policy.duration_from"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","disabled":"","allowed-dates":_vm.durationFrom},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.policy.duration_from),callback:function ($$v) {_vm.$set(_vm.policy, "duration_from", $$v)},expression:"policy.duration_from"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg5":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.policy.duration_toMenu),callback:function ($$v) {_vm.$set(_vm.policy, "duration_toMenu", $$v)},expression:"policy.duration_toMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To","prepend-icon":"event","rules":[function (v) { return !!v || 'Please, select a date.'; }],"readonly":""},slot:"activator",model:{value:(_vm.policy.duration_to),callback:function ($$v) {_vm.$set(_vm.policy, "duration_to", $$v)},expression:"policy.duration_to"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":"","disabled":"","allowed-dates":_vm.durationFrom},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.policy.duration_to),callback:function ($$v) {_vm.$set(_vm.policy, "duration_to", $$v)},expression:"policy.duration_to"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.quoteCalculator(); _vm.validateTraveDetails(); _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Quotation")])],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Plan")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.getPlanName))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Insurance Type")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.insurance_type))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of residence")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_residence))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of destination")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_destination))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date from")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_from))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date to")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_to))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Duration")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.duration)+" days")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Price")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("$ "+_vm._s(_vm.policy.amount))])],1)],1)],1),_vm._v(" "),_c('v-divider')],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.e1++; _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_vm._l((_vm.policy.persons),function(person,key){return _c('span',{key:key},[_c('v-layout',{attrs:{"mt-3":""}},[_c('v-flex',[(key === 0)?_c('span',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.policy.total_parents > 1 && key == 1)?_c('span',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 1 && key !== 0))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 2 && key !== 0 && key !== 1))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.policy.total_children && !_vm.policy.total_parents && key != 0)?_c('span',{staticClass:"headline"},[_vm._v(" User "+_vm._s(key))]):_vm._e()])],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"First Name","rules":_vm.inputRules,"required":""},model:{value:(person.first_name),callback:function ($$v) {_vm.$set(person, "first_name", $$v)},expression:"person.first_name"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Middle Name","rules":_vm.inputRules,"required":""},model:{value:(person.middle_name),callback:function ($$v) {_vm.$set(person, "middle_name", $$v)},expression:"person.middle_name"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Last Name","rules":_vm.inputRules,"required":""},model:{value:(person.last_name),callback:function ($$v) {_vm.$set(person, "last_name", $$v)},expression:"person.last_name"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"prepend-icon":"picture_in_picture","label":"Passport Number","rules":_vm.inputRules,"required":""},model:{value:(person.passport_number),callback:function ($$v) {_vm.$set(person, "passport_number", $$v)},expression:"person.passport_number"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',[_c('span',{attrs:{"prepend-icon":"email"}},[_vm._v("Gender:")])]),_vm._v(" "),_c('v-flex',[_c('span',[_c('v-radio-group',{attrs:{"rules":[function (v) { return !!v || 'Please, select a gender.'; }],"mandatory":true,"row":""},model:{value:(person.gender),callback:function ($$v) {_vm.$set(person, "gender", $$v)},expression:"person.gender"}},[_c('v-radio',{attrs:{"label":"Male","value":"M"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Female","value":"F"}})],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',[_c('v-flex',[_c('span',[_vm._v("Do you have any pre-existing medical condition?")])]),_vm._v(" "),_c('v-flex',{attrs:{"mt-2":""}},[_c('v-switch',{attrs:{"label":person.has_existing_medical_condition ? 'Yes' : 'No',"value":""},model:{value:(person.has_existing_medical_condition),callback:function ($$v) {_vm.$set(person, "has_existing_medical_condition", $$v)},expression:"person.has_existing_medical_condition"}})],1),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-flex',[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Please explain your condition","textarea":"","rules":[function (v) { return !!v || 'This field is required.'; }]},model:{value:(person.existing_medical_condition),callback:function ($$v) {_vm.$set(person, "existing_medical_condition", $$v)},expression:"person.existing_medical_condition"}})],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-2":""}},[_c('v-flex',[_c('v-flex',[_c('span',[_vm._v("Medical coverage with an insurance company in "+_vm._s(_vm.policy.country_residence)+"?")])]),_vm._v(" "),_c('v-flex',{attrs:{"mt-2":""}},[_c('v-switch',{attrs:{"label":person.has_medical_insurance_in_country_of_residence ? 'Yes' : 'No',"value":""},model:{value:(person.has_medical_insurance_in_country_of_residence),callback:function ($$v) {_vm.$set(person, "has_medical_insurance_in_country_of_residence", $$v)},expression:"person.has_medical_insurance_in_country_of_residence"}})],1),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-flex',[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Please state name and expire date","textarea":"","rules":[function (v) { return !!v || 'This field is required.'; }]},model:{value:(person.medical_insurance_in_country_of_residence),callback:function ($$v) {_vm.$set(person, "medical_insurance_in_country_of_residence", $$v)},expression:"person.medical_insurance_in_country_of_residence"}})],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":""}},[_c('v-flex',[_c('span',{staticClass:"headline"},[_vm._v("Contact info")])])],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"prepend-icon":"email","label":"Contact email","rules":_vm.emailRules,"required":""},model:{value:(_vm.policy.email),callback:function ($$v) {_vm.$set(_vm.policy, "email", $$v)},expression:"policy.email"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"prepend-icon":"phone","label":"Contact phone","rules":_vm.phoneValidation,"required":""},model:{value:(_vm.policy.phone),callback:function ($$v) {_vm.$set(_vm.policy, "phone", $$v)},expression:"policy.phone"}})],1)],2)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){_vm.validateLastForm(); _vm.checkToken();}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"6"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Quotation")])],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Plan")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.getPlanName))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Insurance Type")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.insurance_type))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of residence")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_residence))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Country of destination")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.country_destination))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date from")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_from))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date to")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.policy.duration_to))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Duration")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.duration)+" days")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Price")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("$ "+_vm._s(_vm.policy.amount))])],1)],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_vm._l((_vm.policy.persons),function(person,key){return _c('v-card',{key:key},[_c('v-divider'),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[(key === 0)?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.policy.total_parents > 1 && key == 1)?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 1 && key !== 0))?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.policy.total_children && (_vm.policy.total_parents === 2 && key !== 0 && key !== 1))?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.policy.total_children && !_vm.policy.total_parents && key != 0)?_c('v-toolbar-title',{staticClass:"headline"},[_vm._v(" User "+_vm._s(key))]):_vm._e()],1),_vm._v(" "),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("First Name")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.first_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Middle Name")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.middle_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Last Name")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.last_name))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Passport Number")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.passport_number))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date of birth")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.date_of_birth))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Gender")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(person.gender))])],1)],1),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-divider'):_vm._e(),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Pre Existing Medical Condition")])],1)],1):_vm._e(),_vm._v(" "),(person.has_existing_medical_condition)?_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Explanation","textarea":"","readonly":""},model:{value:(person.existing_medical_condition),callback:function ($$v) {_vm.$set(person, "existing_medical_condition", $$v)},expression:"person.existing_medical_condition"}})],1)]):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-divider'):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Medical coverage with an insurance company in "+_vm._s(_vm.policy.country_residence))])],1)],1):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence)?_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('span',[_c('v-text-field',{attrs:{"name":"input-7-1","label":"Explanation","textarea":"","readonly":""},model:{value:(person.medical_insurance_in_country_of_residence),callback:function ($$v) {_vm.$set(person, "medical_insurance_in_country_of_residence", $$v)},expression:"person.medical_insurance_in_country_of_residence"}})],1)]):_vm._e()],1)],1)})],2)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.disabledFinal,"color":"warning"},nativeOn:{"click":function($event){_vm.savePolicy(); _vm.checkToken();}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},nativeOn:{"click":function($event){_vm.goBack(); _vm.checkToken();}}},[_vm._v("Back")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-alert',{attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n        "+_vm._s(_vm.alert.message)+"\n      ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mIVK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPass_vue__ = __webpack_require__("TEkg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f990cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPass_vue__ = __webpack_require__("LCHv");
function injectStyle (ssrContext) {
  __webpack_require__("wJLP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f990cb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f990cb8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mIhx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__("097D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha___default.a },
  data: function data() {
    return {
      valid: false,
      email: '',
      rules: {
        emailRules: [function (v) {
          return !!v || "E-mail is required";
        }, function (v) {
          return (/\S+@\S+\.\S+/.test(v) || "E-mail must be valid"
          );
        }]
      },
      e1: true,
      alert: {
        status: false,
        message: '',
        type: ''
      },
      errorMessage: ''
    };
  },
  methods: {
    alerting: function alerting() {
      var _this = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this.alert.status = !_this.alert.status;
      }, 5000);
    },
    reset: function reset() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/token/request', {
        email: this.email
      }).then(function (res) {
        vm.alert.message = 'Check your email and follow the instructions to change your password.';
        vm.alert.type = 'success';
        vm.alerting();
      }).catch(function (err) {
        vm.alert.message = 'There was an error, please contact administrator.';
        vm.alert.type = 'error';
        vm.alerting();
      });
    }
  }
});

/***/ }),

/***/ "mbGk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return countriesTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryCodesSingle; });
var countriesTo = ["Iraq", "Africa", "Asia (excluding Japan)", "Central America", "Central and South Pacific (excluding Australia)", "Europe", "Europe (shengen)", "Middle East and North Africa", "South America", "Worldwide (excluding LB, US, CA, AU, JP)", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia & Herzegovina", "Botswana", "Brazil", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Myanmar/Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominican Republic", "Dominica", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "French Guiana", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Great Britain", "Greece", "Grenada", "Guadeloupe", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Israel and the Occupied Territories", "Italy", "Ivory Coast (Cote d'Ivoire)", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kosovo", "Kuwait", "Kyrgyz Republic (Kyrgyzstan)", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Republic of Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Korea, Democratic Republic of (North Korea)", "Norway", "Oman", "Pacific Islands", "Pakistan", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent's & Grenadines", "Samoa", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovak Republic (Slovakia)", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Korea, Republic of (South Korea)", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor Leste", "Togo", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos Islands", "Uganda", "Ukraine", "United Arab Emirates", "United States of America (USA)", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (UK)", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];

var countryCodesSingle = ["Iraq", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia & Herzegovina", "Botswana", "Brazil", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Myanmar/Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominican Republic", "Dominica", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "French Guiana", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Great Britain", "Greece", "Grenada", "Guadeloupe", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Israel and the Occupied Territories", "Italy", "Ivory Coast (Cote d'Ivoire)", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kosovo", "Kuwait", "Kyrgyz Republic (Kyrgyzstan)", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Republic of Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Korea, Democratic Republic of (North Korea)", "Norway", "Oman", "Pacific Islands", "Pakistan", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent's & Grenadines", "Samoa", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovak Republic (Slovakia)", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Korea, Republic of (South Korea)", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor Leste", "Togo", "Trinidad & Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks & Caicos Islands", "Uganda", "Ukraine", "United Arab Emirates", "United States of America (USA)", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (UK)", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"];

/***/ }),

/***/ "muFA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n/jG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Summary report")])],1),_vm._v(" "),_c('v-flex',[_c('v-card-title',[_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.accountType,"label":"Account Type","item-text":"account","item-value":"accountValue","bottom":""},model:{value:(_vm.accountTypeSelected),callback:function ($$v) {_vm.accountTypeSelected=$$v},expression:"accountTypeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.agencies,"label":"Agencies","item-text":"company","item-value":"id","bottom":"","autocomplete":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.company)+" "+_vm._s(data.item.id))])],1)]]}}]),model:{value:(_vm.selectedAgency),callback:function ($$v) {_vm.selectedAgency=$$v},expression:"selectedAgency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.typeItems,"item-text":"name","item-value":"value","label":"Type","bottom":""},model:{value:(_vm.typeSelected),callback:function ($$v) {_vm.typeSelected=$$v},expression:"typeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},on:{"input":function($event){_vm.dateFormatted = _vm.formatDate($event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.searchFilter}},[_vm._v(" Search\n            ")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":_vm.rows,"loading":_vm.loading},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.index+1))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("isProvider")(props.item.is_provider)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.company))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.insurance_policies_sold))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(_vm._f("minusRemover")(props.item.total)))])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o3vl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oHAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Summary report")])],1),_vm._v(" "),_c('v-flex',[_c('v-card-title',[_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.accountType,"label":"Account Type","item-text":"account","item-value":"accountValue","bottom":""},model:{value:(_vm.accountTypeSelected),callback:function ($$v) {_vm.accountTypeSelected=$$v},expression:"accountTypeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.agencies,"label":"Agencies","item-text":"company","item-value":"id","bottom":"","autocomplete":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.company)+" "+_vm._s(data.item.id))])],1)]]}}]),model:{value:(_vm.selectedAgency),callback:function ($$v) {_vm.selectedAgency=$$v},expression:"selectedAgency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-select',{attrs:{"items":_vm.typeItems,"item-text":"name","item-value":"value","label":"Type","bottom":""},model:{value:(_vm.typeSelected),callback:function ($$v) {_vm.typeSelected=$$v},expression:"typeSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuFrom),callback:function ($$v) {_vm.menuFrom=$$v},expression:"menuFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date from:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},on:{"input":function($event){_vm.dateFormatted = _vm.formatDate($event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-3 pl-3",attrs:{"xs12":"","lg2":""}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"max-width":"290px","min-width":"290px"},model:{value:(_vm.menuTo),callback:function ($$v) {_vm.menuTo=$$v},expression:"menuTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date to:","prepend-icon":"event"},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":"","actions":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var save = ref.save;
var cancel = ref.cancel;
return [_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":cancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":save}},[_vm._v("OK")])],1)]}}]),model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-5",attrs:{"xs12":"","lg1":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","right":"","block":""},on:{"click":_vm.searchFilter}},[_vm._v(" Search\n            ")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"rows-per-page-items":_vm.rows,"loading":_vm.loading},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.index+1))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("isProvider")(props.item.is_provider)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.company))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.insurance_policies_sold))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center green--text"},[_vm._v("$ "+_vm._s(_vm._f("minusRemover")(props.item.total)))])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oVyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || "Input too long!";
      },
      tmp: "",
      search: "",
      pagination: {},
      rows: [10, 15, 25, { text: "All", value: -1 }],
      loading: true,
      headers: [{
        text: "Short Name",
        align: "left",
        sortable: false,
        value: "name"
      }, {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name"
      }],
      items: []
    };
  },

  methods: {
    editPlan: function editPlan(item) {
      this.$router.push({ path: "/admin/plans/edit/" + item.id });
    },
    showPlan: function showPlan(item) {
      this.$router.push({ path: "/admin/plans/show/" + item.id });
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/insuranceplans").then(function (response) {
      _this.items = response.data.insurancePlans;
      _this.loading = false;
    });
  }
});

/***/ }),

/***/ "otUq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p/wV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_countryCodes_js__ = __webpack_require__("mbGk");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      alert: {
        status: false,
        message: '',
        type: ''
      },
      years: {
        min: null,
        max: null
      },
      durationFrom: {
        min: null,
        max: null
      },
      maxAge: null,
      valid: true,
      disabledFinal: false,
      phoneValidation: [function (v) {
        return !!v || "Phone number is required";
      }, function (v) {
        return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
        );
      }],
      inputRules: [function (v) {
        return !!v || "Input field is required";
      }],
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/\S+@\S+\.\S+/.test(v) || "E-mail must be valid"
        );
      }],
      dateOfBirthRule: [function (v) {
        return 80 > __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(v, 'years', false) || "This person is over age limit.";
      }, function (v) {
        return !!v || 'Please, select a date of birth.';
      }],
      e1: 1,
      allPersonsValid: true,
      name: '',
      beneficaryType: false,
      date: null,
      menu: false,
      modal: false,
      duration: "",
      inputParents: [{ text: "Single Parent", number: 1 }, { text: "Both Parents", number: 2 }],
      personObj: {
        date_of_birth: null,
        menu: null,
        first_name: "",
        middle_name: "",
        last_name: "",
        passport_number: "",
        gender: "",
        has_existing_medical_condition: false,
        existing_medical_condition: "",
        has_medical_insurance_in_country_of_residence: false,
        medical_insurance_in_country_of_residence: ""
      },
      policy: {
        insurance_plan_id: "",
        insurance_type: "",
        total_parents: null,
        total_children: null,
        total_persons: null,
        country_residence: "",
        country_destination: "",
        duration_from: null,
        duration_fromMenu: false,
        duration_to: null,
        duration_toMenu: false,
        email: "",
        phone: "",
        amount: "",
        persons: []
      },
      insurancePlans: [],
      selectedInsurancePlan: {},
      states: __WEBPACK_IMPORTED_MODULE_4__helpers_countryCodes_js__["a" /* countryCodesSingle */],
      statesTo: __WEBPACK_IMPORTED_MODULE_4__helpers_countryCodes_js__["b" /* countriesTo */]
    };
  },
  computed: {
    getPlanName: function getPlanName() {
      var _this = this;

      var planName = "";
      this.insurancePlans.forEach(function (plan) {
        if (plan.id === _this.policy.insurance_plan_id) {
          planName = plan.short_name;
        }
      });
      return planName;
    }
  },
  methods: {
    checkToken: function checkToken() {
      this.$auth.loggedIn() ? true : this.$router.push('/auth/login');
    },
    goBack: function goBack() {
      this.e1--;
    },
    alerting: function alerting() {
      this.alert.status = !this.alert.status;
    },
    redirect: function redirect(uuid) {
      this.$router.push({ path: "/agency/issued_policies/show/" + uuid });
    },
    savePolicy: function savePolicy() {
      var _this2 = this;

      var vm = this;
      this.disabledFinal = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/policies', { policy: this.policy }).then(function (res) {
        _this2.alert.message = 'Policy has been created.';
        _this2.alert.type = 'success';
        _this2.alerting();
        _this2.$root.$emit('updateBalance');
        setTimeout(function () {
          _this2.alert.status = !_this2.alert.status;
          if (_this2.allPersonsValid) {
            _this2.redirect(res.data.uuid);
          }
        }, 5000);
      }).catch(function (err) {
        _this2.disabledFinal = false;
        _this2.alert.message = err.response.data.message || 'Failed to create a policy';
        _this2.alert.type = 'error';
        _this2.alerting();
        setTimeout(function () {
          _this2.alert.status = !_this2.alert.status;
        }, 5000);
      });
    },
    validateForm: function validateForm() {
      var _this3 = this;

      this.$validator.validateAll().then(function (result) {
        if (result == true) {
          _this3.$validator.reset();
          _this3.e1++;
          return;
        }
      });
    },
    validateLastForm: function validateLastForm() {
      if (this.$refs.form.validate()) {
        this.e1++;
      }
    },
    validateNewPolicy: function validateNewPolicy() {
      if (this.$refs.newpolicy.validate()) {
        this.e1++;
      }
    },
    validateMaxAge: function validateMaxAge() {
      var _this4 = this;

      var planObj = void 0;
      var maxAgeLength = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this4;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      maxAgeLength = planObj.pricing[planObj.pricing.length - 1].end;
      this.years.min = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(maxAgeLength, "years").format('YYYY-MM-DD');
    },
    validateDurationTo: function validateDurationTo() {
      var _this5 = this;

      var planObj = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this5;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      var planObjArrLength = planObj.pricing[0].pricing.length;
      var planObjDuration = planObj.pricing[0].pricing[planObjArrLength - 1].duration;
      this.durationFrom.max = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_from).add(planObjDuration, "days").format('YYYY-MM-DD');;
    },
    validateInsurancePlan: function validateInsurancePlan() {
      if (this.$refs.insuranceplan.validate()) {
        this.e1++;
      }
    },
    validateTraveDetails: function validateTraveDetails() {
      var _this6 = this;

      var planObj = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this6;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      var planObjArrLength = planObj.pricing[0].pricing.length;
      var planObjDuration = planObj.pricing[0].pricing[planObjArrLength - 1].duration;

      if (this.$refs.traveldetails.validate() && this.allPersonsValid === true) {
        if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_to).isBefore(this.policy.duration_from) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_from).isAfter(this.policy.duration_to)) {
          this.alert.message = 'Duration From and To are not valid, please check your dates.';
          this.alert.type = 'error';
          this.alerting();
          setTimeout(function () {
            _this6.alert.status = !_this6.alert.status;
          }, 5000);
        } else if (this.duration > planObjDuration) {
          this.alert.message = "Duration should not be longer than " + planObjDuration + " days, please change your dates.";
          this.alert.type = 'error';
          this.alerting();
          setTimeout(function () {
            _this6.alert.status = !_this6.alert.status;
          }, 5000);
        } else if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_from).isBefore()) {
          this.alert.message = 'Policy starting date should not be before tomorrow.';
          this.alert.type = 'error';
          this.alerting();
          setTimeout(function () {
            _this6.alert.status = !_this6.alert.status;
          }, 5000);
        } else {
          this.e1++;
        }
      }
    },
    addToPersons: function addToPersons() {
      this.policy.persons = [];
      var vm = this;
      if (this.policy.insurance_type === "Single") {
        this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
      } else if (this.policy.insurance_type === "Family") {
        this.policy.total_persons = null;
        for (var index = 0; index < this.policy.total_parents; index++) {
          this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
        }
        for (var _index = 0; _index < this.policy.total_children; _index++) {
          this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
        }
      } else {
        this.policy.total_parents = null;
        this.policy.total_children = null;
        for (var _index2 = 0; _index2 < this.policy.total_persons; _index2++) {
          this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
        }
      }
    },
    calcPolicyDuration: function calcPolicyDuration(start, finish) {
      var pocetak = __WEBPACK_IMPORTED_MODULE_3_moment___default()(start);
      var kraj = __WEBPACK_IMPORTED_MODULE_3_moment___default()(finish);
      var result = kraj.diff(pocetak, "days");
      return result;
    },
    getPersonYear: function getPersonYear(dob) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(dob, "years");
    },
    quoteCalculator: function quoteCalculator() {
      var _this7 = this;

      // calculate duration,
      var duration = this.calcPolicyDuration(this.policy.duration_from, this.policy.duration_to);
      this.duration = duration;

      //calculate ages of the persons
      var ages = [];
      this.policy.persons.forEach(function (person) {
        ages = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ages), [_this7.getPersonYear(person.date_of_birth)]);
      });

      //get plan 
      var planObj = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this7;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      //get what duration is for that plan
      var prices = [];
      ages.map(function (personAge) {
        planObj.pricing.map(function (helperObj) {
          if (helperObj.begin <= personAge && personAge <= helperObj.end) {
            helperObj.pricing.some(function (range, index) {
              if (duration <= range.duration) {
                return prices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(prices), [parseInt(range.price)]);
              }
            });
          }
        });
      });

      //summ it all or pass one for single 
      this.policy.amount = prices.length > 1 ? prices.reduce(function (acc, cur) {
        return acc + cur;
      }, 0) : prices[0];
    },
    getPlanObject: function getPlanObject(id) {
      var _this8 = this;

      this.insurancePlans.forEach(function (plan) {
        if (plan.id === id) {
          _this8.selectedInsurancePlan = plan;
        }
      });
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/insuranceplans").then(function (response) {
      response.data.insurancePlans.map(function (plan) {
        if (plan.name !== "Turkey") {
          _this9.insurancePlans.push(plan);
        }
      });
    });
    //date calc
    this.years.min = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(80, "years").format('YYYY-MM-DD');
    this.years.max = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, "years").format('YYYY-MM-DD');
    this.durationFrom.min = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'day').format('YYYY-MM-DD');
    this.durationFrom.max = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(730, 'days').format('YYYY-MM-DD');
  },

  watch: {
    // ubaciti watchera za this.policy.insurance_plan_id i idjeti max dane, kao i srediti sve ostale duratione
    // duration from max preimeovati u duration to max i srediti 

    'policy.insurance_plan_id': function policyInsurance_plan_id(val) {
      this.validateMaxAge();
      this.validateDurationTo();
    },
    'policy.duration_from': function policyDuration_from(val) {
      this.validateDurationTo();
    }
  }
});

/***/ }),

/***/ "p95A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pCD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      classObject: {
        'texterror': 'error--text',
        'text': "text-xs-center"
      },
      loading: true,
      approvedCounter: 0,
      defaultLogo: __WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png___default.a,
      rows: [10, 15, 25, { text: "All", value: -1 }],
      search: "",
      logo: '',
      alert: {
        status: false,
        message: '',
        type: ''
      },
      pagination: {
        sortBy: 'id'
      },
      headers: [{
        text: "ID",
        align: "left",
        sortable: true,
        value: "id"
      }, {
        text: "Logo",
        align: "left",
        sortable: false,
        value: "logo"
      }, {
        text: "Company",
        align: "left",
        sortable: false,
        value: "company"
      }, {
        text: "Email",
        align: "left",
        sortable: false,
        value: "email"
      }, {
        text: "Approved",
        align: "center",
        sortable: false,
        value: "approved"
      }, {
        text: "Disabled",
        align: "center",
        sortable: false,
        value: "is_disabled"
      }, {
        text: "Provider",
        align: "center",
        sortable: false,
        value: "is_provider"
      }],
      items: []
    };
  },

  filters: {
    booleanify: function booleanify(value) {
      if (value == "0") {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    }
  },
  computed: {
    avatarSize: function avatarSize() {
      return '40px';
    }
  },
  methods: {
    customFilter: function customFilter(items, search, filter) {
      search = search.toString().toLowerCase();
      var a = items.filter(function (row) {
        return filter(row["id"], search);
      });
      if (!Array.isArray(a) || !a.length) {
        a = items.filter(function (row) {
          return filter(row["company"], search);
        });
      }
      if (!Array.isArray(a) || !a.length) {
        a = items.filter(function (row) {
          return filter(row["email"], search);
        });
      }
      return a;
    },
    alerting: function alerting() {
      var _this = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this.alert.status = !_this.alert.status;
      }, 2500);
    },
    approvingCounter: function approvingCounter() {
      var helperObj = this.items;
      this.approvedCounter = 0;
      for (var k in helperObj) {
        if (helperObj[k].approved === '0') {
          this.approvedCounter++;
        }
      }
    },
    disableUser: function disableUser(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/users/" + id, {
        user: {
          is_disabled: "1"
        }
      }).then(function (res) {
        _this2.getAgencies();
        _this2.alert.message = 'Agency has been disabled.';
        _this2.alert.type = 'success';
        _this2.alerting();
      });
    },
    enableUser: function enableUser(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/users/" + id, {
        user: {
          is_disabled: '0'
        }
      }).then(function (res) {
        _this3.getAgencies();
        _this3.alert.message = 'Agency has been enabled.';
        _this3.alert.type = 'success';
        _this3.alerting();
      });
    },
    approveAgency: function approveAgency() {
      this.$router.push({ path: '/admin/agencies/approve' });
    },
    editAgency: function editAgency(item) {
      this.$router.push({ path: '/admin/agencies/edit/' + item.id });
    },
    showAgency: function showAgency(item) {
      this.$router.push({ path: '/admin/agencies/show/' + item.id });
    },
    newAgency: function newAgency() {
      this.$router.push("/admin/agencies/new");
    },
    getAgencies: function getAgencies() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (response) {
        _this4.items = response.data.users;
        _this4.loading = false, _this4.approvingCounter();
      }).catch(function (error) {
        _this4.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getAgencies();
    this.pagination.descending = !this.pagination.descending;
  }
});

/***/ }),

/***/ "pfVq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Insurance Policy "),_c('br'),_vm._v(" "+_vm._s(_vm.insurancePolicy.uuid)+" "),(_vm.insurancePolicy.cancelled === '1')?_c('span',[_vm._v(" - Canceled")]):_vm._e()])],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('table',{attrs:{"border":"1"}},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Plan")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePlanName(_vm.insurancePolicy.insurance_plan_id)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Insurance Type")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.insurance_type))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Country of residence")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.country_residence))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Destination country")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.country_destination))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date from")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.duration_from))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date to")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.duration_to))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Days total")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.duration)+" days")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Cost")]),_vm._v(" "),_c('td',[_vm._v("$ "+_vm._s(_vm.insurancePolicy.amount))])])])])]),_vm._v(" "),_vm._l((_vm.insurancePolicy.people),function(person,key){return _c('span',{key:key},[_c('table',{staticClass:"pt-3 mt-3 mb-3",attrs:{"border":"1"}},[_c('thead',[_c('tr',[(key === 0)?_c('span',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.insurancePolicy.total_parents > 1 && key == 1)?_c('span',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.insurancePolicy.total_children && (_vm.insurancePolicy.total_parents == 1 && key !== 0))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.insurancePolicy.total_children && (_vm.insurancePolicy.total_parents == 2 && key !== 0 && key !== 1))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.insurancePolicy.total_children && !_vm.insurancePolicy.total_parents && key != 0)?_c('span',{staticClass:"headline"},[_vm._v(" User "+_vm._s(key))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("First Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.first_name))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Middle Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.middle_name))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Last Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.last_name))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Passport Number")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.passport_number))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date of birth")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.date_of_birth))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gender")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.gender))])]),_vm._v(" "),(person.has_existing_medical_condition === '1')?_c('tr',[_c('th',[_vm._v("Pre Existing Medical Condition")]),_vm._v(" "),_c('td',[_vm._v("Yes")])]):_vm._e(),_vm._v(" "),(person.has_existing_medical_condition === '1')?_c('tr',[_c('th',[_vm._v("Explanation")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.existing_medical_condition))])]):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence === '1')?_c('tr',[_c('th',[_vm._v("Medical coverage with "),_c('br'),_vm._v(" an insurance company in "+_vm._s(_vm.insurancePolicy.country_residence))]),_vm._v(" "),_c('td',[_vm._v("Yes")])]):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence === '1')?_c('tr',[_c('th',[_vm._v("Medical Explanation")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.medical_insurance_in_country_of_residence))])]):_vm._e()])])])}),_vm._v(" "),_c('span',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.policyValid && _vm.insurancePolicy.cancelled === '0')?_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"error"},slot:"activator"},[_vm._v("\n                      Cancel policy\n                    ")]):_vm._e(),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"error","dark":""}},[_c('v-toolbar-title',[_vm._v("Confirm action")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_vm._v("Are you sure you want to delete this policy?"),_c('br'),_vm._v("This action can not be reverted and money will be credited back to policy creator."),_c('br'),_vm._v("If you are sure, please confirm your action, otherwise close modal.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"error","dark":""},nativeOn:{"click":function($event){_vm.closeDialog(); _vm.cancelPolicy(_vm.insurancePolicy.uuid)}}},[_vm._v("Confirm")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning"},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),(_vm.insurancePolicy.cancelled === '0')?_c('v-btn',{attrs:{"dark":"","color":"primary"},on:{"click":function($event){_vm.downloadPdf(_vm.insurancePolicy.uuid)}}},[_vm._v("\n                      Download PDF\n                    ")]):_vm._e()],1)],1)],1)],2)],1)],1)],1),_vm._v(" "),_c('v-alert',{staticStyle:{"position":"fixed"},attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n    "+_vm._s(_vm.alert.message)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ptf8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qLfF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesShow_vue__ = __webpack_require__("JPPC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0653db61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesShow_vue__ = __webpack_require__("+lt4");
function injectStyle (ssrContext) {
  __webpack_require__("ZU8h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0653db61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgenciesShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0653db61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgenciesShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r0+j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r5R8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.dataLoading === true)?_c('spinner',{staticClass:"spinner-centered",attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-app',[(!_vm.dataLoading)?_c('v-navigation-drawer',{attrs:{"persistent":"","enable-resize-watcher":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-card-media',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-avatar',{attrs:{"size":_vm.avatarSize,"tile":false}},[_c('img',{attrs:{"src":_vm.meProps.logo_url || _vm.defaultLogo,"alt":"avatar"}})])],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',[_vm._v(_vm._s(_vm.meProps.first_name)+" "+_vm._s(_vm.meProps.last_name))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.meProps.email))])])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-list',_vm._l((_vm.menuItems),function(item){return _c('v-list-tile',{key:item.title,attrs:{"router-link":"","to":item.route}},[_c('v-list-tile-action',{attrs:{"primary":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)}))],1):_vm._e(),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"indigo","dark":"","fixed":"","app":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3",style:(_vm.$vuetify.breakpoint.smAndUp ? 'width: 300px; min-width: 250px' : 'min-width: 72px')},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',{staticClass:"hidden-xs-only"},[_vm._v("Songa Insurance")])],1),_vm._v(" "),_c('div',{staticClass:"d-flex align-center",staticStyle:{"margin-left":"auto"}},[_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("lock")]),_vm._v("\r\n            Logout\r\n          ")],1)],1)],1),_vm._v(" "),_c('main',[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('v-footer',{attrs:{"color":"indigo","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© Songa Insurance")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "reKX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rgr7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s+GN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md8":"","lg4":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Login")])],1),_vm._v(" "),_c('v-card-title',[_c('v-flex',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-mail","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"name":"input-10-1","label":"Password","hint":"At least 8 characters","min":"8","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text',"counter":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid},on:{"click":function($event){$event.preventDefault();_vm.login($event)}}},[_vm._v("\r\n              login\r\n            ")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")])],1),_vm._v(" "),_c('div',{attrs:{"row":""}},[_c('v-flex',[_c('v-alert',{staticClass:"auth",attrs:{"color":"error","icon":"check_circle","value":_vm.alert,"transition":"scale-transition"}},[_vm._v("\r\n                "+_vm._s(_vm.errorMessage)+"\r\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-footer',[_c('p',[_c('br'),_vm._v("Forgot your password? You can reset it "),_c('router-link',{attrs:{"to":"/auth/reset"}},[_vm._v("here")]),_vm._v(".")],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sD6E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sales_vue__ = __webpack_require__("ULPA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45845204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sales_vue__ = __webpack_require__("IIR/");
function injectStyle (ssrContext) {
  __webpack_require__("dO4R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45845204"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sales_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45845204_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sales_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sFIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      admin: {
        "user": {
          "email": "",
          "first_name": "",
          "last_name": "",
          "password": "",
          "is_admin": "1",
          "approved": "1"
        }
      },
      alert: false,
      e1: true
    };
  },

  methods: {
    errorAlert: function errorAlert() {
      var _this = this;

      this.alert = !this.alert;
      setTimeout(function () {
        _this.alert = !_this.alert;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.push("/admin/admins");
    },
    post: function post() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/users", this.admin).then(function (res) {
        _this2.$router.push("/admin/admins");
        _this2.goBack();
        _this2.errorAlert();
      }).catch(function (error) {
        _this2.errorAlert();
      });
    }
  }
});

/***/ }),

/***/ "sn0/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || "Input too long!";
      },
      search: "",
      dataLoading: true,
      e1: 0,
      policyValid: false,
      items: [],
      duration: null,
      insurancePolicy: [],
      insurancePlans: [],
      dialog: false,
      alert: {
        status: false,
        message: '',
        type: ''
      }
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/me").then(function (response) {
      _this.items = response.data;
      _this.getData();
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/insuranceplans").then(function (response) {
      _this2.insurancePlans = response.data.insurancePlans;
    });
  },

  methods: {
    insurancePlanName: function insurancePlanName(plan_id) {
      var plan_name = '';
      this.insurancePlans.forEach(function (element) {
        if (element.id == plan_id) {
          plan_name = element.name;
        }
      });
      return plan_name;
    },
    closeDialog: function closeDialog() {
      this.dialog = !this.dialog;
    },
    alerting: function alerting() {
      var _this3 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this3.alert.status = !_this3.alert.status;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getData: function getData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/policies/' + this.$route.params.id).then(function (response) {
        _this4.insurancePolicy = response.data.policies;
        _this4.dataLoading = false;
        _this4.duration = _this4.policyDuration(_this4.insurancePolicy.duration_from, _this4.insurancePolicy.duration_to);
      });
    },
    downloadPdf: function downloadPdf(uuid) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/policies/' + uuid + '/pdf', { responseType: 'blob' }).then(function (response) {
        var newBlob = new Blob([response.data], { type: 'application/pdf' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob, uuid + ".pdf");
          return;
        }
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = uuid + ".pdf";
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100);
      }).catch(function (error) {});
    },
    policyDuration: function policyDuration(start, finish) {
      var beg = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start);
      var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(finish);
      var result = end.diff(beg, "days");
      return result;
    },
    policyValidation: function policyValidation(start) {
      var exp = __WEBPACK_IMPORTED_MODULE_2_moment___default()(start);
      var now = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      var diffDuration = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(exp.diff(now));
      if (diffDuration.minutes() > 0) {
        return true;
      }
    }
  }
});

/***/ }),

/***/ "tOzQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admins_vue__ = __webpack_require__("cfn2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79de34c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admins_vue__ = __webpack_require__("wfvy");
function injectStyle (ssrContext) {
  __webpack_require__("OTuL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79de34c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admins_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79de34c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admins_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tdIa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plans_vue__ = __webpack_require__("oVyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bbbdd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plans_vue__ = __webpack_require__("y80d");
function injectStyle (ssrContext) {
  __webpack_require__("OS5g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Plans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19bbbdd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Plans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uFDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[(_vm.dataLoading === true)?_c('spinner',{attrs:{"line-fg-color":"#28AFAF","size":"large"}}):_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{staticClass:"white--text",attrs:{"icon":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Insurance Policy "),_c('br'),_vm._v(" "+_vm._s(_vm.insurancePolicy.uuid)+" "),(_vm.insurancePolicy.cancelled === '1')?_c('span',[_vm._v(" - Canceled")]):_vm._e()])],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('table',{attrs:{"border":"1"}},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Plan")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePlanName(_vm.insurancePolicy.insurance_plan_id)))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Insurance Type")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.insurance_type))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Country of residence")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.country_residence))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Destination country")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.country_destination))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date from")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.duration_from))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date to")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.insurancePolicy.duration_to))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Days total")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.duration)+" days")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Cost")]),_vm._v(" "),_c('td',[_vm._v("$ "+_vm._s(_vm.insurancePolicy.amount))])])])])]),_vm._v(" "),_vm._l((_vm.insurancePolicy.people),function(person,key){return _c('span',{key:key},[_c('table',{staticClass:"pt-3 mt-3 mb-3",attrs:{"border":"1"}},[_c('thead',[_c('tr',[(key === 0)?_c('span',{staticClass:"headline"},[_vm._v(" Beneficiary")]):_vm._e(),_vm._v(" "),(_vm.insurancePolicy.total_parents > 1 && key == 1)?_c('span',{staticClass:"headline"},[_vm._v(" Spouse")]):_vm._e(),_vm._v(" "),(_vm.insurancePolicy.total_children && (_vm.insurancePolicy.total_parents == 1 && key !== 0))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key))]):_vm._e(),_vm._v(" "),(_vm.insurancePolicy.total_children && (_vm.insurancePolicy.total_parents == 2 && key !== 0 && key !== 1))?_c('span',{staticClass:"headline"},[_vm._v(" Child "+_vm._s(key - 1))]):_vm._e(),_vm._v(" "),(!_vm.insurancePolicy.total_children && !_vm.insurancePolicy.total_parents && key != 0)?_c('span',{staticClass:"headline"},[_vm._v(" User "+_vm._s(key))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("First Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.first_name))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Middle Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.middle_name))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Last Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.last_name))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Passport Number")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.passport_number))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date of birth")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.date_of_birth))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Gender")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.gender))])]),_vm._v(" "),(person.has_existing_medical_condition === '1')?_c('tr',[_c('th',[_vm._v("Pre Existing Medical Condition")]),_vm._v(" "),_c('td',[_vm._v("Yes")])]):_vm._e(),_vm._v(" "),(person.has_existing_medical_condition === '1')?_c('tr',[_c('th',[_vm._v("Explanation")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.existing_medical_condition))])]):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence === '1')?_c('tr',[_c('th',[_vm._v("Medical coverage with "),_c('br'),_vm._v(" an insurance company in "+_vm._s(_vm.insurancePolicy.country_residence))]),_vm._v(" "),_c('td',[_vm._v("Yes")])]):_vm._e(),_vm._v(" "),(person.has_medical_insurance_in_country_of_residence === '1')?_c('tr',[_c('th',[_vm._v("Medical Explanation")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(person.medical_insurance_in_country_of_residence))])]):_vm._e()])])])}),_vm._v(" "),_c('span',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[(_vm.insurancePolicy.cancelled === '0')?_c('v-btn',{attrs:{"dark":"","color":"info"},on:{"click":function($event){_vm.downloadPdf(_vm.insurancePolicy.uuid)}}},[_vm._v("\n                      Download PDF\n                    ")]):_vm._e()],1)],1)],1)],2)],1)],1)],1),_vm._v(" "),_c('v-alert',{staticStyle:{"position":"fixed"},attrs:{"color":_vm.alert.type,"icon":"check_circle","value":_vm.alert.status,"transition":"scale-transition"}},[_vm._v("\n    "+_vm._s(_vm.alert.message)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQzO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyFront_vue__ = __webpack_require__("PryS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3799e10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyFront_vue__ = __webpack_require__("6bET");
function injectStyle (ssrContext) {
  __webpack_require__("AZsf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e3799e10"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyFront_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3799e10_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyFront_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2Y2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wJLP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wfvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","lg8":"","xl5":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Admins")])],1),_vm._v(" "),_c('v-card-title',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg4":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex align-center hidden-md-and-down",staticStyle:{"margin-left":"auto"}},[_c('v-card-actions',{on:{"click":function($event){_vm.newAdmin()}}},[_c('v-btn',{attrs:{"color":"primary","dark":""}},[_vm._v("New Admin\n              "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-lg-and-up",attrs:{"xs12":"","lg2":""}},[_c('v-card-actions',{on:{"click":function($event){_vm.newAdmin()}}},[_c('v-btn',{attrs:{"color":"primary","block":"","dark":""}},[_vm._v("New Admin\n              "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"search":_vm.search,"loading":_vm.loading,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.first_name)+" "+_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":""},on:{"click":function($event){_vm.editItem(props.item)}}},[_vm._v("edit\n                      ")])],1)],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"red"},on:{"click":function($event){_vm.userId(props.item.id)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirm your action")]),_vm._v(" "),_c('v-card-text',[_vm._v("Are you sure you want to delete this admin?"),_c('br'),_vm._v("This action can not be reverted")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Disagree")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","dark":""},nativeOn:{"click":function($event){_vm.closeDialog(); _vm.deleteItem(_vm.id)}}},[_vm._v("Delete")])],1)],1)],1)],1)],1)],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"alert"},[_c('v-alert',{attrs:{"color":"success","icon":"check_circle","value":_vm.alert,"transition":"scale-transition"}},[_vm._v("\n      You have successfully deleted an account.\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wi0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      alert: {
        status: false,
        message: '',
        type: ''
      },
      disableButton: false,
      user: {
        amount: "",
        description: ""
      }
    };
  },

  methods: {
    alerting: function alerting() {
      var _this = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this.disableButton = false;
        _this.alert.status = !_this.alert.status;
      }, 2500);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    adjustBallance: function adjustBallance() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/users/" + this.$route.params.id + "/adjustment", this.user).then(function (res) {
        _this2.alert.message = 'Amount adjusted.';
        _this2.alert.type = 'success';
        _this2.alerting();
        setTimeout(function () {
          _this2.goBack();
        }, 2600);
      }).catch(function (err) {
        _this2.alert.message = err.response.data.message || 'Adjustment failed.';
        _this2.alert.type = 'error';
        _this2.alerting();
      });
    }
  }
});

/***/ }),

/***/ "wo1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_countryCodes_js__ = __webpack_require__("mbGk");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      alert: {
        status: false,
        message: '',
        type: ''
      },
      years: {
        min: null,
        max: null
      },
      durationFrom: {
        min: null,
        max: null
      },
      maxAge: null,
      disabledFinal: false,
      valid: true,
      phoneValidation: [function (v) {
        return !!v || "Phone number is required";
      }, function (v) {
        return (/^(\+\d{1,3}[- ]?)?\d{0,20}$/.test(v) || "Phone number is not valid."
        );
      }],
      inputRules: [function (v) {
        return !!v || "Input field is required";
      }],
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/\S+@\S+\.\S+/.test(v) || "E-mail must be valid"
        );
      }],
      e1: 1,
      allPersonsValid: true,
      name: '',
      beneficaryType: false,
      date: null,
      menu: false,
      modal: false,
      duration: "",
      inputParents: [{ text: "Single Parent", number: 1 }, { text: "Both Parents", number: 2 }],
      personObj: {
        date_of_birth: null,
        menu: null,
        first_name: "",
        middle_name: "",
        last_name: "",
        passport_number: "",
        gender: "",
        has_existing_medical_condition: false,
        existing_medical_condition: "",
        has_medical_insurance_in_country_of_residence: false,
        medical_insurance_in_country_of_residence: ""
      },
      policy: {
        insurance_plan_id: "",
        insurance_type: "",
        total_parents: null,
        total_children: null,
        total_persons: null,
        country_residence: "",
        country_destination: "Turkey",
        duration_from: null,
        duration_fromMenu: false,
        duration_to: null,
        duration_toMenu: false,
        email: "",
        phone: "",
        amount: "",
        persons: []
      },
      insurancePlans: [],
      selectedInsurancePlan: {},
      states: __WEBPACK_IMPORTED_MODULE_4__helpers_countryCodes_js__["a" /* countryCodesSingle */],
      statesTo: __WEBPACK_IMPORTED_MODULE_4__helpers_countryCodes_js__["b" /* countriesTo */]
    };
  },
  computed: {
    getPlanName: function getPlanName() {
      var _this = this;

      var planName = "";
      this.insurancePlans.forEach(function (plan) {
        if (plan.id === _this.policy.insurance_plan_id) {
          planName = plan.short_name;
        }
      });
      return planName;
    }
  },
  methods: {
    checkToken: function checkToken() {
      this.$auth.loggedIn() ? true : this.$router.push('/auth/login');
    },
    goBack: function goBack() {
      this.e1--;
    },
    alerting: function alerting() {
      this.alert.status = !this.alert.status;
    },
    redirect: function redirect(uuid) {
      this.$router.push({ path: "/agency/issued_policies/show/" + uuid });
    },
    savePolicy: function savePolicy() {
      var _this2 = this;

      var vm = this;
      this.disabledFinal = true;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/policies', { policy: this.policy }).then(function (res) {
        _this2.alert.message = 'Policy has been created.';
        _this2.alert.type = 'success';
        _this2.alerting();
        _this2.$root.$emit('updateBalance');
        setTimeout(function () {
          _this2.alert.status = !_this2.alert.status;
          if (_this2.allPersonsValid) {
            _this2.redirect(res.data.uuid);
          }
        }, 5000);
      }).catch(function (err) {
        _this2.disabledFinal = false;
        _this2.alert.message = err.response.data.message || 'Failed to create a policy';
        _this2.alert.type = 'error';
        _this2.alerting();
        setTimeout(function () {
          _this2.alert.status = !_this2.alert.status;
        }, 5000);
      });
    },
    validateForm: function validateForm() {
      var _this3 = this;

      this.$validator.validateAll().then(function (result) {
        if (result == true) {
          _this3.$validator.reset();
          _this3.e1++;
          return;
        }
      });
    },
    validateLastForm: function validateLastForm() {
      if (this.$refs.form.validate()) {
        this.e1++;
      }
    },
    validateNewPolicy: function validateNewPolicy() {
      if (this.$refs.newpolicy.validate()) {
        this.e1++;
      }
    },
    validateMaxAge: function validateMaxAge() {
      var _this4 = this;

      var planObj = void 0;
      var maxAgeLength = void 0;
      var planObjDuration = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this4;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      this.maxAge = planObj.pricing[planObj.pricing.length - 1].end;
      this.years.min = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(maxAge, "years").format('YYYY-MM-DD');
    },
    validateDurationTo: function validateDurationTo() {
      var _this5 = this;

      var planObj = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this5;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      var planObjArrLength = planObj.pricing[0].pricing.length;
      var planObjDuration = planObj.pricing[0].pricing[planObjArrLength - 1].duration;
      this.durationFrom.max = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_from).add(planObjDuration, "days").format('YYYY-MM-DD');;
    },
    validateInsurancePlan: function validateInsurancePlan() {
      if (this.$refs.insuranceplan.validate()) {
        this.e1++;
      }
    },
    validateTraveDetails: function validateTraveDetails() {
      var _this6 = this;

      var planObj = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this6;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });
      var planObjArrLength = planObj.pricing[0].pricing.length;
      var planObjDuration = planObj.pricing[0].pricing[planObjArrLength - 1].duration;

      if (this.$refs.traveldetails.validate() && this.allPersonsValid === true) {
        if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_to).isBefore(this.policy.duration_from) || __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_from).isAfter(this.policy.duration_to)) {
          this.alert.message = 'Duration From and To are not valid, please check your dates.';
          this.alert.type = 'error';
          this.alerting();
          setTimeout(function () {
            _this6.alert.status = !_this6.alert.status;
          }, 5000);
        } else if (this.duration > planObjDuration) {
          this.alert.message = "Duration should not be longer than " + planObjDuration + " days, please change your dates.";
          this.alert.type = 'error';
          this.alerting();
          setTimeout(function () {
            _this6.alert.status = !_this6.alert.status;
          }, 5000);
        } else if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.policy.duration_from).isBefore()) {
          this.alert.message = 'Policy starting date should not be before tomorrow.';
          this.alert.type = 'error';
          this.alerting();
          setTimeout(function () {
            _this6.alert.status = !_this6.alert.status;
          }, 5000);
        } else {
          this.e1++;
        }
      }
    },
    addToPersons: function addToPersons() {
      this.policy.persons = [];
      var vm = this;
      if (this.policy.insurance_type === "Single") {
        this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
      } else if (this.policy.insurance_type === "Family") {
        this.policy.total_persons = null;
        for (var index = 0; index < this.policy.total_parents; index++) {
          this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
        }
        for (var _index = 0; _index < this.policy.total_children; _index++) {
          this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
        }
      } else {
        this.policy.total_parents = null;
        this.policy.total_children = null;
        for (var _index2 = 0; _index2 < this.policy.total_persons; _index2++) {
          this.policy.persons.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.personObj)));
        }
      }
    },
    calcPolicyDuration: function calcPolicyDuration(start, finish) {
      var pocetak = __WEBPACK_IMPORTED_MODULE_3_moment___default()(start);
      var kraj = __WEBPACK_IMPORTED_MODULE_3_moment___default()(finish);
      var result = kraj.diff(pocetak, "days");
      return result;
    },
    getPersonYear: function getPersonYear(dob) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(dob, "years");
    },
    quoteCalculator: function quoteCalculator() {
      var _this7 = this;

      var duration = this.calcPolicyDuration(this.policy.duration_from, this.policy.duration_to);
      this.duration = duration;

      var ages = [];
      this.policy.persons.forEach(function (person) {
        ages = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ages), [_this7.getPersonYear(person.date_of_birth)]);
      });

      var planObj = void 0;
      this.insurancePlans.forEach(function (plan) {
        var vm = _this7;
        if (plan.id === vm.policy.insurance_plan_id) {
          planObj = plan;
        }
      });

      var prices = [];
      ages.map(function (personAge) {
        planObj.pricing.map(function (helperObj) {
          if (helperObj.begin <= personAge && personAge <= helperObj.end) {
            helperObj.pricing.some(function (range, index) {
              if (duration <= range.duration) {
                return prices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(prices), [parseInt(range.price)]);
              }
            });
          }
        });
      });

      this.policy.amount = prices.length > 1 ? prices.reduce(function (acc, cur) {
        return acc + cur;
      }, 0) : prices[0];
    },
    getPlanObject: function getPlanObject(id) {
      var _this8 = this;

      this.insurancePlans.forEach(function (plan) {
        if (plan.id === id) {
          _this8.selectedInsurancePlan = plan;
        }
      });
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("/insuranceplans").then(function (response) {
      response.data.insurancePlans.map(function (plan) {
        if (plan.name == "Turkey") {
          _this9.policy.insurance_plan_id = plan.id;
          _this9.insurancePlans.push(plan);
        }
      });
    });
    this.years.min = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(80, "years").format('YYYY-MM-DD');
    this.years.max = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, "years").format('YYYY-MM-DD');
    this.durationFrom.min = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(1, 'day').format('YYYY-MM-DD');
    this.durationFrom.max = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(730, 'days').format('YYYY-MM-DD');
  },

  watch: {
    'policy.insurance_plan_id': function policyInsurance_plan_id(val) {
      this.validateMaxAge();
      this.validateDurationTo();
    },
    'policy.duration_from': function policyDuration_from(val) {
      this.validateDurationTo();
    }
  }
});

/***/ }),

/***/ "x84x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_2_vue_simple_spinner___default.a
  },
  data: function data() {
    var _this = this,
        _ref;

    return _ref = {
      alert: {
        status: false,
        message: "",
        type: ""
      },
      rules: {
        passwordRules: [function (v) {
          return !!v || "Field is required";
        }],
        passwordRulesConfirm: [function (v) {
          return !!v || "Field is required";
        }, function (v) {
          return v == _this.user.password || "Password not confirmed";
        }]
      },
      user: {
        password: "",
        confirm_password: ""
      },
      defaultLogo: __WEBPACK_IMPORTED_MODULE_3__assets_placeholder_profile_photo_200x200_png___default.a,
      validAcc: true,
      visibility: true,
      visibilityConfirm: true,
      dataLoading: true,
      dialog: false,
      agencyData: [],
      color: 'primary',
      resize: "lg4",
      menu: false,
      isAgencyDeleted: false,
      showMenuButton: false,
      agencyType: "Agency",
      providedAgencies: [],
      providerAgency: null,
      agencies: [{ id: '' }],
      selectedAgency: null
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialog", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "loading", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "search", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "items", ["Account", "Agencies"]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "headers", [{
      text: "ID",
      align: "left",
      sortable: false,
      value: "name"
    }, {
      text: "Logo",
      align: "left",
      sortable: false,
      value: "name"
    }, {
      text: "Company",
      align: "left",
      sortable: false,
      value: "name"
    }, {
      text: "Email",
      align: "left",
      sortable: false,
      value: "email"
    }, {
      text: "Approved",
      align: "center",
      sortable: false,
      value: "approved"
    }, {
      text: "Disabled",
      align: "center",
      sortable: false,
      value: "approved"
    }]), _ref;
  },

  mounted: function mounted() {
    this.getData();
    this.getAgencies();
  },
  filters: {
    booleanify: function booleanify(value) {
      if (value == '0') {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    }
  },
  methods: {
    alerting: function alerting() {
      var _this2 = this;

      this.alert.status = !this.alert.status;
      setTimeout(function () {
        _this2.alert.status = !_this2.alert.status;
      }, 2500);
    },
    resizeCard: function resizeCard(value) {
      this.resize = value;
    },
    closeDialog: function closeDialog() {
      this.user = {
        password: '',
        confirm_password: ''
      };
      this.dialog = !this.dialog;
    },
    adjustBalance: function adjustBalance() {
      this.$router.push("/admin/agencies/balance/" + this.$route.params.id);
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    showAgency: function showAgency(item) {
      this.resize = "lg4";
      this.$router.push({ path: "/admin/agencies/subagency/show/" + item.id });
      this.getData();
    },
    editAgency: function editAgency(item) {
      this.$router.push({ path: "/admin/agencies/edit/" + item.id });
    },
    getData: function getData() {
      var _this3 = this;

      this.dataLoading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/users/" + this.$route.params.id).then(function (res) {
        _this3.agencyData = res.data.user;
        _this3.showMenuButton = false;
        _this3.agencyType = "Agency";
        _this3.dataLoading = false;
        _this3.isAgencyDeleted = _this3.agencyData.is_deleted == 1 ? true : false;
        _this3.color = _this3.isAgencyDeleted ? 'red' : 'primary';
        _this3.getProviderName(_this3.agencyData.provider_id);
        if (_this3.agencyData.is_provider === '1') {
          _this3.getProvided();
          _this3.resize = "lg10";
          _this3.agencyType = "Provider";
          _this3.showMenuButton = true;
          _this3.dataLoading = false;
        }
      });
    },
    getAgencies: function getAgencies() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/agencies").then(function (response) {
        _this4.agencies = response.data.users;
        _this4.dataLoading = false;
        _this4.loading = false;
        _this4.getProviderName(_this4.agencyData.provider_id);
      });
    },
    getProviderName: function getProviderName(id) {
      var _this5 = this;

      return this.agencies.forEach(function (element) {
        if (element.id == id) {
          _this5.providerAgency = element.company + ' ID ' + element.id;
        }
      });
    },
    addAgency: function addAgency(id) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/users/" + id, {
        user: {
          provider_id: this.agencyData.id
        }
      }).then(function (res) {
        _this6.getProvided();
        _this6.alert.message = "Agency has been added to this provider.";
        _this6.alert.type = "success";
        _this6.alerting();
        _this6.selectedAgency = "";
      });
    },
    removeProvidedAgency: function removeProvidedAgency(id) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put("/users/" + id, {
        user: {
          provider_id: false
        }
      }).then(function (res) {
        _this7.getProvided();
        _this7.alert.message = "Agency has been removed from this provider.";
        _this7.alert.type = "success";
        _this7.alerting();
      });
    },
    getProvided: function getProvided() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/users/" + this.$route.params.id + "/subagencies").then(function (res) {
        _this8.providedAgencies = res.data.users;
      });
    },
    checkPassword: function checkPassword() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/me/verify", {
        password: this.user.password
      }).then(function (res) {
        _this9.deleteItem();
      }).catch(function (res) {
        _this9.alert.message = "Could not delete agency. Please, check your password.";
        _this9.alert.type = "error";
        _this9.alerting();
      });
    },
    deleteItem: function deleteItem() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/users/" + this.agencyData.id).then(function (response) {
        _this10.alert.message = "Agency has been deleted";
        _this10.alert.type = "success";
        _this10.alerting();
        var vm = _this10;
        setTimeout(function () {
          vm.$router.push("/admin/agencies");
        }, 3000);
      });
    }
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xRPz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__ = __webpack_require__("8kuj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1_vue_simple_spinner___default.a
  },
  data: function data() {
    return {
      dataLoading: true,
      plan: {}

    };
  },

  mounted: function mounted() {
    this.getPlan();
  },
  methods: {
    goBack: function goBack() {
      this.$router.push("/admin/plans");
    },
    getPlan: function getPlan() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/insuranceplans/" + this.$route.params.id).then(function (res) {
        _this.dataLoading = false;
        _this.plan = res.data;
      });
    },
    post: function post() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/insuranceplans/" + this.$route.params.id, this.plan).then(function (res) {});
    }
  }
});

/***/ }),

/***/ "xdGE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png__ = __webpack_require__("959D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      max25chars: function max25chars(v) {
        return v.length <= 25 || "Input too long!";
      },
      tmp: "",
      loading: true,
      approvedCounter: 0,
      search: "",
      pagination: {},
      defaultLogo: __WEBPACK_IMPORTED_MODULE_1__assets_placeholder_profile_photo_200x200_png___default.a,
      headers: [{
        text: "ID",
        align: "left",
        sortable: false,
        value: "id"
      }, {
        text: "Logo",
        align: "left",
        sortable: false,
        value: "logo"
      }, {
        text: "Company",
        align: "left",
        sortable: false,
        value: "company"
      }, {
        text: "Email",
        align: "left",
        sortable: false,
        value: "email"
      }, {
        text: "Approved",
        align: "center",
        sortable: false,
        value: "approved"
      }, {
        text: "Disabled",
        align: "center",
        sortable: false,
        value: "is_disabled"
      }, {
        text: "Provider",
        align: "center",
        sortable: false,
        value: "is_provider"
      }],
      items: []
    };
  },

  filters: {
    booleanify: function booleanify(value) {
      if (value === "0") {
        value = "No";
      } else {
        value = "Yes";
      }
      return value;
    }
  },
  computed: {
    avatarSize: function avatarSize() {
      return "40px";
    }
  },
  methods: {
    customFilter: function customFilter(items, search, filter) {
      search = search.toString().toLowerCase();
      var a = items.filter(function (row) {
        return filter(row["id"], search);
      });
      if (!Array.isArray(a) || !a.length) {
        a = items.filter(function (row) {
          return filter(row["company"], search);
        });
      }
      return a;
    },
    disableUser: function disableUser(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put("/users/" + id, {
        user: {
          disabled: "1"
        }
      }).then(function (res) {
        _this.getAgencies();
      });
    },
    editAgency: function editAgency(item) {
      this.$router.push({ path: "/agency/agencies/edit/" + item.id });
    },
    showAgency: function showAgency(item) {
      this.$router.push({ path: "/agency/agencies/show/" + item.id });
    },
    newAgency: function newAgency() {
      this.$router.push("/agency/agencies/new");
    },
    getAgencies: function getAgencies() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("/agencies").then(function (response) {
        _this2.items = response.data.users;
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getAgencies();
  }
});

/***/ }),

/***/ "y80d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":""}},[_c('v-card',{staticClass:"elevation-1"},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("Insurance Plans")])],1),_vm._v(" "),_c('v-flex',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":"","loading":_vm.loading,"no-data-text":"Loading plans.","rows-per-page-items":_vm.rows,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.short_name))]),_vm._v(" "),_c('td',[_vm._v("\n             "+_vm._s(props.item.name)+"\n          ")]),_vm._v(" "),_c('td',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":"","color":"primary"},on:{"click":function($event){_vm.showPlan(props.item)}}},[_vm._v("\n                    show\n                    ")])],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"small":"","dark":""},on:{"click":function($event){_vm.editPlan(props.item)}}},[_vm._v("edit\n                    ")])],1)],1)],1)]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z0xp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zADa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFront_vue__ = __webpack_require__("1O+T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8212004c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFront_vue__ = __webpack_require__("r5R8");
function injectStyle (ssrContext) {
  __webpack_require__("k/0z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8212004c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminFront_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8212004c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminFront_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b15a56f81666db73d810.js